import React from 'react';
import { IconProps, SocialIconProps } from '../types/modules/IconsTypes';
import Link from 'next/link';

export const CursorIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}>
      <g id="Group" filter="url(#filter0_d_9576_29246)">
        <path
          id="arrow border"
          d="M10.9231 16.0296C11.0985 16.4505 10.9299 18.0447 10 18.4142C9.07008 18.7837 7.88197 18.4142 7.88197 18.4142L5.72605 14.1024L2 17.8284V1L13.4142 12.4142H9.16151C9.37022 12.8144 10.7003 15.4948 10.9231 16.0296Z"
          fill="white"
        />
        <path
          id="arrow"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 3.41406V15.4141L6 12.4141L8.5 17.4141C8.5 17.4141 9.17631 17.6299 9.5 17.4141C9.82369 17.1983 10.1457 16.7636 10 16.4141C9.31233 14.7636 7.5 11.4141 7.5 11.4141H11L3 3.41406Z"
          fill="black"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9576_29246"
          x="0.2"
          y="0.2"
          width="15.0141"
          height="21.1781"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.9" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9576_29246" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9576_29246"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const HistoryIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        stroke="#AEB6BA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 7.5V12l3.9 2.25m1.37-4.903h3.75m0 0v-3.75m0 3.75l-3.188-3.178a8.25 8.25 0 100 11.662"></path>
    </svg>
  );
};

export const LightbulbIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      data-testid="testIcon"
      className={props.className}
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 20 20"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
    </svg>
  );
};
export const LightbulbIconOutline: React.FC<IconProps> = (props) => {
  return (
    <svg
      data-testid="testIcon"
      className={props.className}
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.333 10.333h.937M16 4.937L16.936 4M9.999 1.937V1M4.27 4.938L3.333 4m-.667 6.333h-.937m6.395 8h3.75m2.813-9.062a4.687 4.687 0 10-6.563 4.297v2.265h3.75v-2.265a4.689 4.689 0 002.813-4.297z"></path>
    </svg>
  );
};
export const ReportBugIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className={props.className}>
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M4.75 9.216A3.466 3.466 0 018.216 5.75h3.568a3.466 3.466 0 013.466 3.466V12a5.25 5.25 0 11-10.5 0V9.216zM13.25 5c0 .084-.003.168-.01.25H6.76A3.25 3.25 0 1113.25 5z"></path>
      <path
        fill="currentColor"
        d="M17.424 16.4a.75.75 0 00.75-1.3l-.75 1.3zm-2.598-1.5l2.598 1.5.75-1.3-2.598-1.5-.75 1.3zM1.826 15.1a.75.75 0 10.75 1.3l-.75-1.3zm2.598-1.5l-2.598 1.5.75 1.3 2.598-1.5-.75-1.3zM18.174 6.9a.75.75 0 10-.75-1.3l.75 1.3zm-2.598 1.5l2.598-1.5-.75-1.3-2.598 1.5.75 1.3zM1 10.25a.75.75 0 000 1.5v-1.5zm3 1.5h.75v-1.5H4v1.5zm-3 0h3v-1.5H1v1.5zM19 11.75a.75.75 0 000-1.5v1.5zm-3-1.5h-.75v1.5H16v-1.5zm3 0h-3v1.5h3v-1.5zM2.51 5.85a.75.75 0 10-.75 1.3l.75-1.3zm.982 2.3l.65.375.75-1.3-.65-.375-.75 1.3zm-1.732-1l1.732 1 .75-1.3-1.732-1-.75 1.3zM9.25 17v.75h1.5V17h-1.5zm1.5-3.5a.75.75 0 00-1.5 0h1.5zm0 3.5v-3.5h-1.5V17h1.5z"></path>
    </svg>
  );
};

export const AddToFolderIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.355 16.25H3.488a.58.58 0 01-.578-.578V6.25h14.375a.625.625 0 01.625.625v8.82a.555.555 0 01-.555.555zM2.91 6.25V4.375a.625.625 0 01.625-.625h4.117a.617.617 0 01.438.18l2.32 2.32M8.535 11.25h3.75M10.41 9.375v3.75"></path>
    </svg>
  );
};

export const RemoveFromFolderIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16 10h11a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V13"></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.662 13H4V8a1 1 0 011-1h6.662c.217 0 .427.071.6.2L16 10l-3.738 2.8c-.173.129-.383.2-.6.2v0zM13 18.5h6"></path>
    </svg>
  );
};

export const CartIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.25 17.125C7.94036 17.125 8.5 16.5654 8.5 15.875C8.5 15.1846 7.94036 14.625 7.25 14.625C6.55964 14.625 6 15.1846 6 15.875C6 16.5654 6.55964 17.125 7.25 17.125Z"
        fill="#F5F5F5"
      />
      <path
        d="M15.375 17.125C16.0654 17.125 16.625 16.5654 16.625 15.875C16.625 15.1846 16.0654 14.625 15.375 14.625C14.6846 14.625 14.125 15.1846 14.125 15.875C14.125 16.5654 14.6846 17.125 15.375 17.125Z"
        fill="#F5F5F5"
      />
      <path
        d="M4.30469 4.625L18.3203 4.625L16.2578 11.8437C16.1842 12.1057 16.0266 12.3363 15.8093 12.5C15.5919 12.6638 15.3268 12.7516 15.0547 12.75L7.57031 12.75C7.29819 12.7516 7.03308 12.6638 6.81572 12.5C6.59836 12.3363 6.44078 12.1057 6.36719 11.8437L3.53906 1.95313C3.50169 1.82246 3.42275 1.70754 3.3142 1.62578C3.20565 1.54401 3.0734 1.49986 2.9375 1.5H1.625"
        stroke="#F5F5F5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.719 9.094L10 12.375l3.281-3.281M10 3.625v8.75M16.875 12.375v4.375a.624.624 0 01-.625.625H3.75a.625.625 0 01-.625-.625v-4.375"></path>
    </svg>
  );
};

export const ElementCountIcon: React.FC<IconProps> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 33 32">
      <rect width="32" height="32" x="0.41" fill="#1D2224" rx="4"></rect>
      <rect width="14.625" height="6.5" x="9.41" y="16.5" fill="#7F898D" rx="2"></rect>
      <rect width="11.375" height="2.167" x="11.035" y="13.25" fill="#7F898D" rx="1.083"></rect>
      <rect width="8.125" height="2.167" x="12.66" y="10" fill="#7F898D" rx="1.083"></rect>
    </svg>
  );
};

export const AssetIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={props.fill || '#AFAFB0'}
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="4.16602"
        y="10.4185"
        width="12.1875"
        height="5.41667"
        rx="2"
        fill={props.fill || '#AFAFB0'}
      />
      <rect
        x="5.51953"
        y="7.71045"
        width="9.47917"
        height="1.80556"
        rx="0.902778"
        fill={props.fill || '#AFAFB0'}
      />
      <rect
        x="6.875"
        y="5.00195"
        width="6.77083"
        height="1.80556"
        rx="0.902778"
        fill={props.fill || '#AFAFB0'}
      />
    </svg>
  );
};

export const AssetCountIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="11"
      stroke="none"
      viewBox="0 0 13 11">
      <rect width="12.188" height="5.417" x="0.167" y="5.418" rx="2"></rect>
      <rect width="9.479" height="1.806" x="1.521" y="2.707" rx="0.903"></rect>
      <rect width="6.771" height="1.806" x="2.875" rx="0.903"></rect>
    </svg>
  );
};

export const CameraIcon: React.FC<IconProps> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 33 32">
      <rect width="32" height="32" x="0.41" fill="#1D2224" rx="4"></rect>
      <path
        fill="#7F898D"
        d="M18.269 10.057c-.203-.052-.868-.06-5.138-.056-4.037.004-4.94.012-5.1.06a2.85 2.85 0 00-.449.184c-.152.08-.355.236-.508.392-.16.16-.312.368-.402.54a2.757 2.757 0 00-.2.56c-.05.24-.062.853-.062 4.261 0 3.41.012 4.022.063 4.261.03.157.12.405.199.56.09.173.242.38.402.54.153.157.356.313.508.393.141.072.352.156.47.188.183.052.933.06 5.098.06 4.314 0 4.912-.008 5.119-.064a2.81 2.81 0 00.488-.196c.14-.076.348-.232.465-.348.117-.116.277-.312.352-.432.078-.12.183-.356.238-.52l.098-.3c0-8.039-.004-8.299-.07-8.523a3.16 3.16 0 00-.215-.5 2.753 2.753 0 00-.38-.5 2.256 2.256 0 00-.492-.368 2.95 2.95 0 00-.484-.192zM25.564 11.277a1.19 1.19 0 00-.485-.076h-.004a1.58 1.58 0 00-.402.048c-.07.028-.918.516-1.887 1.088l-1.763 1.04.02 5.23c2.665 1.565 3.509 2.045 3.595 2.08.085.037.234.077.332.093.117.02.258.008.418-.036.136-.036.312-.108.39-.16a1.597 1.597 0 00.535-.624c.083-.176.083-.24.094-3.834v-.027c.008-3.177 0-3.713-.05-3.91a1.605 1.605 0 00-.168-.4 1.63 1.63 0 00-.266-.304 1.45 1.45 0 00-.36-.208z"></path>
    </svg>
  );
};

export const ResolutionIcon: React.FC<IconProps> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 33 32">
      <rect width="32" height="32" x="0.41" fill="#1D2224" rx="4"></rect>
      <rect width="20" height="13" x="6.41" y="9" fill="#7F898D" rx="2"></rect>
      <path
        stroke="#1D2224"
        strokeLinecap="round"
        d="M8.91 13.5v-1.8c0-.11.09-.2.2-.2h1.8M24.41 18v1.8a.2.2 0 01-.2.2h-1.8"></path>
    </svg>
  );
};

export const AlphaIcon: React.FC<IconProps> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 33 32">
      <rect width="32" height="32" x="0.41" fill="#1D2224" rx="4"></rect>
      <path fill="#7F898D" d="M16.935 8l5.475 4.894L15.885 17l-5.475-4.894L16.935 8z"></path>
      <path
        fill="#7F898D"
        d="M16.935 12l5.475 4.894L15.885 21l-5.475-4.894L16.935 12z"
        opacity="0.5"></path>
      <path
        fill="#7F898D"
        d="M16.935 16l5.475 4.894L15.885 25l-5.475-4.894L16.935 16z"
        opacity="0.3"></path>
    </svg>
  );
};

export const FolderIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      data-cy="folder-icon"
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8344 21.75H2.19375C2.10265 21.75 2.01243 21.7321 1.92826 21.6972C1.84409 21.6623 1.76762 21.6112 1.70319 21.5468C1.63877 21.4824 1.58767 21.4059 1.55281 21.3217C1.51794 21.2376 1.5 21.1474 1.5 21.0563V9.75M4.5 6.75V18.0563C4.5 18.1474 4.51794 18.2376 4.55281 18.3217C4.58767 18.4059 4.63877 18.4824 4.70319 18.5468C4.76762 18.6112 4.84409 18.6623 4.92826 18.6972C5.01243 18.7321 5.10265 18.75 5.19375 18.75H21.8344C22.0109 18.75 22.1802 18.6799 22.305 18.555C22.4299 18.4302 22.5 18.2609 22.5 18.0844V7.5C22.5 7.30109 22.421 7.11032 22.2803 6.96967C22.1397 6.82902 21.9489 6.75 21.75 6.75H4.5ZM4.5 6.75V4.5C4.5 4.30109 4.57902 4.11033 4.71967 3.96967C4.86032 3.82902 5.05109 3.75 5.25 3.75H10.1906C10.288 3.74966 10.3845 3.76853 10.4746 3.80553C10.5647 3.84253 10.6466 3.89694 10.7156 3.96563L13.5 6.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CategoryFolderIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      data-cy="category-folder-icon"
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        stroke="currentColor"
        d="M18.8344 21.75H2.19375C2.10265 21.75 2.01243 21.7321 1.92826 21.6972C1.84409 21.6623 1.76762 21.6112 1.70319 21.5468C1.63877 21.4824 1.58767 21.4059 1.55281 21.3217C1.51794 21.2376 1.5 21.1474 1.5 21.0563V9.75M4.5 6.75V18.0563C4.5 18.1474 4.51794 18.2376 4.55281 18.3217C4.58767 18.4059 4.63877 18.4824 4.70319 18.5468C4.76762 18.6112 4.84409 18.6623 4.92826 18.6972C5.01243 18.7321 5.10265 18.75 5.19375 18.75H21.8344C22.0109 18.75 22.1802 18.6799 22.305 18.555C22.4299 18.4302 22.5 18.2609 22.5 18.0844V7.5C22.5 7.30109 22.421 7.11032 22.2803 6.96967C22.1397 6.82902 21.9489 6.75 21.75 6.75H4.5ZM4.5 6.75V4.5C4.5 4.30109 4.57902 4.11033 4.71967 3.96967C4.86032 3.82902 5.05109 3.75 5.25 3.75H10.1906C10.288 3.74966 10.3845 3.76853 10.4746 3.80553C10.5647 3.84253 10.6466 3.89694 10.7156 3.96563L13.5 6.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PersonIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0.772321 15.5001C0.565248 15.8588 0.688196 16.3175 1.04693 16.5246C1.40567 16.7316 1.86435 16.6087 2.07143 16.2499L0.772321 15.5001ZM15.9286 16.2499C16.1356 16.6087 16.5943 16.7316 16.9531 16.5246C17.3118 16.3175 17.4348 15.8588 17.2277 15.5001L15.9286 16.2499ZM13.25 6.5C13.25 8.84721 11.3472 10.75 9 10.75V12.25C12.1756 12.25 14.75 9.67564 14.75 6.5H13.25ZM9 10.75C6.65279 10.75 4.75 8.84721 4.75 6.5H3.25C3.25 9.67564 5.82436 12.25 9 12.25V10.75ZM4.75 6.5C4.75 4.15279 6.65279 2.25 9 2.25V0.75C5.82436 0.75 3.25 3.32436 3.25 6.5H4.75ZM9 2.25C11.3472 2.25 13.25 4.15279 13.25 6.5H14.75C14.75 3.32436 12.1756 0.75 9 0.75V2.25ZM2.07143 16.2499C2.77353 15.0336 3.78345 14.0235 4.99968 13.3213L4.24962 12.0223C2.80535 12.8562 1.60606 14.0557 0.772321 15.5001L2.07143 16.2499ZM4.99968 13.3213C6.21591 12.619 7.59558 12.2493 9 12.2493V10.7493C7.33225 10.7493 5.69389 11.1883 4.24962 12.0223L4.99968 13.3213ZM9 12.2493C10.4044 12.2493 11.7841 12.619 13.0003 13.3213L13.7504 12.0223C12.3061 11.1883 10.6677 10.7493 9 10.7493V12.2493ZM13.0003 13.3213C14.2165 14.0235 15.2265 15.0336 15.9286 16.2499L17.2277 15.5001C16.3939 14.0557 15.1947 12.8562 13.7504 12.0223L13.0003 13.3213Z" />
    </svg>
  );
};

export const QuestionIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
      stroke={props.color || '#7F898D'}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"></path>
      <path
        d="M10 15.344a.781.781 0 100-1.563.781.781 0 000 1.563z"></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 11.75v-.625a2.187 2.187 0 10-2.188-2.188"></path>
    </svg>
  );
};

export const NewHelpIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9942_15636)">
        <path
          d="M11.4026 8.40196L12.0333 8.8078L12.0333 8.8078L11.4026 8.40196ZM7.58329 7.5013C7.58329 7.91552 7.91908 8.2513 8.33329 8.2513C8.74751 8.2513 9.08329 7.91552 9.08329 7.5013H7.58329ZM9.24996 11.2513C9.24996 11.6655 9.58575 12.0013 9.99996 12.0013C10.4142 12.0013 10.75 11.6655 10.75 11.2513H9.24996ZM10.75 13.3346C10.75 12.9204 10.4142 12.5846 9.99996 12.5846C9.58575 12.5846 9.24996 12.9204 9.24996 13.3346H10.75ZM9.24996 14.168C9.24996 14.5822 9.58575 14.918 9.99996 14.918C10.4142 14.918 10.75 14.5822 10.75 14.168H9.24996ZM17.5833 10.0013C17.5833 14.1895 14.1881 17.5846 9.99996 17.5846V19.0846C15.0165 19.0846 19.0833 15.0179 19.0833 10.0013H17.5833ZM9.99996 17.5846C5.8118 17.5846 2.41663 14.1895 2.41663 10.0013H0.916626C0.916626 15.0179 4.98337 19.0846 9.99996 19.0846V17.5846ZM2.41663 10.0013C2.41663 5.81314 5.8118 2.41797 9.99996 2.41797V0.917969C4.98337 0.917969 0.916626 4.98472 0.916626 10.0013H2.41663ZM9.99996 2.41797C14.1881 2.41797 17.5833 5.81314 17.5833 10.0013H19.0833C19.0833 4.98472 15.0165 0.917969 9.99996 0.917969V2.41797ZM10.9166 7.5013C10.9166 7.68491 10.8634 7.8538 10.7718 7.99612L12.0333 8.8078C12.2759 8.43069 12.4166 7.98128 12.4166 7.5013H10.9166ZM9.08329 7.5013C9.08329 6.99504 9.4937 6.58464 9.99996 6.58464V5.08464C8.66527 5.08464 7.58329 6.16661 7.58329 7.5013H9.08329ZM9.99996 6.58464C10.5062 6.58464 10.9166 6.99504 10.9166 7.5013H12.4166C12.4166 6.16661 11.3346 5.08464 9.99996 5.08464V6.58464ZM9.24996 10.8346V11.2513H10.75V10.8346H9.24996ZM10.7718 7.99612C10.6708 8.15312 10.5432 8.31734 10.3889 8.50901C10.2426 8.69093 10.0661 8.90487 9.90802 9.12214C9.59715 9.54939 9.24996 10.1274 9.24996 10.8346H10.75C10.75 10.6214 10.855 10.3701 11.1209 10.0047C11.2512 9.82557 11.3943 9.65231 11.5576 9.44936C11.7131 9.25615 11.8852 9.03784 12.0333 8.8078L10.7718 7.99612ZM9.24996 13.3346V14.168H10.75V13.3346H9.24996Z"
          fill="#F5F5F5"
        />
      </g>
      <defs>
        <clipPath id="clip0_9942_15636">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ReelIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.875 3.75H3.125a.625.625 0 00-.625.625v11.25c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625V4.375a.625.625 0 00-.625-.625z"></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M10 3.75v12.5M2.5 6.25h15M2.5 13.75h15M6.25 3.75v2.5M13.75 3.75v2.5M6.25 13.75v2.5M13.75 13.75v2.5"></path>
    </svg>
  );
};

export const TwoDElementsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21">
      <path
        fill="#24C1FF"
        fillOpacity="0.2"
        stroke="#24C1FF"
        strokeWidth="1.5"
        d="M4.167 8.59C-.145 13.402 2.77 17.383 6.23 19.06c.217.106.446-.356.284-.535-1.623-1.787-1.968-5.01 3.507-8.916.143-.103.378.022.397.197.1.903.647 2.572 1.8 3.636.98.902 2.889 3.043.499 5.362-.167.163.012.49.224.392 6.63-3.073 4.725-9.344 2.645-12.357-.08-.117-.255-.109-.337.006-.37.52-1.092 1.376-1.593 1.862-.121.118-.306.021-.306-.148.004-3.284-2.94-5.333-5.017-6.839-.147-.106-.36.026-.346.207.156 2.182-1.568 4.151-3.82 6.663z"></path>
    </svg>
  );
};

export const TwoDElementsIconOutlined: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21">
      <path
        fill="#fff"
        fillOpacity="0.2"
        stroke="#fff"
        strokeWidth="1.5"
        d="M4.167 8.59C-.145 13.402 2.77 17.383 6.23 19.06c.217.106.446-.356.284-.535-1.623-1.787-1.968-5.01 3.507-8.916.143-.103.378.022.397.197.1.903.647 2.572 1.8 3.636.98.902 2.889 3.043.499 5.362-.167.163.012.49.224.392 6.63-3.073 4.725-9.344 2.645-12.357-.08-.117-.255-.109-.337.006-.37.52-1.092 1.376-1.593 1.862-.121.118-.306.021-.306-.148.004-3.284-2.94-5.333-5.017-6.839-.147-.106-.36.026-.346.207.156 2.182-1.568 4.151-3.82 6.663z"></path>
    </svg>
  );
};

export const TwoDElementsIconOutlinedLarge: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#fff"
        fillOpacity="0.2"
        stroke="#F5F5F5"
        strokeWidth="1.5"
        d="M6.668 12.145c-7.406 8.263-1.49 14.996 4.529 17.282.225.086.399-.333.208-.48-3.35-2.596-5.182-8.282 4.862-15.338.144-.101.37.022.38.197.065 1.352.928 4.28 2.903 6.101 1.654 1.525 4.972 5.263.081 9.213-.181.146-.015.463.201.375 11.76-4.81 8.458-15.414 5.002-20.3-.081-.116-.253-.106-.332.01-.595.872-1.996 2.533-2.84 3.303-.124.114-.31.014-.305-.155.167-5.542-4.89-8.919-8.276-11.383-.146-.106-.354.026-.332.206.441 3.615-2.373 6.832-6.081 10.97z"></path>
    </svg>
  );
};

export const TwoDElementsIconFilled: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" fill="none" viewBox="0 0 27 31">
      <path
        fill="#00A1E0"
        stroke="#00A1E0"
        strokeWidth="1.5"
        d="M4.668 12.145c-7.406 8.263-1.49 14.996 4.529 17.282.225.086.399-.333.208-.48-3.35-2.596-5.182-8.282 4.863-15.338.143-.101.37.022.378.197.066 1.352.93 4.28 2.904 6.101 1.654 1.525 4.972 5.263.081 9.213-.181.146-.015.463.201.375 11.76-4.81 8.458-15.414 5.002-20.3-.081-.116-.253-.106-.332.01-.595.872-1.996 2.533-2.84 3.303-.124.114-.31.014-.305-.155.167-5.542-4.89-8.919-8.276-11.383-.146-.106-.354.026-.332.206.441 3.615-2.373 6.832-6.081 10.97z"></path>
    </svg>
  );
};

export function TwoDElementsIconFilledFilter(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 27 31">
      <path
        fill="#00A1E0"
        stroke="#00A1E0"
        strokeWidth="1.5"
        d="M4.668 12.145c-7.406 8.263-1.49 14.996 4.529 17.282.225.086.399-.333.208-.48-3.35-2.596-5.182-8.282 4.863-15.338.143-.101.37.022.378.197.066 1.352.93 4.28 2.904 6.101 1.654 1.525 4.972 5.263.081 9.213-.181.146-.015.463.201.375 11.76-4.81 8.458-15.414 5.002-20.3-.081-.116-.253-.106-.332.01-.595.872-1.996 2.533-2.84 3.303-.124.114-.31.014-.305-.155.167-5.542-4.89-8.919-8.276-11.383-.146-.106-.354.026-.332.206.441 3.615-2.373 6.832-6.081 10.97z"></path>
    </svg>
  );
}

export const TwoDElementsIconFilledLarge: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#24C1FF"
        stroke="#24C1FF"
        strokeWidth="1.5"
        d="M6.668 12.145c-7.406 8.263-1.49 14.996 4.529 17.282.225.086.399-.333.208-.48-3.35-2.596-5.182-8.282 4.862-15.338.144-.101.37.022.38.197.065 1.352.928 4.28 2.903 6.101 1.654 1.525 4.972 5.263.081 9.213-.181.146-.015.463.201.375 11.76-4.81 8.458-15.414 5.002-20.3-.081-.116-.253-.106-.332.01-.595.872-1.996 2.533-2.84 3.303-.124.114-.31.014-.305-.155.167-5.542-4.89-8.919-8.276-11.383-.146-.106-.354.026-.332.206.441 3.615-2.373 6.832-6.081 10.97z"></path>
    </svg>
  );
};

export const ThreeDElementsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#24C1FF"
        fillOpacity="0.2"
        stroke="#24C1FF"
        strokeWidth="1.5"
        d="M9.375 1.227a1.25 1.25 0 011.25 0l6.66 3.845c.387.223.625.636.625 1.083v7.69c0 .447-.238.86-.625 1.083l-6.66 3.845a1.25 1.25 0 01-1.25 0l-6.66-3.845a1.25 1.25 0 01-.625-1.083v-7.69c0-.447.238-.86.625-1.083l6.66-3.845z"></path>
      <path stroke="#24C1FF" strokeWidth="1.5" d="M2.5 5.834l7.5 3.75 7.5-3.75"></path>
      <path
        fill="#24C1FF"
        fillRule="evenodd"
        d="M7.656 11.641l-1.201.746-.583-1.174 1.2-.746.584 1.174zm5.89.746l-1.202-.746.583-1.174 1.202.746-.584 1.174zm2.402 1.493l-1.202-.746.584-1.175 1.201.747-.583 1.174zm-10.694-.746l-1.202.746-.583-1.174 1.201-.747.584 1.175z"
        clipRule="evenodd"></path>
      <path stroke="#24C1FF" strokeWidth="1.5" d="M10 9.584v9.583"></path>
      <path
        fill="#24C1FF"
        fillRule="evenodd"
        d="M9.375 4.548v-1.32h1.25v1.32h-1.25zm0 2.639v-1.32h1.25v1.32h-1.25z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const ThreeDElementsIconOutlined: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#fff"
        fillOpacity="0.2"
        stroke="#fff"
        strokeWidth="1.5"
        d="M9.375 1.227a1.25 1.25 0 011.25 0l6.66 3.845c.387.223.625.636.625 1.083v7.69c0 .447-.238.86-.625 1.083l-6.66 3.845a1.25 1.25 0 01-1.25 0l-6.66-3.845a1.25 1.25 0 01-.625-1.083v-7.69c0-.447.238-.86.625-1.083l6.66-3.845z"></path>
      <path stroke="#fff" strokeWidth="1.5" d="M2.5 5.834l7.5 3.75 7.5-3.75"></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.656 11.641l-1.201.746-.583-1.174 1.2-.746.584 1.174zm5.89.746l-1.202-.746.583-1.174 1.202.746-.584 1.174zm2.402 1.493l-1.202-.746.584-1.175 1.201.747-.583 1.174zm-10.694-.746l-1.202.746-.583-1.174 1.201-.747.584 1.175z"
        clipRule="evenodd"></path>
      <path stroke="#fff" strokeWidth="1.5" d="M10 9.584v9.583"></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9.375 4.548v-1.32h1.25v1.32h-1.25zm0 2.639v-1.32h1.25v1.32h-1.25z"
        clipRule="evenodd"></path>
    </svg>
  );
};
export const ThreeDElementsIconOutlinedLarge: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#fff"
        fillOpacity="0.2"
        stroke="#F5F5F5"
        strokeWidth="1.5"
        d="M15.375 1.227a1.25 1.25 0 011.25 0l11.856 6.845c.387.223.625.636.625 1.083v13.69c0 .447-.238.86-.625 1.083l-11.856 6.845a1.25 1.25 0 01-1.25 0L3.519 23.928a1.25 1.25 0 01-.625-1.083V9.155c0-.447.238-.86.625-1.083l11.856-6.845z"></path>
      <path stroke="#F5F5F5" strokeWidth="1.5" d="M3 8.334l13 7 13-7"></path>
      <path
        fill="#F5F5F5"
        fillRule="evenodd"
        d="M12.249 18.627l-1.922 1.194-.934-1.879 1.922-1.194.934 1.879zm9.422 1.194l-1.922-1.194.933-1.879 1.923 1.194-.934 1.879zm3.844 2.388l-1.922-1.194.934-1.879 1.922 1.194-.934 1.88zm-17.11-1.194L6.482 22.21 5.55 20.33l1.922-1.194.934 1.88z"
        clipRule="evenodd"></path>
      <path stroke="#F5F5F5" strokeWidth="1.5" d="M16 15.334v15.333"></path>
      <path
        fill="#F5F5F5"
        fillRule="evenodd"
        d="M15 7.277V5.166h2v2.111h-2zm0 4.222V9.39h2v2.11h-2z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const ThreeDElementsIconFilled: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 32 32">
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M17 .577a2 2 0 00-2 0L3.146 7.422c-.062.035-.12.073-.177.115a5671.843 5671.843 0 0011.755 6.267l1.277.678L29.03 7.533a1.994 1.994 0 00-.172-.111L17.001.577zm12.827 8.23l-13.076 6.974v15.763c.085-.035.169-.075.25-.122l11.856-6.846a2 2 0 001-1.732V9.155c0-.117-.01-.233-.03-.347zM15.251 31.544V15.782l-1.232-.654c-1.01-.537-2.409-1.28-3.967-2.11a3131.73 3131.73 0 01-7.878-4.205 2 2 0 00-.03.34v13.691a2 2 0 001 1.732l11.857 6.846c.081.047.165.087.25.122zm-.25-26.377v2.111h2v-2.11h-2zm0 4.222v2.112h2V9.389h-2zm-4.673 10.43l1.923-1.195-.934-1.879-1.922 1.194.933 1.88zm11.345 0l-1.923-1.195.934-1.879 1.922 1.194-.933 1.88zm1.922 1.193l1.922 1.194.934-1.878-1.923-1.194-.933 1.878zm-15.189 0l-1.922 1.194-.934-1.878 1.923-1.194.933 1.878z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export function ThreeDElementsIconFilledFilter(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 32 32">
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M17 .577a2 2 0 00-2 0L3.146 7.422c-.062.035-.12.073-.177.115a5671.843 5671.843 0 0011.755 6.267l1.277.678L29.03 7.533a1.994 1.994 0 00-.172-.111L17.001.577zm12.827 8.23l-13.076 6.974v15.763c.085-.035.169-.075.25-.122l11.856-6.846a2 2 0 001-1.732V9.155c0-.117-.01-.233-.03-.347zM15.251 31.544V15.782l-1.232-.654c-1.01-.537-2.409-1.28-3.967-2.11a3131.73 3131.73 0 01-7.878-4.205 2 2 0 00-.03.34v13.691a2 2 0 001 1.732l11.857 6.846c.081.047.165.087.25.122zm-.25-26.377v2.111h2v-2.11h-2zm0 4.222v2.112h2V9.389h-2zm-4.673 10.43l1.923-1.195-.934-1.879-1.922 1.194.933 1.88zm11.345 0l-1.923-1.195.934-1.879 1.922 1.194-.933 1.88zm1.922 1.193l1.922 1.194.934-1.878-1.923-1.194-.933 1.878zm-15.189 0l-1.922 1.194-.934-1.878 1.923-1.194.933 1.878z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export const ThreeDElementsIconFilledLarge: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#24C1FF"
        fillRule="evenodd"
        d="M17 .577a2 2 0 00-2 0L3.146 7.422c-.062.035-.12.073-.177.115a5671.843 5671.843 0 0011.755 6.267l1.277.678L29.03 7.533a1.994 1.994 0 00-.172-.111L17.001.577zm12.827 8.23l-13.076 6.974v15.763c.085-.035.169-.075.25-.122l11.856-6.846a2 2 0 001-1.732V9.155c0-.117-.01-.233-.03-.347zM15.251 31.544V15.782l-1.232-.654c-1.01-.537-2.409-1.28-3.967-2.11a3131.73 3131.73 0 01-7.878-4.205 2 2 0 00-.03.34v13.691a2 2 0 001 1.732l11.857 6.846c.081.047.165.087.25.122zm-.25-26.377v2.111h2v-2.11h-2zm0 4.222v2.112h2V9.389h-2zm-4.673 10.43l1.923-1.195-.934-1.879-1.922 1.194.933 1.88zm11.345 0l-1.923-1.195.934-1.879 1.922 1.194-.933 1.88zm1.922 1.193l1.922 1.194.934-1.878-1.923-1.194-.933 1.878zm-15.189 0l-1.922 1.194-.934-1.878 1.923-1.194.933 1.878z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const VideoIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <rect
        width="12.25"
        height="9.333"
        x="1.584"
        y="9.084"
        fill="#24C1FF"
        fillOpacity="0.2"
        stroke="#24C1FF"
        strokeWidth="1.5"
        rx="1.25"></rect>
      <path
        stroke="#24C1FF"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M10.833 15.834H4.166"></path>
      <path
        fill="#24C1FF"
        fillOpacity="0.2"
        stroke="#24C1FF"
        strokeWidth="1.5"
        d="M14.084 15.399v-3.296l3.96-2.263a.25.25 0 01.373.217v7.387a.25.25 0 01-.374.217L14.084 15.4zM13.417 4.167a2.583 2.583 0 11-5.167 0 2.583 2.583 0 015.167 0zM5.917 4.583a2.167 2.167 0 11-4.333 0 2.167 2.167 0 014.333 0z"></path>
    </svg>
  );
};

export const VideoIconOutlined: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <rect
        width="12.25"
        height="9.333"
        x="1.584"
        y="9.084"
        fill="#fff"
        fillOpacity="0.2"
        stroke="#fff"
        strokeWidth="1.5"
        rx="1.25"></rect>
      <path stroke="#fff" strokeLinecap="round" strokeWidth="1.5" d="M10.833 15.834H4.166"></path>
      <path
        fill="#fff"
        fillOpacity="0.2"
        stroke="#fff"
        strokeWidth="1.5"
        d="M14.084 15.399v-3.296l3.96-2.263a.25.25 0 01.373.217v7.387a.25.25 0 01-.374.217L14.084 15.4zM13.417 4.167a2.583 2.583 0 11-5.167 0 2.583 2.583 0 015.167 0zM5.917 4.583a2.167 2.167 0 11-4.333 0 2.167 2.167 0 014.333 0z"></path>
    </svg>
  );
};
export const VideoIconOutlinedLarge: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <rect
        width="20.5"
        height="15.833"
        x="2.084"
        y="14.082"
        fill="#fff"
        fillOpacity="0.2"
        stroke="#F5F5F5"
        strokeWidth="1.5"
        rx="1.25"></rect>
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M17.333 25.332H6.666"></path>
      <path
        fill="#fff"
        fillOpacity="0.2"
        stroke="#F5F5F5"
        strokeWidth="1.5"
        d="M23.084 24.897V19.1l7.46-4.263a.25.25 0 01.373.217v13.887a.25.25 0 01-.374.217l-7.459-4.262zM21.917 6.665a4.583 4.583 0 11-9.167 0 4.583 4.583 0 019.167 0zM9.917 7.335a3.917 3.917 0 11-7.833 0 3.917 3.917 0 017.833 0z"></path>
    </svg>
  );
};

export const VideoIconFilled: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 32 32">
      <path
        fill="#00A1E0"
        d="M22.667 6.665a5.333 5.333 0 11-10.666 0 5.333 5.333 0 0110.666 0z"></path>
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M3.334 13.332a2 2 0 00-2 2v13.333a2 2 0 002 2h18a2 2 0 002-2v-2.761l6.837 3.906a1 1 0 001.496-.868V15.055a1 1 0 00-1.496-.868l-6.837 3.907v-2.762a2 2 0 00-2-2h-18zm3.333 11.25a.75.75 0 000 1.5h10.667a.75.75 0 000-1.5H6.667z"
        clipRule="evenodd"></path>
      <path fill="#00A1E0" d="M6 12.001a4.667 4.667 0 100-9.333 4.667 4.667 0 000 9.333z"></path>
    </svg>
  );
};

export function VideoIconFilledFilter(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 32 32">
      <path
        fill="#00A1E0"
        d="M22.667 6.665a5.333 5.333 0 11-10.666 0 5.333 5.333 0 0110.666 0z"></path>
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M3.334 13.332a2 2 0 00-2 2v13.333a2 2 0 002 2h18a2 2 0 002-2v-2.761l6.837 3.906a1 1 0 001.496-.868V15.055a1 1 0 00-1.496-.868l-6.837 3.907v-2.762a2 2 0 00-2-2h-18zm3.333 11.25a.75.75 0 000 1.5h10.667a.75.75 0 000-1.5H6.667z"
        clipRule="evenodd"></path>
      <path fill="#00A1E0" d="M6 12.001a4.667 4.667 0 100-9.333 4.667 4.667 0 000 9.333z"></path>
    </svg>
  );
}
export const VideoIconFilledLarge: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#24C1FF"
        d="M22.667 6.665a5.333 5.333 0 11-10.666 0 5.333 5.333 0 0110.666 0z"></path>
      <path
        fill="#24C1FF"
        fillRule="evenodd"
        d="M3.334 13.332a2 2 0 00-2 2v13.333a2 2 0 002 2h18a2 2 0 002-2v-2.761l6.837 3.906a1 1 0 001.496-.868V15.055a1 1 0 00-1.496-.868l-6.837 3.907v-2.762a2 2 0 00-2-2h-18zm3.333 11.25a.75.75 0 000 1.5h10.667a.75.75 0 000-1.5H6.667z"
        clipRule="evenodd"></path>
      <path fill="#24C1FF" d="M6 12.001a4.667 4.667 0 100-9.333 4.667 4.667 0 000 9.333z"></path>
    </svg>
  );
};

export const NewFolderIcon: React.FC<IconProps> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8344 21.75H2.19375C2.10265 21.75 2.01243 21.7321 1.92826 21.6972C1.84409 21.6623 1.76762 21.6112 1.70319 21.5468C1.63877 21.4824 1.58767 21.4059 1.55281 21.3217C1.51794 21.2376 1.5 21.1474 1.5 21.0563V9.75M4.5 6.75V18.0563C4.5 18.1474 4.51794 18.2376 4.55281 18.3217C4.58767 18.4059 4.63877 18.4824 4.70319 18.5468C4.76762 18.6112 4.84409 18.6623 4.92826 18.6972C5.01243 18.7321 5.10265 18.75 5.19375 18.75H21.8344C22.0109 18.75 22.1802 18.6799 22.305 18.555C22.4299 18.4302 22.5 18.2609 22.5 18.0844V7.5C22.5 7.30109 22.421 7.11032 22.2803 6.96967C22.1397 6.82902 21.9489 6.75 21.75 6.75H4.5ZM4.5 6.75V4.5C4.5 4.30109 4.57902 4.11033 4.71967 3.96967C4.86032 3.82902 5.05109 3.75 5.25 3.75H10.1906C10.288 3.74966 10.3845 3.76853 10.4746 3.80553C10.5647 3.84253 10.6466 3.89694 10.7156 3.96563L13.5 6.75"
        stroke="#24C1FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LikeIcon: React.FC<IconProps> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 8H4C2.89543 8 2 8.89543 2 10V19C2 20.1046 2.89543 21 4 21H6C7.10457 21 8 20.1046 8 19V10C8 8.89543 7.10457 8 6 8Z"
        stroke="#F5F5F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8769 21H12.2111C11.4214 21 10.6494 20.7662 9.9923 20.3282L8.4453 19.2969C8.1671 19.1114 8 18.7992 8 18.4648V10.2656C8 10.0915 8.04541 9.92052 8.13176 9.76943L12 3H13.3287C15.3254 3 16.5164 5.22536 15.4088 6.88675L14 9H19.4384C20.7396 9 21.6943 10.2228 21.3787 11.4851L19.7575 17.9701C19.3123 19.7508 17.7124 21 15.8769 21Z"
        stroke="#F5F5F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NewIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 12.5L10 1V9.5H15L6 21V12.5H1Z"
        stroke="#F5F5F5"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NavDivider: React.FC<IconProps> = (props) => {
  return (
    <svg width="2" height="24" viewBox="0 0 2 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.2" d="M1 0V24" stroke="white" strokeWidth="1.5" />
    </svg>
  );
};

export const SearchIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      // width="20"
      // height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.0625 14.625C11.6869 14.625 14.625 11.6869 14.625 8.0625C14.625 4.43813 11.6869 1.5 8.0625 1.5C4.43813 1.5 1.5 4.43813 1.5 8.0625C1.5 11.6869 4.43813 14.625 8.0625 14.625Z"
        // stroke="#F5F5F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7031 12.7031L16.5 16.5"
        // stroke="#F5F5F5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShareIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      cy-test-id="share-icon"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        // stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13.75 11.875l3.75-3.75m0 0l-3.75-3.75m3.75 3.75h-4.375a7.508 7.508 0 00-7.266 5.625M15 16.875H3.125a.625.625 0 01-.625-.625V6.875"></path>
    </svg>
  );
};
export const CopyLinkIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      cy-test-id="share-icon"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9.555 5.579l1.547-1.547a3.445 3.445 0 014.867 4.867l-2.211 2.203a3.43 3.43 0 01-4.86 0"></path>
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.446 14.422L8.899 15.97a3.445 3.445 0 01-4.867-4.867l2.21-2.203a3.43 3.43 0 014.86 0"></path>
    </svg>
  );
};

export const VarietyPackIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      fill="none"
      viewBox="0 0 15 15">
      <path
        fill="#252B2D"
        stroke="#252B2D"
        fillRule="evenodd"
        d="M4 1.5V4H1.5A1.5 1.5 0 000 5.5v8A1.5 1.5 0 001.5 15h8a1.5 1.5 0 001.5-1.5V11h2.5A1.5 1.5 0 0015 9.5v-8A1.5 1.5 0 0013.5 0h-8A1.5 1.5 0 004 1.5zM5.5 1a.5.5 0 00-.5.5V4h4.5A1.5 1.5 0 0111 5.5V10h2.5a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-8zm0 10A1.5 1.5 0 014 9.5V5H1.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5V11H5.5z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const SmallCartIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M14.785 14.375H5.863L3.683 2.391a.625.625 0 00-.609-.516H1.66m13.125 12.5a1.562 1.562 0 100 3.125 1.562 1.562 0 000-3.125zM5.293 11.25h9.813a1.242 1.242 0 001.226-1.023L17.285 5H4.16m4.063 10.938a1.563 1.563 0 11-3.125 0 1.563 1.563 0 013.125 0z"></path>
    </svg>
  );
};

export const FacebookIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24">
      <path
        fill="#4D5457"
        d="M22.16 12a9.779 9.779 0 01-8.579 9.684.384.384 0 01-.421-.375v-7.06h2.25a.75.75 0 00.75-.796.769.769 0 00-.778-.703H13.16V10.5a1.5 1.5 0 011.5-1.5h1.5a.75.75 0 00.75-.797.769.769 0 00-.779-.703H14.66a3 3 0 00-3 3v2.25H9.41a.751.751 0 00-.75.797.769.769 0 00.778.703h2.222v7.06a.376.376 0 01-.413.374c-4.95-.6-8.775-4.903-8.578-10.05a9.75 9.75 0 0119.49.366z"></path>
    </svg>
  );
};

export const TwitterIcon: React.FC<IconProps> = (props) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.444 7.284l-2.832 2.822C20.05 16.66 14.52 21.75 7.91 21.75c-1.36 0-2.484-.215-3.337-.637-.685-.347-.966-.713-1.04-.825a.75.75 0 01.365-1.116c.019-.01 2.231-.853 3.665-2.475a10.183 10.183 0 01-2.315-2.287c-1.285-1.744-2.644-4.772-1.828-9.291a.76.76 0 011.275-.403c.028.037 3.15 3.112 6.965 4.106V8.25a4.528 4.528 0 014.556-4.5A4.518 4.518 0 0120.06 6h2.85a.75.75 0 01.694.46.788.788 0 01-.16.824z"
        fill="#4D5457"></path>
    </svg>
  );
};
export const LinkedinIcon: React.FC<IconProps> = (props) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.285 2.625H4.535a1.5 1.5 0 00-1.5 1.5v15.75a1.5 1.5 0 001.5 1.5h15.75a1.5 1.5 0 001.5-1.5V4.125a1.5 1.5 0 00-1.5-1.5zM9.41 16.5a.75.75 0 11-1.5 0v-6a.75.75 0 111.5 0v6zm-.75-7.875a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm9 7.875a.75.75 0 01-1.5 0v-3.375a1.875 1.875 0 00-3.75 0V16.5a.75.75 0 01-1.5 0v-6a.75.75 0 011.481-.169 3.375 3.375 0 015.27 2.794V16.5z"
        fill="#4D5457"></path>
    </svg>
  );
};

// export const LinkedinIcon: React.FC<IconProps> = (props) => {
//   return (
//       <svg
//         fill="none"
//         height="24"
//         viewBox="0 0 25 24"
//         width="25"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M20.285 2.625H4.535a1.5 1.5 0 00-1.5 1.5v15.75a1.5 1.5 0 001.5 1.5h15.75a1.5 1.5 0 001.5-1.5V4.125a1.5 1.5 0 00-1.5-1.5zM9.41 16.5a.75.75 0 11-1.5 0v-6a.75.75 0 111.5 0v6zm-.75-7.875a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm9 7.875a.75.75 0 01-1.5 0v-3.375a1.875 1.875 0 00-3.75 0V16.5a.75.75 0 01-1.5 0v-6a.75.75 0 011.481-.169 3.375 3.375 0 015.27 2.794V16.5z"
//           fill="#4D5457"
//         ></path>
//       </svg>
//   );
// };

export const SocialIcon: React.FC<SocialIconProps> = (props) => {
  const icons = {
    facebook: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        fill="none"
        viewBox="0 0 25 24">
        <path
          fill="#4D5457"
          d="M22.16 12a9.779 9.779 0 01-8.579 9.684.384.384 0 01-.421-.375v-7.06h2.25a.75.75 0 00.75-.796.769.769 0 00-.778-.703H13.16V10.5a1.5 1.5 0 011.5-1.5h1.5a.75.75 0 00.75-.797.769.769 0 00-.779-.703H14.66a3 3 0 00-3 3v2.25H9.41a.751.751 0 00-.75.797.769.769 0 00.778.703h2.222v7.06a.376.376 0 01-.413.374c-4.95-.6-8.775-4.903-8.578-10.05a9.75 9.75 0 0119.49.366z"></path>
      </svg>
    ),
    twitter: (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.444 7.284l-2.832 2.822C20.05 16.66 14.52 21.75 7.91 21.75c-1.36 0-2.484-.215-3.337-.637-.685-.347-.966-.713-1.04-.825a.75.75 0 01.365-1.116c.019-.01 2.231-.853 3.665-2.475a10.183 10.183 0 01-2.315-2.287c-1.285-1.744-2.644-4.772-1.828-9.291a.76.76 0 011.275-.403c.028.037 3.15 3.112 6.965 4.106V8.25a4.528 4.528 0 014.556-4.5A4.518 4.518 0 0120.06 6h2.85a.75.75 0 01.694.46.788.788 0 01-.16.824z"
          fill="#4D5457"></path>
      </svg>
    ),
    youtube: (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.375 6.544a2.202 2.202 0 00-1.359-1.528C17.81 3.78 12.691 3.788 12.41 3.788c-.281 0-5.4-.01-8.606 1.228a2.203 2.203 0 00-1.36 1.528c-.243.928-.534 2.635-.534 5.457s.29 4.528.534 5.456a2.203 2.203 0 001.36 1.528c3.075 1.19 7.893 1.228 8.54 1.228h.132c.646 0 5.465-.037 8.54-1.228a2.203 2.203 0 001.36-1.528c.243-.928.534-2.635.534-5.456 0-2.822-.29-4.529-.535-5.457zm-6.759 5.766l-4.5 3a.338.338 0 01-.206.066.42.42 0 01-.178-.047.366.366 0 01-.197-.328V9a.365.365 0 01.197-.329.375.375 0 01.384.02l4.5 3a.366.366 0 010 .618z"
          fill="#4D5457"></path>
      </svg>
    ),
    instagram: (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M12.41 15a3 3 0 100-6 3 3 0 000 6z" fill="#4D5457"></path>
        <path
          d="M16.535 2.625h-8.25a5.25 5.25 0 00-5.25 5.25v8.25a5.25 5.25 0 005.25 5.25h8.25a5.25 5.25 0 005.25-5.25v-8.25a5.25 5.25 0 00-5.25-5.25zM12.41 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm4.875-8.25a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25z"
          fill="#4D5457"></path>
      </svg>
    ),
    linkedin: (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.285 2.625H4.535a1.5 1.5 0 00-1.5 1.5v15.75a1.5 1.5 0 001.5 1.5h15.75a1.5 1.5 0 001.5-1.5V4.125a1.5 1.5 0 00-1.5-1.5zM9.41 16.5a.75.75 0 11-1.5 0v-6a.75.75 0 111.5 0v6zm-.75-7.875a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25zm9 7.875a.75.75 0 01-1.5 0v-3.375a1.875 1.875 0 00-3.75 0V16.5a.75.75 0 01-1.5 0v-6a.75.75 0 011.481-.169 3.375 3.375 0 015.27 2.794V16.5z"
          fill="#4D5457"></path>
      </svg>
    ),
    tiktok: (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 25 24"
        width="25"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.16 7.875v3.75a.75.75 0 01-.75.75 9.675 9.675 0 01-4.5-1.097v3.347A7.126 7.126 0 118.53 7.612a.75.75 0 01.881.741v3.9a.741.741 0 01-.431.675 1.876 1.876 0 102.681 1.697v-12a.75.75 0 01.75-.75h3.75a.75.75 0 01.75.75 4.5 4.5 0 004.5 4.5.75.75 0 01.75.75z"
          fill="#4D5457"></path>
      </svg>
    )
  };

  const icon = icons[props.site];
  return (
    <Link href={props.link} target="_blank">
      {icon}
    </Link>
  );
};

export const LeftArrowIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="20" fill="none" viewBox="0 0 34 20">
      <g stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="M33 10H1M9.616 1L1 10l8.616 9"></path>
      </g>
    </svg>
  );
};

export const RightArrowIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="20" fill="none" viewBox="0 0 34 20">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 10h32M24.384 19L33 10l-8.616-9"></path>
    </svg>
  );
};

// Simple Arrows for collections pages
export const LeftArrowIconCollection: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 34 20"
      transform="scale(-1 1)">
      <g stroke="#F5F5F5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="M1 1L11 11L1 21"></path>
      </g>
    </svg>
  );
};
export const CustomLeftArrowIconCollection: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 34 20"
      transform="scale(-1 1)">
      <g
        // stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2">
        <path d="M1 1L11 11L1 21"></path>
      </g>
    </svg>
  );
};

export const RightArrowIconCollection: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 34 20">
      <path
        stroke="#f5f5f5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 1L11 11L1 21"></path>
    </svg>
  );
};

export const CustomRightArrowIconCollection: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 34 20">
      <path
        // stroke="#f5f5f5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 1L11 11L1 21"></path>
    </svg>
  );
};

export const PlayIcon: React.FC<IconProps & {circleFill?: string, iconFill?: string, circleOpacity?: string}> = (props) => {
  return (
    <svg
      {...props}
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle opacity={props.circleOpacity || "0.8"} cx="80" cy="80" r="50" fill={props.circleFill || "#00A1E0"} />
      <path
        d="M70.7148 91.4642C70.7225 91.9107 70.8524 92.3465 71.0905 92.7243C71.3285 93.1021 71.6655 93.4074 72.0648 93.6071C72.4636 93.8324 72.9139 93.9508 73.372 93.9508C73.83 93.9508 74.2803 93.8324 74.6791 93.6071L93.2148 82.1428C93.6181 81.9485 93.9584 81.6443 94.1966 81.2653C94.4347 80.8862 94.5611 80.4476 94.5611 79.9999C94.5611 79.5523 94.4347 79.1137 94.1966 78.7346C93.9584 78.3556 93.6181 78.0514 93.2148 77.8571L74.6791 66.4785C74.2803 66.2532 73.83 66.1348 73.372 66.1348C72.9139 66.1348 72.4636 66.2532 72.0648 66.4785C71.6655 66.6782 71.3285 66.9835 71.0905 67.3613C70.8524 67.7391 70.7225 68.1749 70.7148 68.6214V91.4642Z"
        fill={props.iconFill || 'white'}
      />
    </svg>
  );
};
export const PlayIconBlack: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25">
      <circle cx="12.539" cy="12.143" r="12" fill="#24C1FF" opacity="0.8"></circle>
      <g clipPath="url(#clip0_5462_115692)">
        <path
          fill="#171D1F"
          d="M10.313 14.893a.586.586 0 00.323.515.638.638 0 00.628 0l4.449-2.752a.571.571 0 000-1.028l-4.45-2.731a.638.638 0 00-.627 0 .587.587 0 00-.323.514v5.482z"></path>
      </g>
      <defs>
        <clipPath id="clip0_5462_115692">
          <path fill="#fff" d="M0 0H7.2V7.2H0z" transform="translate(9.54 8.543)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlayIconActive: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="160"
      fill="none"
      viewBox="0 0 160 160">
      <circle cx="80" cy="80" r="80" fill="#00A1E0" opacity="0.1"></circle>
      <circle cx="80" cy="80" r="65" fill="#00A1E0" opacity="0.3"></circle>
      <circle cx="80" cy="80" r="50" fill="#00A1E0"></circle>
      <path
        fill="#fff"
        d="M68.857 93.757a2.931 2.931 0 001.62 2.571 3.189 3.189 0 003.138 0l22.242-13.757a2.855 2.855 0 000-5.143L73.615 63.774a3.189 3.189 0 00-3.138 0 2.932 2.932 0 00-1.62 2.571v27.412z"></path>
    </svg>
  );
};

export const QuoteIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="57"
      // fill="none"
      viewBox="0 0 65 57">
      <path
        // fill="#F5F5F5"
        fillOpacity="1"
        d="M25 .2v11.6c-8.133 2.8-12.2 8.733-12.2 17.8H25v27H0v-27c0-7.2 2.467-13.533 7.4-19C11.8 5.8 17.667 2.333 25 .2zm39.8 0v11.6c-8.133 2.8-12.2 8.733-12.2 17.8h12.2v27h-25v-27c0-7.2 2.467-13.533 7.4-19C51.6 5.8 57.467 2.333 64.8.2z"></path>
    </svg>
  );
};

export function TagIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 28 27">
      <path
        fill="#fff"
        d="M8 5.5a2 2 0 100 4 2 2 0 000-4zm18.16 6.28L14.945.554a1.332 1.332 0 00-.947-.387H2A1.333 1.333 0 00.666 1.5v12a1.333 1.333 0 00.387.947L12.279 25.66a4 4 0 005.654 0l8.226-8.16a4 4 0 000-5.653v-.067zm-1.88 3.76l-8.24 8.227a1.333 1.333 0 01-1.88 0L3.332 12.954V2.834h10.12L24.279 13.66a1.336 1.336 0 010 1.88z"></path>
    </svg>
  );
}

export function EarlyAccessIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="24"
      fill="none"
      viewBox="0 0 32 24">
      <path
        fill="#AEB6BA"
        d="M20.413.501c-6.39 0-11.588 5.159-11.588 11.5 0 6.34 5.198 11.499 11.588 11.499C26.803 23.5 32 18.34 32 12 32 5.659 26.802.5 20.413.5v.001zm0 21.07c-5.318 0-9.645-4.294-9.645-9.57 0-5.278 4.327-9.572 9.645-9.572 5.317 0 9.643 4.294 9.643 9.572 0 5.277-4.326 9.57-9.643 9.57zm.971-9.97V4.92a.968.968 0 00-.971-.964.968.968 0 00-.972.964V12c0 .127.025.247.07.358l.002.008c.05.12.123.23.215.32l3.28 3.255c.19.188.439.282.687.282a.972.972 0 00.688-.282.96.96 0 000-1.364L21.384 11.6zM2.482 8.931h4.29a.968.968 0 00.972-.964.968.968 0 00-.971-.964H2.482a.968.968 0 00-.972.964c0 .532.435.964.972.964zm4.4 3.069a.968.968 0 00-.972-.965H.972a.968.968 0 00-.972.965c0 .532.435.964.972.964H5.91A.968.968 0 006.882 12zm-.946-7.102h2.996a.968.968 0 00.971-.964.968.968 0 00-.971-.964H5.936a.968.968 0 00-.971.964c0 .533.434.964.971.964zm1.808 11.135a.968.968 0 00-.971-.964H2.482a.968.968 0 00-.972.964c0 .532.435.964.972.964h4.29a.968.968 0 00.972-.964zm1.187 3.068H5.936a.968.968 0 00-.972.965c0 .532.435.964.972.964H8.93a.968.968 0 00.972-.964.967.967 0 00-.972-.965z"></path>
    </svg>
  );
}

export function CoinsIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="23"
      fill="none"
      viewBox="0 0 30 23">
      <path
        stroke={props || '#AEB6BA'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M21 6c0 2.485-4.477 4.5-10 4.5S1 8.485 1 6m20 0c0-2.485-4.477-4.5-10-4.5S1 3.515 1 6m20 0v5c0 2.488-4.475 4.5-10 4.5S1 13.488 1 11V6m6 4.125v5m14-7.537c4.563.424 8 2.237 8 4.412m0 0c0 2.488-4.475 4.5-10 4.5-2.45 0-4.7-.4-6.438-1.05M29 12v5c0 2.488-4.475 4.5-10 4.5S9 19.488 9 17v-1.588m14 .713v5m-8-11v11"></path>
    </svg>
  );
}
export function CoinsIconOrderHistory(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke={props || "#F5F5F5"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13.75 6.563c0 1.553-2.798 2.812-6.25 2.812s-6.25-1.26-6.25-2.812m12.5 0c0-1.554-2.798-2.813-6.25-2.813S1.25 5.01 1.25 6.563m12.5 0v3.125c0 1.554-2.797 2.812-6.25 2.812s-6.25-1.258-6.25-2.812V6.562M5 9.142v3.125m8.75-4.711c2.852.265 5 1.398 5 2.758m0 0c0 1.554-2.797 2.812-6.25 2.812-1.531 0-2.937-.25-4.023-.656m10.273-2.156v3.124c0 1.555-2.797 2.813-6.25 2.813s-6.25-1.258-6.25-2.812v-.993m8.75.446v3.125M10 9.14v6.875"
      ></path>
    </svg>
  );
}

export function CheckmarkIcon(props) {
  return (
    <svg
      cy-test-id="checkmark-icon"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="14"
      fill="none"
      viewBox="0 0 20 14">
      <path
        fill={props.color || '#00DA5E'}
        fillRule="evenodd"
        d="M18.786.495a.997.997 0 010 1.41l-11.17 11.17a.997.997 0 01-1.41 0L.62 7.492a.997.997 0 111.41-1.41l4.88 4.88L17.377.494a.997.997 0 011.41 0z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export function SmallCheckmarkIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="9"
      fill="none"
      viewBox="0 0 11 9">
      <path
        stroke="#00B74F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.9"
        strokeWidth="2"
        d="M10 1.75L4.333 7.417 1.5 4.583"></path>
    </svg>
  );
}

export const Logo: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="214"
      height="32"
      fill="none"
      viewBox="0 0 214 32">
      <g fillRule="evenodd" clipPath="url(#clip0_4555_11497)" clipRule="evenodd">
        <path
          fill="url(#paint0_linear_4555_11497)"
          d="M0 16.006l5.93 2.667L21.268 9.68l-.024 15.886 5.972 2.688L27.26.021 0 16.006z"></path>
        <path
          fill="#00A1E0"
          d="M56.597 16.016l-5.93-2.67-15.338 8.996.025-15.886-5.972-2.688L29.336 32l27.261-15.984z"></path>
        <path
          fill="#fff"
          d="M92.006 9.15l-1.017 1.976c-.407.796-.793 1.181-2.38 1.181h-5.186a.41.41 0 00-.41.41v6.571c0 .224.182.41.41.41h9.678l-1.017 1.977c-.411.795-.794 1.18-2.38 1.18h-8.8a1.055 1.055 0 01-1.053-1.05v-11.6c0-.579.474-1.052 1.053-1.052h11.102V9.15zm-22.156.63l3.197 5.737 4.088 7.335h-2.358c-.81 0-1.477-.55-1.814-1.156l-3.576-6.42-.231-.414c-.116-.21-.267-.21-.386-.01l-.007.01-.204.364-3.604 6.466c-.337.607-1.007 1.157-1.814 1.157h-2.358l4.088-7.335 3.197-5.737c.207-.337.47-.63.891-.634.421.01.684.304.891.637zm135.388 8.85l3.572 3.539c.39.386.895.68 2.229.68H214l-6.512-6.459c-.207-.207-.197-.585.01-.792L214 9.146h-3.102c-1.41 0-1.838.431-2.228.817l-3.435 3.403c-.316.315-.513.322-.828.014l-.014-.014-3.436-3.403c-.389-.386-.817-.817-2.228-.817h-3.102l6.502 6.452c.207.207.218.585.011.792l-6.513 6.462h2.962c1.33 0 1.838-.297 2.228-.68l3.572-3.54c.33-.325.526-.322.849-.003zm-37.297 3.588l3.197-5.733 4.088-7.335h-2.358c-.811 0-1.478.55-1.814 1.156l-3.58 6.42-.231.414c-.116.21-.267.21-.386.01l-.007-.01-.204-.364-3.603-6.466c-.337-.607-1.008-1.157-1.815-1.157h-2.358l4.088 7.335 3.197 5.733c.207.337.47.631.891.635.425-.007.688-.302.895-.638zm-23.847-7.184V21.717a1.14 1.14 0 01-1.137 1.135h-2.021V9.15h1.368c.639 0 1.127.262 1.6.736l6.868 6.854.35.35c.257.257.464.075.464-.153V10.285a1.14 1.14 0 011.137-1.135h2.024v13.702h-1.368c-.639 0-1.127-.262-1.6-.736l-6.871-6.858-.421-.417c-.119-.123-.393-.032-.393.193zm36.753-5.884h11.531l-1.018 1.976c-.407.796-.793 1.181-2.379 1.181h-5.706c-.214 0-.407.165-.407.375v2.898c0 .21.172.379.379.379h11.282l-.811 1.577c-.407.795-.793 1.181-2.379 1.181h-8.088a.38.38 0 00-.379.379V21.71a1.14 1.14 0 01-1.137 1.135h-2.025V19.1a.38.38 0 00-.379-.378h-3.551l.811-1.578c.407-.795.793-1.18 2.379-1.18h.361a.38.38 0 00.379-.38v-5.298a1.136 1.136 0 011.137-1.135zm-65.734 0h2.025v12.563a1.14 1.14 0 01-1.137 1.136h-2.025V10.285a1.136 1.136 0 011.137-1.135zm8.137 0h11.535a1.14 1.14 0 011.136 1.135v11.428a1.14 1.14 0 01-1.136 1.136H123.25a1.14 1.14 0 01-1.136-1.136V10.285a1.14 1.14 0 011.136-1.135zm2.432 3.157h6.671a.41.41 0 01.41.41v6.571a.41.41 0 01-.41.41h-6.671a.41.41 0 01-.41-.41v-6.574a.412.412 0 01.41-.407zm-25.654 0h-5.902l1.017-1.976c.41-.796.793-1.181 2.38-1.181h13.541l-1.081 1.966c-.365.665-.993 1.177-1.758 1.18l-4.064.011a.485.485 0 00-.484.484v8.926a1.14 1.14 0 01-1.137 1.135h-2.024V12.791a.49.49 0 00-.488-.484z"></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4555_11497"
          x1="-18.005"
          x2="26.991"
          y1="-35.499"
          y2="28.012"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#00A1E0"></stop>
        </linearGradient>
        <clipPath id="clip0_4555_11497">
          <path fill="#fff" d="M0 0H214V32H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export const LogoFull: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="214"
      height="32"
      viewBox="0 0 214 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10652_176302)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16.0057L5.93022 18.6727L21.2681 9.68001L21.2435 25.5661L27.2158 28.2541L27.2614 0.0214844L0 16.0057Z"
          fill="url(#paint0_linear_10652_176302)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.5974 16.016L50.6672 13.3455L35.3293 22.3417L35.3539 6.45556L29.3816 3.76758L29.3359 32.0002L56.5974 16.016Z"
          fill="#00A1E0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.0058 9.15056L90.9882 11.1271C90.5812 11.9227 90.1952 12.3082 88.6091 12.3082H83.4228C83.1982 12.3082 83.0122 12.4904 83.0122 12.7182V19.2892C83.0122 19.5135 83.1947 19.6992 83.4228 19.6992H93.1006L92.083 21.6758C91.6725 22.4713 91.29 22.8568 89.7039 22.8568H80.9033C80.3243 22.8568 79.8506 22.3837 79.8506 21.8055V10.2054C79.8506 9.62718 80.3243 9.15407 80.9033 9.15407H92.0058V9.15056ZM69.85 9.78138L73.0467 15.5183L77.1347 22.8533H74.7766C73.966 22.8533 73.2993 22.3031 72.9625 21.6968L69.3868 15.2765L69.1552 14.863C69.0394 14.6527 68.8885 14.6527 68.7692 14.8525L68.7622 14.863L68.5587 15.2274L64.9549 21.6933C64.6181 22.2996 63.9478 22.8498 63.1408 22.8498H60.7827L64.8707 15.5148L68.0674 9.77788C68.2744 9.44144 68.5376 9.14706 68.9587 9.14355C69.3798 9.15407 69.6429 9.44845 69.85 9.78138ZM205.238 18.6304L208.81 22.1699C209.199 22.5554 209.705 22.8498 211.038 22.8498H214L207.487 16.391C207.28 16.1842 207.291 15.8057 207.498 15.5989L214 9.14706H210.898C209.487 9.14706 209.059 9.57812 208.67 9.96362L205.234 13.3665C204.918 13.6819 204.722 13.6889 204.406 13.3805L204.392 13.3665L200.957 9.96362C200.567 9.57812 200.139 9.14706 198.729 9.14706H195.627L202.129 15.5989C202.336 15.8057 202.346 16.1842 202.139 16.391L195.627 22.8533H198.588C199.918 22.8533 200.427 22.5554 200.816 22.1735L204.389 18.6339C204.718 18.3079 204.915 18.3114 205.238 18.6304ZM167.941 22.219L171.137 16.4856L175.225 9.15056H172.867C172.057 9.15056 171.39 9.70078 171.053 10.3071L167.474 16.7274L167.242 17.1409C167.127 17.3512 166.976 17.3512 166.856 17.1514L166.849 17.1409L166.646 16.7765L163.042 10.3106C162.705 9.70428 162.035 9.15407 161.228 9.15407H158.87L162.958 16.4891L166.155 22.2225C166.362 22.559 166.625 22.8533 167.046 22.8568C167.47 22.8498 167.734 22.5554 167.941 22.219ZM144.093 15.0347V15.4587V21.7179C144.093 22.3417 143.581 22.8533 142.957 22.8533H140.935V9.15056H142.304C142.942 9.15056 143.43 9.4134 143.904 9.88652L150.771 16.7414L151.122 17.0919C151.378 17.3477 151.585 17.1655 151.585 16.9377V16.426V10.286C151.585 9.66223 152.097 9.15056 152.722 9.15056L154.747 9.15056V22.8533H153.378C152.74 22.8533 152.252 22.5905 151.778 22.1174L144.908 15.259L144.486 14.8419C144.367 14.7193 144.093 14.8104 144.093 15.0347ZM180.847 9.15056H192.377L191.36 11.1271C190.953 11.9227 190.567 12.3082 188.981 12.3082L183.275 12.3082C183.061 12.3082 182.868 12.4729 182.868 12.6831V15.4658V15.5814C182.868 15.7917 183.04 15.9599 183.247 15.9599L194.528 15.9599L193.718 17.5369C193.311 18.3325 192.925 18.718 191.339 18.718H183.25C183.04 18.718 182.871 18.8897 182.871 19.0965V19.2121V21.7109C182.871 22.3347 182.359 22.8463 181.734 22.8463H179.71V19.2331V19.2156V19.1C179.71 18.8897 179.538 18.7215 179.331 18.7215H175.78L176.59 17.1444C176.997 16.3489 177.383 15.9634 178.969 15.9634H179.331C179.541 15.9634 179.71 15.7917 179.71 15.5849V15.4693V15.4202V10.286C179.706 9.66223 180.219 9.15056 180.847 9.15056ZM115.113 9.15056H117.137V21.7144C117.137 22.3382 116.625 22.8498 116 22.8498H113.976V10.286C113.972 9.66223 114.484 9.15056 115.113 9.15056ZM123.25 9.15056L134.784 9.15056C135.409 9.15056 135.921 9.66223 135.921 10.286V21.7144C135.921 22.3382 135.409 22.8498 134.784 22.8498L123.25 22.8498C122.625 22.8498 122.113 22.3382 122.113 21.7144V10.286C122.113 9.66223 122.625 9.15056 123.25 9.15056ZM125.682 12.3082L132.352 12.3082C132.577 12.3082 132.763 12.4904 132.763 12.7182V19.2892C132.763 19.5135 132.58 19.6992 132.352 19.6992L125.682 19.6992C125.457 19.6992 125.271 19.517 125.271 19.2892V12.7147C125.275 12.4904 125.457 12.3082 125.682 12.3082ZM100.027 12.3082L94.1252 12.3082L95.1429 10.3316C95.5534 9.53606 95.9359 9.15056 97.522 9.15056L102.126 9.15056H103.119H111.063L109.982 11.1166C109.617 11.7825 108.989 12.2941 108.224 12.2976L104.161 12.3082C103.894 12.3082 103.677 12.5254 103.677 12.7918V16.0019V21.7179C103.677 22.3417 103.164 22.8533 102.54 22.8533L100.515 22.8533V19.6957V16.0019V12.7918C100.512 12.5254 100.294 12.3082 100.027 12.3082Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10652_176302"
          x1="-18.0048"
          y1="-35.4995"
          x2="26.9912"
          y2="28.0118"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="#00A1E0" />
        </linearGradient>
        <clipPath id="clip0_10652_176302">
          <rect width="214" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export function PayPalIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="84"
      height="20"
      fill="none"
      viewBox="0 0 84 20">
      <g fillRule="evenodd" clipPath="url(#clip0_2442_72290)" clipRule="evenodd" opacity="0.5">
        <path
          fill="#AAA"
          d="M7.975 4.708h5.64c3.03 0 4.17 1.533 3.994 3.786-.292 3.719-2.54 5.776-5.522 5.776H10.58c-.409 0-.684.271-.795 1.005l-.639 4.267c-.042.276-.188.436-.406.458H5.197c-.334 0-.452-.255-.365-.806L6.993 5.516c.085-.547.385-.808.982-.808z"></path>
        <path
          fill="#fff"
          d="M32.465 4.454c1.903 0 3.66 1.033 3.419 3.605-.291 3.058-1.93 4.75-4.514 4.758H29.11c-.324 0-.482.265-.566.808l-.437 2.777c-.066.419-.281.626-.598.626h-2.102c-.335 0-.451-.214-.377-.693l1.735-11.13c.085-.547.29-.75.665-.75h5.034zm-3.422 5.959h1.71c1.071-.041 1.782-.782 1.853-2.12.044-.825-.514-1.416-1.4-1.412l-1.611.008-.552 3.524zm12.553 5.763c.192-.175.388-.265.36-.05l-.069.516c-.035.27.072.412.322.412h1.867c.315 0 .467-.127.545-.613l1.15-7.22c.058-.362-.03-.54-.306-.54h-2.053c-.185 0-.275.104-.323.386l-.076.444c-.04.232-.146.273-.245.04-.348-.825-1.236-1.194-2.475-1.165-2.879.06-4.82 2.245-5.028 5.047-.16 2.166 1.392 3.869 3.44 3.869 1.485 0 2.149-.437 2.897-1.122l-.006-.004zm-1.564-1.111c-1.239 0-2.102-.989-1.923-2.2.179-1.212 1.338-2.2 2.577-2.2 1.24 0 2.103.988 1.924 2.2-.18 1.211-1.337 2.2-2.578 2.2zm9.392-6.407h-1.893c-.39 0-.548.291-.425.65l2.35 6.881-2.305 3.275c-.193.274-.043.523.229.523h2.127a.65.65 0 00.632-.31l7.229-10.368c.222-.319.118-.654-.248-.654h-2.014c-.345 0-.483.137-.681.424l-3.014 4.368-1.347-4.378c-.079-.265-.276-.411-.638-.411h-.002z"></path>
        <path
          fill="#AAA"
          d="M64.887 4.454c1.903 0 3.66 1.032 3.42 3.605-.292 3.058-1.93 4.75-4.515 4.758h-2.257c-.324 0-.482.265-.566.808l-.437 2.777c-.066.419-.281.626-.599.626h-2.1c-.336 0-.452-.214-.378-.693l1.737-11.132c.086-.548.291-.752.666-.752h5.03v.003zm-3.422 5.959h1.711c1.07-.041 1.781-.782 1.852-2.12.044-.825-.514-1.416-1.4-1.412l-1.61.008-.553 3.524zm12.554 5.763c.192-.175.387-.265.36-.05l-.07.516c-.034.27.072.412.323.412h1.866c.315 0 .468-.127.545-.613l1.15-7.22c.059-.362-.03-.54-.305-.54h-2.05c-.186 0-.276.104-.324.386l-.076.444c-.039.232-.145.273-.244.04-.348-.825-1.237-1.194-2.476-1.165-2.879.06-4.82 2.245-5.028 5.047-.16 2.166 1.392 3.869 3.44 3.869 1.485 0 2.149-.437 2.897-1.122l-.008-.004zm-1.563-1.111c-1.239 0-2.103-.989-1.923-2.2.179-1.212 1.338-2.2 2.577-2.2 1.24 0 2.103.988 1.924 2.2-.18 1.211-1.339 2.2-2.578 2.2zm8.61 2h-2.155a.257.257 0 01-.255-.18.254.254 0 01-.008-.11L80.54 4.781a.371.371 0 01.358-.292h2.155a.255.255 0 01.263.292l-1.892 11.992a.372.372 0 01-.359.295v-.003z"></path>
        <path
          fill="#fff"
          d="M4.447 0h5.646c1.59 0 3.478.051 4.739 1.165.843.744 1.285 1.928 1.183 3.203-.346 4.312-2.925 6.728-6.385 6.728H6.846c-.474 0-.788.314-.921 1.165l-.778 4.95c-.051.32-.19.51-.437.533H1.226c-.386 0-.523-.29-.423-.934L3.308.94c.1-.637.451-.94 1.139-.94z"></path>
        <path
          fill="#DADADA"
          d="M6.006 11.758l.986-6.242c.086-.548.386-.81.983-.81h5.64c.934 0 1.69.146 2.28.415-.566 3.838-3.048 5.97-6.298 5.97h-2.78c-.373.002-.647.188-.811.667z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2442_72290">
          <path fill="#fff" d="M0 0H82.553V20H0z" transform="translate(.771)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function StripeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="20"
      fill="none"
      viewBox="0 0 49 20">
      <g clipPath="url(#clip0_2442_72287)">
        <path
          fill="#7F898D"
          d="M3.74 7.802c0-.518.425-.717 1.13-.717 1.01 0 2.286.305 3.296.85V4.812A8.765 8.765 0 004.87 4.2C2.17 4.2.377 5.61.377 7.962c0 3.668 5.05 3.084 5.05 4.665 0 .612-.53.811-1.275.811-1.103 0-2.512-.452-3.629-1.063v3.163a9.213 9.213 0 003.629.758c2.765 0 4.665-1.37 4.665-3.748C8.804 8.585 3.74 9.29 3.74 7.801zm8.985-6.26l-3.243.691-.013 10.647c0 1.967 1.475 3.416 3.442 3.416 1.09 0 1.888-.2 2.326-.439V13.16c-.425.173-2.525.784-2.525-1.183V7.257h2.525v-2.83h-2.525l.013-2.885zm6.646 3.868l-.213-.984h-2.87v11.63h3.322V8.175c.784-1.023 2.114-.837 2.526-.69V4.425c-.426-.16-1.98-.452-2.765.984zm3.575-.984h3.337v11.63h-3.337V4.426zm0-1.01l3.337-.718V0l-3.337.704v2.712zm10.275.784c-1.303 0-2.14.612-2.605 1.037l-.173-.824h-2.924V19.91l3.323-.704.013-3.762c.479.346 1.183.837 2.353.837 2.379 0 4.546-1.914 4.546-6.127C37.74 6.3 35.547 4.2 33.22 4.2zm-.797 9.158c-.785 0-1.25-.279-1.569-.625l-.013-4.93c.345-.386.824-.652 1.581-.652 1.21 0 2.047 1.356 2.047 3.097 0 1.781-.824 3.11-2.047 3.11zm15.803-3.07c0-3.403-1.648-6.088-4.798-6.088-3.163 0-5.077 2.685-5.077 6.061 0 4.001 2.26 6.021 5.502 6.021 1.582 0 2.778-.358 3.682-.864V12.76c-.904.452-1.94.731-3.256.731-1.29 0-2.433-.452-2.579-2.02h6.5c0-.173.026-.864.026-1.183zm-6.566-1.263c0-1.502.917-2.127 1.755-2.127.81 0 1.675.625 1.675 2.127h-3.43z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2442_72287">
          <path fill="#fff" d="M0 0H47.85V20H0z" transform="translate(.377)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function ShieldIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32">
      <path
        fill="#7F898D"
        d="M5.5 14.338V7a1 1 0 011-1h20a1 1 0 011 1v7.338c0 10.5-8.913 13.975-10.688 14.562a.9.9 0 01-.625 0C14.412 28.313 5.5 24.837 5.5 14.338z"
        opacity="0.2"></path>
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.5 14.338V7a1 1 0 011-1h20a1 1 0 011 1v7.338c0 10.5-8.913 13.975-10.688 14.562a.9.9 0 01-.625 0C14.412 28.313 5.5 24.837 5.5 14.338z"></path>
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22 13l-7.338 7L11 16.5"></path>
    </svg>
  );
}

export function ExitIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      fill="none"
      viewBox="0 0 32 33">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.5"
        strokeWidth="2"
        d="M25 7.5l-18 18M25 25.5L7 7.5"></path>
    </svg>
  );
}
export function NewExitIcon(props) {
  return (
    <svg
      cy-test-id="exit-icon"
      {...props}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1.25 1.25L8.75 8.75" stroke={props || 'white'} />
      <path d="M8.75 1.25L1.25 8.75" stroke={props || 'white'} />
    </svg>
  );
}

export function SmallExitIcon(props) {
  const settings = {
    ...props,
    height: props.height || 14,
    width: props.width || 15,
  }

  return (
    <svg
      {...settings}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 15 14">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.438 3.063l-7.876 7.874m7.876 0L3.561 3.064"></path>
    </svg>
  );
}

export function PlusIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18">
      <path
        fill={props.color || '#7F898D'}
        d="M17.25 8.25h-7.5V.75a.75.75 0 00-1.5 0v7.5H.75a.75.75 0 000 1.5h7.5v7.5a.75.75 0 101.5 0v-7.5h7.5a.75.75 0 100-1.5z"></path>
    </svg>
  );
}

export function MinusIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="3"
      fill="none"
      viewBox="0 0 19 3">
      <path
        fill="#7F898D"
        d="M17.625.875H9.75 1.125a.75.75 0 100 1.5h16.5a.75.75 0 100-1.5z"></path>
    </svg>
  );
}

export function TrashIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16">
      <path
        stroke={props.className?.includes('stroke') ? '' : '#AEB6BA'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M13.5 3.5h-11m4 3v4m3-4v4m3-7V13a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V3.5m7 0v-1a1 1 0 00-1-1h-3a1 1 0 00-1 1v1"></path>
    </svg>
  );
}

export function DownChevronIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="10"
      fill="none"
      viewBox="0 0 11 10"
    // className={props.className}
    >
      <path
        // stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9.102 3.75L5.977 6.875 2.852 3.75"></path>
    </svg>
  );
}
export function DownChevronIconThin(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16">
      <path
        // stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13 6l-5 5-5-5"></path>
    </svg>
  );
}

export function DiscordIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      fill="none"
      viewBox="0 0 20 16">
      <path d="M19.32 11.266l-2.657-8.844a1.22 1.22 0 00-.718-.797h-.047l.047-.015a15.028 15.028 0 00-2.696-.797.625.625 0 00-.734.492.616.616 0 00.484.734c.352.07.696.156 1.032.25a.625.625 0 01-.282 1.18h-.062A14.484 14.484 0 009.999 3a14.203 14.203 0 00-3.601.453.625.625 0 01-.438-1.164h.008c.336-.094.68-.18 1.031-.25a.625.625 0 00.493-.734.633.633 0 00-.735-.492c-.925.185-1.83.457-2.703.812a1.219 1.219 0 00-.719.797L.68 11.266a1.25 1.25 0 00.383 1.304c.072.07.147.135.226.196h.008c1.266 1.031 2.93 1.82 4.805 2.273a.489.489 0 00.148.024.625.625 0 00.149-1.235 12.531 12.531 0 01-2.446-.867.625.625 0 01.672-1.031C6.11 12.586 7.976 13 10 13c2.024 0 3.891-.414 5.375-1.07a.625.625 0 01.672 1.031c-.783.373-1.602.664-2.445.867a.625.625 0 00.148 1.235c.05 0 .1-.008.149-.024 1.875-.453 3.539-1.242 4.805-2.273h.007c.08-.061.155-.126.227-.196a1.25 1.25 0 00.383-1.304zM7.5 10.188a.937.937 0 11-.001-1.874.937.937 0 010 1.874zm5 0a.937.937 0 11-.001-1.874.937.937 0 010 1.874z"></path>
    </svg>
  );
}

export function CalendarIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16">
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13 2.5H3a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h10a.5.5 0 00.5-.5V3a.5.5 0 00-.5-.5zM11 1.5v2M5 1.5v2M2.5 5.5h11"></path>
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.75 8H7.5l-1 1.25a1 1 0 11-.706 1.706M9 8.75L10 8v3.25"></path>
    </svg>
  );
}
export function SimpleCalendarIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        // stroke="#7F898D"
        strokeWidth="1.5"
        d="M16.5 4.8v.75h1.65c.283 0 .542.115.732.3H4.818c.19-.185.449-.3.732-.3H7.2v-1.8h.3v1.8h8.7v-1.8h.3V4.8zm2.4 1.8v-.732c.185.19.3.449.3.732v12.6c0 .283-.115.542-.3.732V9.45H4.8v10.482c-.185-.19-.3-.449-.3-.732V6.6c0-.283.115-.542.3-.732V9.15h14.1V6.6zm-.75 13.35h.732c-.19.185-.449.3-.732.3H5.55c-.283 0-.542-.115-.732-.3H18.15zm-5.55-6.3h3v3h-3v-3z"></path>
    </svg>
  );
}

export function LeftCaretIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="27"
      fill="none"
      viewBox="0 0 15 27">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.062"
        d="M13.6 25.215L2.002 13.617 13.6 2.017"></path>
    </svg>
  );
}

export function RightCaretIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="27"
      fill="none"
      viewBox="0 0 15 27">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.062"
        d="M1.401 25.215l11.6-11.598-11.6-11.6"></path>
    </svg>
  );
}

export function CirclePersonIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 21a9 9 0 100-18 9 9 0 000 18z"></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 15a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM5.98 18.694a6.75 6.75 0 0112.038 0"></path>
    </svg>
  );
}
export function ProjectsIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.834 21.75H2.194a.693.693 0 01-.694-.694V9.75m3-3v11.306a.693.693 0 00.694.694h16.64a.665.665 0 00.666-.666V7.5a.75.75 0 00-.75-.75H4.5zm0 0V4.5a.75.75 0 01.75-.75h4.94a.74.74 0 01.526.216L13.5 6.75"></path>
    </svg>
  );
}
export function DownloadsIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M12 4.5v15m-9-12h18m-18 9h18M7.5 4.5v3m9-3v3m-9 9v3m9-3v3M3.75 4.5h16.5a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V5.25a.75.75 0 01.75-.75z"></path>
    </svg>
  );
}
export function OrdersIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.125 9.75h9.75m-9.75 3h9.75M3 19.5V5.25a.75.75 0 01.75-.75h16.5a.75.75 0 01.75.75V19.5L18 18l-3 1.5-3-1.5-3 1.5L6 18l-3 1.5z"></path>
    </svg>
  );
}
export function TeamIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14.25 7.5h9m-9 4.5h9m-6.75 4.5h6.75M1.687 18a6 6 0 0111.626 0M11.25 9.75a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"></path>
    </svg>
  );
}
export function CardIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.75 15.75h3m-7.5 0h1.5M2.25 9.084h19.5M3 5.25h18a.75.75 0 01.75.75v12a.75.75 0 01-.75.75H3a.75.75 0 01-.75-.75V6A.75.75 0 013 5.25z"></path>
    </svg>
  );
}

export function AVIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="414"
      height="234"
      fill="none"
      viewBox="0 0 414 234">
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M414 116.805l-43.289-19.58-111.961 65.959.179-116.476L215.333 27 215 234l199-117.195z"
        clipRule="evenodd"></path>
      <path
        fill="url(#paint0_linear_3975_75122)"
        fillRule="evenodd"
        d="M0 117.195l43.289 19.554L155.25 70.816l-.179 116.476L198.667 207 199 0 0 117.195z"
        clipRule="evenodd"></path>
      <defs>
        <linearGradient
          id="paint0_linear_3975_75122"
          x1="-131.429"
          x2="198.959"
          y1="-260.438"
          y2="203.849"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#00A1E0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export function AvfxLogo(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="249.387"
      height="42.987"
      version="1.1"
      viewBox="0 0 249.387 42.987">
      <g transform="matrix(1.33333 0 0 -1.33333 0 42.987)">
        <g fillOpacity="1" fillRule="evenodd" stroke="none" transform="scale(.1)">
          <path
            fill="#f8f8f8"
            d="M213.008 307.457l75.101-134.926L384.148 0h-55.371c-19.027 0-34.726 12.977-42.664 27.234l-84.054 151.004-5.407 9.711c-2.73 4.91-6.304 4.922-9.027.231l-.129-.231-4.797-8.609L98.035 27.234C90.102 12.977 74.398 0 55.375 0H0l96.04 172.531 75.101 134.926c4.867 7.906 11.054 14.813 20.933 14.898 9.879-.085 16.067-6.992 20.934-14.898"></path>
          <path
            fill="#f8f8f8"
            d="M1405.82 99.293l83.97-83.262C1498.9 6.981 1510.85 0 1542.12 0h69.62l-153 151.996c-4.87 4.832-4.64 13.762.24 18.598l152.76 151.761h-72.84c-33.16 0-43.24-10.16-52.36-19.21l-80.73-80.082c-7.44-7.383-12-7.614-19.46-.352l-.36.352-80.73 80.082c-9.11 9.05-19.2 19.21-52.35 19.21h-72.85l152.77-151.761c4.87-4.836 5.1-13.766.23-18.598L1180.06 0h69.62c31.27 0 43.22 6.98 52.34 16.031l83.96 83.266.01-.004c7.68 7.617 12.26 7.5 19.82 0h.01"></path>
          <path
            fill="#f8f8f8"
            d="M555.371 14.902l75.102 134.926 96.039 172.527h-55.375c-19.024 0-34.727-12.976-42.66-27.226l-84.055-151.012-5.406-9.711c-2.735-4.91-6.305-4.922-9.032-.226l-.129.226-4.792 8.614-84.668 152.109c-7.93 14.25-23.633 27.226-42.661 27.226h-55.375l96.043-172.527 75.102-134.926C518.371 6.996 524.559.09 534.438.004c9.875.086 16.066 6.992 20.933 14.898"></path>
          <path
            fill="#f8f8f8"
            d="M858.551 322.352l270.909.003-23.89-46.5c-9.6-18.703-18.6-27.769-55.89-27.769H915.66c-5.019 0-9.578-3.891-9.578-8.828v-68.211c0-4.918 4.02-8.938 8.938-8.938h265.04l-19.08-37.144c-9.6-18.703-18.61-27.766-55.89-27.766H915.02c-4.918 0-8.938-4.02-8.938-8.937V26.738C906.082 12.031 894.047 0 879.344 0h-47.535v88.262c0 4.918-4.02 8.937-8.942 8.937h-83.469l19.079 37.141c9.601 18.703 18.609 27.769 55.89 27.769h8.5c4.922 0 8.942 4.02 8.942 8.938v124.566c0 14.707 12.035 26.739 26.742 26.739"></path>
          <path
            fill="#49a8e3"
            d="M1792.45 238.16a6.242 6.242 0 00-6.24 6.227l-.01.004v77.964h-56.8l-.08-78.226a6.18 6.18 0 00-5.83-5.879l-35.09-.066h-3.7c-.04 0-.08-.004-.12-.004h-39.36v-56.801s78.07-.051 78.07-.059a6.218 6.218 0 006.07-6.113l.04-78.008h56.8l.07 78.203c.16 3.266 2.78 5.868 6.07 5.93l34.87.035h3.69c.09 0 .16.012.24.012h39.24v56.801l-77.93-.02"></path>
        </g>
      </g>
    </svg>
  );
}

export function CardTypes(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="149"
      height="24"
      fill="none"
      viewBox="0 0 149 24">
      <rect
        width="33.424"
        height="23.195"
        x="115.172"
        y="0.403"
        fill="#fff"
        stroke="#B2BCCA"
        strokeWidth="0.805"
        rx="2.819"></rect>
      <path
        fill="#ED0006"
        fillRule="evenodd"
        d="M132.063 16.83a6.875 6.875 0 01-4.428 1.6c-3.77 0-6.826-3-6.826-6.7s3.056-6.7 6.826-6.7c1.69 0 3.236.603 4.428 1.6a6.877 6.877 0 014.428-1.6c3.771 0 6.827 3 6.827 6.7s-3.056 6.7-6.827 6.7a6.877 6.877 0 01-4.428-1.6z"
        clipRule="evenodd"></path>
      <path
        fill="#F9A000"
        fillRule="evenodd"
        d="M132.063 16.83a6.638 6.638 0 002.398-5.1c0-2.042-.931-3.87-2.399-5.1a6.88 6.88 0 014.428-1.6c3.77 0 6.827 3 6.827 6.7s-3.057 6.7-6.827 6.7a6.874 6.874 0 01-4.427-1.6z"
        clipRule="evenodd"></path>
      <path
        fill="#FD6020"
        fillRule="evenodd"
        d="M132.062 16.83a6.635 6.635 0 002.399-5.1c0-2.042-.931-3.87-2.399-5.1a6.637 6.637 0 00-2.398 5.1c0 2.042.931 3.87 2.398 5.1z"
        clipRule="evenodd"></path>
      <rect
        width="33.424"
        height="23.195"
        x="38.66"
        y="0.403"
        fill="#fff"
        stroke="#B2BCCA"
        strokeWidth="0.805"
        rx="2.819"></rect>
      <path
        fill="#FD6020"
        d="M56.781 23.357l15.303-4.63v2.214a2.416 2.416 0 01-2.416 2.416H56.78z"></path>
      <path
        fill="#000"
        fillRule="evenodd"
        d="M67.85 9.112c1.052 0 1.63.483 1.63 1.396.053.699-.42 1.29-1.052 1.397l1.42 1.988h-1.104l-1.21-1.934h-.106v1.934h-.894V9.112h1.315zm-.422 2.203h.263c.58 0 .842-.27.842-.753 0-.43-.263-.698-.842-.698h-.263v1.45zm-3.998 2.579h2.525v-.806h-1.631v-1.29h1.579v-.806h-1.579V9.918h1.631v-.806H63.43v4.782zm-2.63-1.559l-1.211-3.223h-.947l1.947 4.89h.473l1.947-4.89h-.947l-1.263 3.223zm-10.682-.805c0 1.343 1.052 2.471 2.367 2.471.421 0 .79-.107 1.158-.268v-1.075c-.263.322-.632.537-1.053.537-.841 0-1.525-.645-1.525-1.504v-.108c-.053-.86.631-1.611 1.473-1.665.42 0 .842.215 1.105.537V9.381c-.316-.215-.737-.269-1.105-.269-1.368-.107-2.42 1.02-2.42 2.418zm-1.631-.591c-.526-.215-.684-.323-.684-.591.052-.323.315-.591.631-.538.263 0 .526.161.737.376l.473-.644c-.368-.323-.842-.538-1.315-.538-.737-.053-1.368.538-1.42 1.29v.053c0 .645.262 1.021 1.104 1.29.21.054.421.161.632.269a.567.567 0 01.263.483c0 .376-.316.699-.632.699h-.053c-.42 0-.789-.269-.947-.645l-.578.59c.315.592.947.914 1.578.914.842.054 1.526-.59 1.579-1.45v-.162c-.053-.644-.316-.967-1.368-1.397zm-3.053 2.955h.895V9.112h-.895v4.782zm-4.157-4.782H42.856a2.32 2.32 0 012.21 2.417c0 .699-.316 1.343-.842 1.827-.474.376-1.052.591-1.631.537h-1.316V9.112zm1.158 3.975c.42.054.894-.107 1.21-.376.316-.322.473-.752.473-1.236 0-.43-.157-.86-.473-1.182-.316-.268-.79-.43-1.21-.376h-.263v3.17h.263z"
        clipRule="evenodd"></path>
      <path
        fill="#FD6020"
        fillRule="evenodd"
        d="M56.327 9c-1.316 0-2.42 1.075-2.42 2.472a2.522 2.522 0 002.42 2.525c1.368.054 2.42-1.074 2.473-2.471C58.747 10.129 57.695 9 56.327 9z"
        clipRule="evenodd"></path>
      <rect
        width="33.424"
        height="23.195"
        x="0.403"
        y="0.403"
        fill="#fff"
        stroke="#B2BCCA"
        strokeWidth="0.805"
        rx="2.819"></rect>
      <path
        fill="#28356A"
        fillRule="evenodd"
        d="M10.822 15.859H8.75L7.194 9.793c-.074-.279-.23-.526-.461-.642a6.648 6.648 0 00-1.901-.642v-.233h3.34c.462 0 .807.35.865.758l.807 4.375 2.072-5.133h2.016l-3.11 7.583zm4.263 0h-1.958l1.612-7.583h1.959l-1.613 7.583zm4.147-5.483c.057-.408.403-.642.807-.642a3.58 3.58 0 011.9.35l.346-1.633a4.862 4.862 0 00-1.785-.35c-1.901 0-3.284 1.05-3.284 2.508 0 1.109.98 1.691 1.671 2.042.748.35 1.036.583.979.933 0 .525-.577.758-1.152.758a4.848 4.848 0 01-2.016-.467l-.346 1.634a5.54 5.54 0 002.132.409c2.13.057 3.455-.992 3.455-2.567 0-1.984-2.707-2.1-2.707-2.975zm9.561 5.483l-1.555-7.583h-1.67a.868.868 0 00-.807.583l-2.88 7h2.017l.402-1.108h2.477l.23 1.108h1.786zm-2.937-5.541l.575 2.858h-1.613l1.038-2.858z"
        clipRule="evenodd"></path>
      <rect
        width="33.424"
        height="23.195"
        x="76.918"
        y="0.403"
        fill="#fff"
        stroke="#B2BCCA"
        strokeWidth="0.805"
        rx="2.819"></rect>
      <path
        fill="#ED0006"
        d="M95.906 11.705c0 3.703-2.988 6.705-6.674 6.705-3.686 0-6.673-3.002-6.673-6.705 0-3.704 2.987-6.706 6.673-6.706s6.674 3.002 6.674 6.706z"></path>
      <path
        fill="#2F80ED"
        d="M104.562 11.705c0 3.703-2.988 6.705-6.674 6.705-3.685 0-6.673-3.002-6.673-6.705 0-3.704 2.988-6.706 6.673-6.706 3.686 0 6.674 3.002 6.674 6.706z"></path>
      <path
        fill="#6C6BBD"
        fillRule="evenodd"
        d="M93.56 16.809a6.704 6.704 0 002.344-5.104c0-2.043-.91-3.873-2.345-5.103a6.704 6.704 0 00-2.344 5.103c0 2.044.91 3.874 2.344 5.104z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export function HamburgerIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        fill="#7F898D"
        d="M16.25 9.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16.25 17.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16.25 25.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>
    </svg>
  );
}

export function CopyIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9.555 5.579l1.547-1.547a3.445 3.445 0 014.867 4.867l-2.211 2.203a3.43 3.43 0 01-4.86 0"></path>
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.446 14.422L8.899 15.97a3.445 3.445 0 01-4.867-4.867l2.21-2.203a3.43 3.43 0 014.86 0"></path>
    </svg>
  );
}

export function NameIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 4.375v11.25M3.75 6.875v-2.5h12.5v2.5M7.5 15.625h5"></path>
    </svg>
  );
}

export function WhiteTrashIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.875 4.375H3.125m5 3.75v5m3.75-5v5m3.75-8.75V16.25a.624.624 0 01-.625.625H5a.625.625 0 01-.625-.625V4.375m8.75 0v-1.25a1.25 1.25 0 00-1.25-1.25h-3.75a1.25 1.25 0 00-1.25 1.25v1.25"></path>
    </svg>
  );
}

export function RoyaltyFreeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      viewBox="0 0 60 60">
      <rect width="60" height="60" fill="#122227" rx="4"></rect>
      <path
        fill="#00A1E0"
        d="M18 38.4h24v2.4H18v-2.4zm0-16.8l6 3.6 6-7.2 6 7.2 6-3.6V36H18V21.6z"></path>
    </svg>
  );
}

export function SixKIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      viewBox="0 0 60 60">
      <rect width="60" height="60" fill="#122227" rx="4"></rect>
      <rect width="37.5" height="22.5" x="10.801" y="19.2" fill="#00A1E0" rx="2"></rect>
      <path
        fill="#122227"
        d="M28.335 27.74h-1.657l.007-.2c0-.413-.092-.681-.277-.806-.185-.129-.576-.193-1.173-.193-.868 0-1.41.084-1.625.251-.214.163-.322.578-.322 1.244v1.515h.032c.288-.567 1.008-.851 2.16-.851 1.13 0 1.901.18 2.314.541.412.357.618 1.027.618 2.011 0 1.139-.221 1.906-.664 2.301-.442.396-1.302.593-2.578.593-1.572 0-2.56-.232-2.965-.696-.403-.468-.605-1.607-.605-3.416 0-2.234.18-3.598.541-4.093.365-.494 1.373-.74 3.023-.74 1.203 0 2.032.165 2.488.495.455.331.683.935.683 1.812v.232zm-3.242 2.3c-.786 0-1.291.072-1.515.213-.219.138-.328.454-.328.948 0 .717.098 1.164.296 1.34.198.177.696.265 1.495.265.765 0 1.242-.078 1.431-.232.194-.16.29-.555.29-1.186 0-.598-.094-.971-.283-1.122-.185-.15-.647-.225-1.386-.225zM31.628 25.271v3.584h.787l2.926-3.584h2.075l-3.551 4.273 3.925 4.525h-2.14l-3.222-3.81h-.8v3.81H29.96V25.27h1.67z"></path>
    </svg>
  );
}

export function FileFormatsIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      viewBox="0 0 60 60">
      <rect width="60" height="60" fill="#122227" rx="4"></rect>
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M20.906 19.29c-.566.233-1.008.672-1.324 1.317-.398.81-.383.427-.383 9.402 0 7.214.012 8.205.099 8.59.197.873.682 1.602 1.321 1.99l.35.211H39.03l.35-.211c.639-.388 1.123-1.117 1.32-1.99.088-.385.1-1.376.1-8.59 0-7.213-.012-8.204-.1-8.59-.197-.872-.681-1.601-1.32-1.989l-.35-.211-8.938-.015c-7.087-.012-8.989.005-9.186.086zm3.073 4.502v1.564H21.62v-3.129h2.359v1.565zm14.4 0v1.564h-2.36v-3.129h2.36v1.565zm-14.4 6.217v1.525H21.62v-3.049h2.359v1.524zm14.4 0v1.525h-2.36v-3.049h2.36v1.524zm-14.4 6.218v1.565H21.62v-3.129h2.359v1.564zm14.4 0v1.565h-2.36v-3.129h2.36v1.564z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export function MoneyBackGuaranteeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      viewBox="0 0 60 60">
      <rect width="60" height="60" fill="#122227" rx="4"></rect>
      <path
        fill="#00A1E0"
        d="M19 28.337V21a1 1 0 011-1h20a1 1 0 011 1v7.337c0 10.5-8.913 13.976-10.688 14.563a.9.9 0 01-.625 0C27.913 42.313 19 38.837 19 28.337z"></path>
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M19 28.337V21a1 1 0 011-1h20a1 1 0 011 1v7.337c0 10.5-8.913 13.976-10.688 14.563a.9.9 0 01-.625 0C27.913 42.313 19 38.837 19 28.337z"></path>
      <path
        stroke="#122227"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M35.5 27l-7.337 7-3.663-3.5"></path>
    </svg>
  );
}

export function TeamRectangleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      viewBox="0 0 60 60">
      <rect width="60" height="60" fill="#122227" rx="4"></rect>
      <g fill="#00A1E0" clipPath="url(#clip0_6664_122970)">
        <path d="M38.024 38.032c0-1.39-.397-2.78-1.191-3.772-1.39-1.589-2.978-2.383-4.964-2.383h-3.574c-1.39 0-2.581.397-3.772 1.191-1.39.993-2.184 2.383-2.383 3.971-.199 1.787 0 3.773-.199 5.758.199 0 .596.199.795.199 2.382.596 4.566 1.191 6.949 1.191 1.39 0 2.978 0 4.368-.198 1.191-.199 2.383-.596 3.574-.993.199 0 .199-.199.199-.397.198-1.589.198-3.177.198-4.567z"></path>
        <path d="M25.119 31.48c.397-.199.596-.199.993-.397-1.192-1.191-1.787-2.383-1.787-3.971h-4.17c-.794 0-1.588.198-2.184.397-2.184.794-3.971 2.978-3.971 5.36v4.965c0 .198 0 .198.199.397 1.588.397 3.176.794 4.765.992.596 0 1.39.2 1.985.2V38.23c0-.596 0-1.192.199-1.787.596-2.383 1.985-3.971 3.97-4.964zM45.77 33.267c0-.794-.2-1.787-.596-2.581-1.192-2.383-2.979-3.574-5.56-3.574h-3.772c0 1.588-.596 2.978-1.787 3.97.198 0 .397.2.397.2.993.396 1.985.992 2.78 1.786 1.19 1.39 1.787 2.979 1.787 4.766v1.39c.992-.199 1.787-.199 2.78-.398 1.19-.198 2.58-.595 3.772-1.19.198 0 .198-.2.198-.398v-3.971zM30.084 31.678c2.58 0 4.765-2.184 4.566-4.765 0-2.581-2.184-4.567-4.566-4.567-2.582 0-4.766 1.986-4.766 4.567.199 2.581 2.184 4.765 4.766 4.765zM35.84 26.516c.596.199 1.192.397 1.986.397 2.581 0 4.765-2.184 4.566-4.765 0-2.581-2.184-4.567-4.566-4.567-2.581 0-4.766 1.986-4.766 4.567 1.589.794 2.582 2.382 2.78 4.368zM21.943 26.913c.794 0 1.787-.198 2.383-.596.198-1.588.992-2.978 2.184-3.772v-.199c0-2.58-2.184-4.566-4.567-4.566-2.581 0-4.765 1.985-4.765 4.566 0 2.383 2.184 4.567 4.765 4.567z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6664_122970">
          <path fill="#fff" d="M0 0H31.768V30H0z" transform="translate(14 15)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function GivingRectangleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80">
      <rect width="80" height="80" fill="#1F3D48" fillOpacity="0.7" rx="4"></rect>
      <g clipPath="url(#clip0_6068_121020)">
        <path
          fill="#00A1E0"
          d="M35.254 39.111h3.858a8 8 0 018 8H34.666l.002 1.778H48.89V47.11a9.916 9.916 0 00-1.575-5.333h5.13a8.89 8.89 0 018.029 5.068C56.269 52.395 49.462 56 41.779 56c-4.909 0-9.067-1.049-12.445-2.889v-16.54a12.385 12.385 0 015.92 2.54zm-7.698 13.333a1.778 1.778 0 01-1.777 1.778h-3.556a1.778 1.778 0 01-1.778-1.778v-16a1.778 1.778 0 011.778-1.777h3.556a1.778 1.778 0 011.777 1.777v16zm23.111-24.889a5.333 5.333 0 110 10.667 5.333 5.333 0 010-10.667zm-12.444-5.333a5.333 5.333 0 110 10.667 5.333 5.333 0 010-10.667z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6068_121020">
          <path fill="#fff" d="M0 0H42.667V42.667H0z" transform="translate(18.668 18.666)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function FolderRectangleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80">
      <rect width="80" height="80" fill="#1F3D48" fillOpacity="0.7" rx="4"></rect>
      <g clipPath="url(#clip0_6068_121011)">
        <path
          fill="#00A1E0"
          d="M24 56a1.778 1.778 0 01-1.777-1.778V25.778A1.778 1.778 0 0124 24h13.18l3.556 3.556h13.487A1.778 1.778 0 0156 29.333v5.334H25.778v17.77l3.556-14.215h29.333L54.56 54.654A1.778 1.778 0 0152.836 56H24z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6068_121011">
          <path fill="#fff" d="M0 0H42.667V42.667H0z" transform="translate(18.668 18.666)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function RecycleIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80">
      <rect width="80" height="80" fill="#1F3D48" fillOpacity="0.7" rx="4"></rect>
      <g clipPath="url(#clip0_6068_121001)">
        <path
          fill="#00A1E0"
          d="M29.334 25.778h26.667a1.777 1.777 0 011.778 1.777V40h-3.556V29.333H29.334v5.334l-8.889-7.112 8.89-7.11v5.333zm21.333 28.444H24.001a1.778 1.778 0 01-1.778-1.778V40h3.556v10.667h24.888v-5.334l8.89 7.111-8.89 7.111v-5.333z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6068_121001">
          <path fill="#fff" d="M0 0H42.667V42.667H0z" transform="translate(18.668 18.666)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function RedXIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="#CB333B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.625 4.375l-11.25 11.25m11.25 0L4.375 4.375"></path>
    </svg>
  );
}

export function FilterIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13.875 16.125H3.75M20.25 16.125h-2.625M15.75 18a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75zM7.875 7.875H3.75M20.25 7.875h-8.625M9.75 9.75a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z"></path>
    </svg>
  );
}

export function CheckboxCheckedIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#00A1E0"
        d="M16.25 2.5H3.75A1.25 1.25 0 002.5 3.75v12.5a1.25 1.25 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25V3.75a1.25 1.25 0 00-1.25-1.25zm-2.383 6.078L9.29 12.953a.633.633 0 01-.867 0l-2.29-2.187a.625.625 0 11.86-.907l1.86 1.774 4.156-3.961a.625.625 0 01.86.906z"></path>
    </svg>
  );
}

export function CheckboxEmptyIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.25 3.125H3.75a.625.625 0 00-.625.625v12.5c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V3.75a.625.625 0 00-.625-.625z"></path>
    </svg>
  );
}

export function VDBIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18">
      <path
        fill="#24C1FF"
        d="M10.024 10.062c4.28-3.71 1.366-8.275 1.366-8.275s-.392 3.531-3.414 6.15c-4.28 3.71-1.367 8.275-1.367 8.275s.392-3.53 3.415-6.15zM14.175 12.896c3.551-3.077 1.134-6.865 1.134-6.865s-.325 2.93-2.833 5.103c-3.55 3.077-1.134 6.865-1.134 6.865s.326-2.93 2.833-5.103zM5.525 6.865C9.075 3.788 6.659 0 6.659 0s-.326 2.93-2.833 5.103c-3.55 3.077-1.134 6.865-1.134 6.865s.326-2.93 2.833-5.103z"></path>
    </svg>
  );
}

export function ModelsIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18">
      <path
        fill="#E3CC00"
        d="M9.185 1.884a.642.642 0 00-.638.003l-5.13 2.962c-.034.019-.035.066-.002.086L8.88 8.089c.015.01.032.008.047-.001L14.39 4.92a.05.05 0 000-.087L9.184 1.884zM2.7 12.016c0 .23.122.442.32.556l5.165 2.982a.05.05 0 00.075-.043V9.245a.05.05 0 00-.025-.043L2.775 6.05a.05.05 0 00-.076.043v5.924zM15.106 12.017v-5.94a.05.05 0 00-.075-.043L9.57 9.2a.05.05 0 00-.025.044v6.266a.05.05 0 00.075.044l5.165-2.982a.642.642 0 00.32-.556z"></path>
    </svg>
  );
}

export function MotionIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18">
      <g clipPath="url(#clip0_9284_141354)">
        <path
          fill="#00B74F"
          d="M17.333 9A8.315 8.315 0 008.999.665c-.975 0-1.916.158-2.816.467l.583 1.616a5.961 5.961 0 012.233-.441c3.675 0 6.692 3.016 6.692 6.691s-3.017 6.692-6.692 6.692c-3.675 0-6.691-3.017-6.691-6.692a6.1 6.1 0 01.441-2.266l-1.616-.55a8.645 8.645 0 00-.467 2.816 8.315 8.315 0 008.333 8.334 8.315 8.315 0 008.334-8.334zM3.558 2.307c.708 0 1.275.591 1.275 1.25a1.27 1.27 0 01-1.275 1.275c-.659 0-1.25-.567-1.25-1.275 0-.659.591-1.25 1.25-1.25zm10.441 6.691c0-2.775-2.225-5-5-5S4 6.224 4 9s2.225 5 5 5 5-2.225 5-5zm-2.5 0l-4.166 2.5v-5"></path>
      </g>
      <defs>
        <clipPath id="clip0_9284_141354">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

////// NEW CATEGORY ICONS FOR LEFT NAVBAR FILTER ICONS //////

export const AllCollectionsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18">
      <path
        // fill="#FFFF"
        fillRule="evenodd"
        d="M7.975.898a2.292 2.292 0 012.05 0l6.097 3.049c1.075.537 1.075 2.071 0 2.609l-6.097 3.048a2.292 2.292 0 01-2.05 0L1.878 6.556c-1.075-.538-1.075-2.072 0-2.61L7.975.899zM.93 13.332a.625.625 0 01.825-.317l6.823 3.032c.27.12.577.12.846 0l6.823-3.032a.625.625 0 11.508 1.142L9.93 17.19a2.291 2.291 0 01-1.862 0l-6.823-3.033a.625.625 0 01-.317-.825zm.825-4.067a.625.625 0 00-.508 1.142L8.07 13.44a2.291 2.291 0 001.862 0l6.823-3.033a.625.625 0 10-.508-1.142l-6.823 3.032c-.27.12-.577.12-.846 0L1.754 9.265z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const NewReleasesIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        // stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.833 2.5l-6.609 8.078c-.284.348-.427.522-.428.668a.417.417 0 00.156.329c.114.092.339.092.788.092H10L9.167 17.5l6.609-8.078c.284-.348.427-.522.428-.668a.417.417 0 00-.156-.329c-.114-.092-.339-.092-.788-.092H10l.833-5.833z"></path>
    </svg>
  );
};
export const EssentialsCategoryIconThin: React.FC<IconProps> = (props) => {
  return (
    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" cy-test-id="essentials-category-icon">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8238 7.24002L16.5575 9.60154C15.9221 10.6979 15.0554 10.8076 13.3939 10.7962C11.5143 10.7947 10.9001 10.7966 9.02028 10.7966H8.6858C8.35633 10.806 8.09214 11.0071 8.04566 11.3234L8.04694 13.0205C8.09258 13.2938 8.3017 13.4794 8.57399 13.5259L21 13.5261L19.7267 15.9005C19.0917 16.9968 18.225 17.0881 16.563 17.0769L5.64566 17.076C4.93705 17.0631 4.37848 16.6011 4.35384 15.8857C4.35384 14.3617 4.34555 12.8375 4.34756 11.3137C4.2972 11.0045 4.03758 10.8071 3.71424 10.795L0 10.7928L1.26677 8.43073C1.80094 7.50834 2.49984 7.28224 3.69726 7.24086L17.8238 7.24002Z"
        fill={props.fill || '#f5f5f5'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.34999 4.47441L4.34958 2.21007C4.32574 1.44042 4.90216 0.937797 5.6417 0.923828L20.996 0.924214L19.7227 3.29865C19.0877 4.39488 18.221 4.48606 16.5591 4.47483L4.34999 4.47441Z"
        fill={props.fill || '#f5f5f5'}
      />
    </svg>
  );
}
export const EssentialsCategoryIconThinPlanVariant: React.FC<IconProps> = (props) => {
  return (
    <svg {...props} width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" cy-test-id="essentials-category-icon">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8238 7.24002L16.5575 9.60154C15.9221 10.6979 15.0554 10.8076 13.3939 10.7962C11.5143 10.7947 10.9001 10.7966 9.02028 10.7966H8.6858C8.35633 10.806 8.09214 11.0071 8.04566 11.3234L8.04694 13.0205C8.09258 13.2938 8.3017 13.4794 8.57399 13.5259L21 13.5261L19.7267 15.9005C19.0917 16.9968 18.225 17.0881 16.563 17.0769L5.64566 17.076C4.93705 17.0631 4.37848 16.6011 4.35384 15.8857C4.35384 14.3617 4.34555 12.8375 4.34756 11.3137C4.2972 11.0045 4.03758 10.8071 3.71424 10.795L0 10.7928L1.26677 8.43073C1.80094 7.50834 2.49984 7.28224 3.69726 7.24086L17.8238 7.24002Z"
        // fill={props.fill || '#f5f5f5'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.34999 4.47441L4.34958 2.21007C4.32574 1.44042 4.90216 0.937797 5.6417 0.923828L20.996 0.924214L19.7227 3.29865C19.0877 4.39488 18.221 4.48606 16.5591 4.47483L4.34999 4.47441Z"
        // fill={props.fill || '#f5f5f5'}
      />
    </svg>
  );
}
export const EssentialsCategoryIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      cy-test-id="essentials-category-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill={props.fill || 'none'}
      viewBox="0 0 21 20">
      <path
        stroke={props.stroke || ''}
        strokeWidth="1.2"
        d="M16.32 8.49l-1.088 2.03c-.546.942-1.29 1.037-2.719 1.027-1.616-.002-2.143 0-3.76 0h-.287c-.283.008-.51.18-.55.453l.001 1.459c.04.235.219.394.453.434h10.681l-1.094 2.041c-.546.943-1.291 1.021-2.72 1.011H5.853c-.61-.011-1.09-.409-1.11-1.024 0-1.31-.008-2.62-.006-3.93-.043-.265-.266-.435-.544-.445L1 11.544l1.089-2.03c.459-.794 1.06-.988 2.09-1.023L16.32 8.49zM4.74 6.113l-.001-1.947c-.02-.661.475-1.093 1.11-1.105h13.199L17.953 5.1c-.546.943-1.29 1.022-2.72 1.012H4.74z"
        clipRule="evenodd"></path>
    </svg>
  );
};
export const EssentialsCategoryPageIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="400"
      height="57"
      fill="none"
      viewBox="0 0 400 57">
      <g fillRule="evenodd" clipPath="url(#clip0_15439_59380)" clipRule="evenodd">
        <path fill="#F5F5F5" d="M.067.507h399.396v56.329H.067V.506z"></path>
        <path
          fill="#252B2D"
          d="M65.398 21.146l.003 3.083c.06.634.558 1.041 1.188 1.067l20.935.026c1.382.026 2.46.984 2.414 2.452l.001 13.856c.045 1.469-1.033 2.427-2.415 2.453l-32.016.007 2.367-4.505c1.187-2.092 2.807-2.279 5.913-2.257l18.315.003c.494-.123.857-.508.9-1.056l-.004-3.137c-.06-.634-.56-1.041-1.188-1.066l-20.943-.008c-1.382-.026-2.46-.985-2.414-2.453V15.716c-.045-1.469 1.032-2.427 2.414-2.454l29.073-.006-2.367 4.505c-1.187 2.091-2.807 2.3-5.912 2.278l-15.27.031c-.542.096-.95.494-.993 1.076zM328.608 37.328c5.488.002 17.372.004 20.54.008l-2.367 4.484c-1.187 2.083-2.807 2.29-5.913 2.269l-17.956-.007c-1.381-.026-2.459-.98-2.414-2.442V15.706c-.045-1.462 1.033-2.416 2.414-2.443l4.505-.007c.018 7.594.01 15.358.006 22.948.034.664.539 1.095 1.185 1.124zM255.497 13.279l-2.38 4.512c-1.193 2.094-2.822 2.304-5.944 2.282-2.478-.01-4.958-.016-7.437-.019-.624.042-1.113.462-1.157 1.105.009 6.832.004 13.652.004 20.467.044 1.47-1.039 2.43-2.428 2.457l-4.53.007c-.017-7.422.024-14.813.031-22.256v-.57c0-.702-.503-1.191-1.217-1.213-4.558.002-9.118.004-13.676 0l2.38-4.512c1.193-2.094 2.822-2.303 5.944-2.282 10.135.04 20.274.012 30.41.022zM269.636 41.625c.045 1.471-1.039 2.431-2.428 2.458l-4.53.007c-.021-9.465-.004-18.902-.004-28.37-.045-1.47 1.038-2.43 2.428-2.457l4.53-.008c.021 9.466.004 18.903.004 28.37zM295.064 25.774c-.231.011-.561-.037-1.114.86l-7.376 13.092c-1.396 2.633-3.418 4.428-6.044 4.361l-4.492.003 16.845-29.052c.31-.527.907-1.84 2.181-1.78 1.274-.06 1.87 1.253 2.182 1.78L314.09 44.09l-4.492-.003c-2.626.066-4.649-1.728-6.044-4.361l-7.377-13.093c-.553-.896-.881-.848-1.113-.859zM179.72 44.09l4.529-.008c1.39-.026 2.474-.985 2.429-2.455v-14.97c.057-.696.613-1.038 1.313-.516l17.455 17.036c.892.937 2.138.913 3.331.913h2.561c.009-8.389.05-22.956.032-30.834l-4.53.008c-1.389.026-2.473.985-2.428 2.455v15.02c-.079.668-.631.982-1.32.459L186.09 14.661c-1.288-1.252-1.953-1.405-3.778-1.405h-2.56c-.009 8.389-.05 22.955-.032 30.833zM46.565 25.293l-2.38 4.512c-1.193 2.095-2.822 2.305-5.943 2.283-3.532-.003-4.686 0-8.218 0h-.629c-.619.019-1.115.403-1.203 1.007l.003 3.243c.085.522.479.877.99.965l23.348.001-2.392 4.537c-1.193 2.094-2.822 2.269-5.945 2.247l-20.513-.001c-1.332-.025-2.381-.908-2.427-2.275 0-2.911-.016-5.824-.012-8.735-.095-.591-.583-.968-1.19-.991h-.64l-6.34-.004 2.38-4.514c1.005-1.762 2.318-2.194 4.568-2.273l26.543-.002zM21.252 20.04v-4.326c-.046-1.47 1.038-2.43 2.427-2.457h28.85l-2.392 4.537c-1.193 2.095-2.821 2.269-5.944 2.247h-22.94zM105.694 21.146l.003 3.083c.059.634.558 1.041 1.188 1.067l20.934.026c1.382.026 2.46.984 2.415 2.452l.001 13.856c.045 1.469-1.033 2.427-2.415 2.453l-32.016.007 2.367-4.505c1.187-2.092 2.807-2.279 5.912-2.257l18.315.003c.495-.123.858-.508.899-1.056l-.002-3.137c-.061-.634-.56-1.041-1.188-1.066l-20.943-.008c-1.382-.026-2.46-.985-2.415-2.453V15.716c-.044-1.469 1.033-2.427 2.415-2.454l29.072-.006-2.366 4.505c-1.187 2.091-2.807 2.3-5.913 2.278l-15.27.031c-.542.096-.949.494-.993 1.076zM168.3 25.293l-2.379 4.512c-1.193 2.095-2.823 2.305-5.944 2.283-3.532-.003-4.686 0-8.218 0h-.629c-.618.019-1.115.403-1.202 1.007l.002 3.243c.086.522.479.877.991.965l23.348.001-2.393 4.537c-1.193 2.094-2.822 2.269-5.944 2.247l-20.514-.001c-1.331-.025-2.381-.908-2.427-2.275 0-2.911-.016-5.824-.012-8.735-.095-.591-.583-.968-1.19-.991h-.64l-6.339-.004 2.38-4.514c1.004-1.762 2.317-2.194 4.567-2.273l26.543-.002zM142.999 20.04l-.001-4.326c-.045-1.47 1.038-2.43 2.427-2.457h28.851l-2.392 4.537c-1.193 2.095-2.822 2.269-5.945 2.247h-22.94zM361.916 21.146l.002 3.083c.06.634.559 1.041 1.188 1.067l20.935.026c1.382.026 2.459.984 2.415 2.452V41.63c.046 1.469-1.032 2.427-2.414 2.453l-32.017.007 2.367-4.505c1.187-2.092 2.808-2.279 5.913-2.257l18.315.003a1.15 1.15 0 00.899-1.056l-.003-3.137c-.06-.634-.559-1.041-1.187-1.066l-20.944-.008c-1.382-.026-2.459-.985-2.414-2.453V15.716c-.045-1.469 1.032-2.427 2.414-2.454l29.073-.006-2.367 4.505c-1.187 2.091-2.807 2.3-5.912 2.278l-15.27.031c-.542.096-.949.494-.993 1.076z"></path>
      </g>
      <defs>
        <clipPath id="clip0_15439_59380">
          <rect width="400" height="57" fill="#fff" rx="5"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};
export const EssentialsFilterIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="146"
      height="12"
      fill="none"
      viewBox="0 0 146 12"
    >
      <path
        fill="#7F898D"
        fillRule="evenodd"
        d="M20.363 3.07v1.2c.024.247.218.406.463.416l8.147.01c.538.01.958.383.94.954v5.393c.018.571-.401.944-.94.954L16.514 12l.922-1.753c.462-.814 1.092-.887 2.3-.878h7.129a.447.447 0 00.35-.41l-.002-1.221c-.023-.247-.217-.405-.462-.415L18.6 7.32c-.538-.01-.957-.383-.94-.955V.958c-.017-.572.402-.945.94-.955L29.914 0l-.92 1.753c-.463.814-1.093.896-2.302.887l-5.943.012a.45.45 0 00-.386.419zM122.798 9.368l7.993.003-.921 1.746c-.462.81-1.093.89-2.301.882l-6.988-.002c-.538-.01-.957-.381-.94-.95V.954c-.017-.57.402-.94.94-.95L122.334 0c.007 2.956.004 5.977.002 8.931.014.258.21.426.462.437zM94.346.01l-.926 1.755c-.465.815-1.099.897-2.314.888-.964-.003-1.93-.006-2.894-.007-.243.016-.433.18-.45.43.003 2.659.001 5.313.001 7.965.017.572-.404.946-.945.956L85.055 12c-.006-2.889.01-5.765.012-8.661v-.222c0-.273-.195-.464-.473-.472h-5.322l.925-1.756c.465-.815 1.099-.897 2.314-.888 3.944.015 7.89.004 11.835.008zM99.847 11.04c.017.573-.404.947-.945.957L97.139 12c-.008-3.684-.002-7.356-.002-11.04-.017-.573.404-.947.945-.957L99.845 0c.008 3.684.002 7.356.002 11.04zM109.742 4.872c-.09.004-.218-.015-.433.334l-2.871 5.096c-.543 1.025-1.33 1.723-2.352 1.697l-1.748.001L108.893.694c.121-.205.353-.716.849-.693.496-.023.728.488.849.693L117.147 12h-1.749c-1.021.025-1.809-.673-2.351-1.698l-2.871-5.096c-.216-.349-.344-.33-.434-.334zM64.853 12l1.763-.003c.541-.01.963-.383.945-.956V5.215c.022-.27.239-.404.511-.2l6.793 6.63c.347.365.833.355 1.297.355h.996c.004-3.265.02-8.934.013-12l-1.763.003c-.54.01-.963.384-.945.956v5.845c-.03.26-.246.382-.514.179L67.332.547c-.5-.487-.76-.547-1.47-.547h-.996c-.004 3.265-.02 8.934-.013 12zM13.034 4.685l-.926 1.756c-.465.815-1.099.897-2.314.888H6.352c-.241.007-.435.157-.469.392l.001 1.262a.453.453 0 00.386.376h9.086l-.93 1.766c-.465.815-1.099.883-2.314.874H4.128c-.518-.01-.926-.353-.944-.885 0-1.134-.006-2.267-.005-3.4-.037-.23-.226-.377-.463-.386h-.249L0 7.327.926 5.57c.391-.686.902-.854 1.778-.884l10.33-.001zM3.182 2.64V.958c-.017-.572.404-.946.945-.956h11.228l-.931 1.765c-.464.816-1.098.883-2.314.875H3.182zM36.044 3.07l.001 1.2c.024.247.218.406.463.416l8.147.01c.538.01.957.383.94.954v5.393c.018.571-.402.944-.94.954L32.195 12l.922-1.753c.462-.814 1.092-.887 2.3-.878h7.128a.447.447 0 00.35-.41V7.738c-.024-.247-.219-.405-.463-.415l-8.15-.003c-.538-.01-.958-.383-.94-.955V.958c-.018-.572.401-.945.94-.955L45.595 0l-.921 1.753c-.462.814-1.093.896-2.301.887l-5.943.012a.45.45 0 00-.387.419zM60.41 4.685l-.925 1.756c-.465.815-1.099.897-2.314.888h-3.443c-.24.007-.434.157-.468.392l.001 1.262a.453.453 0 00.386.376h9.086l-.93 1.766c-.465.815-1.099.883-2.314.874h-7.984c-.518-.01-.926-.353-.944-.885 0-1.134-.007-2.267-.005-3.4-.037-.23-.227-.377-.463-.386h-.249l-2.467-.001.926-1.757c.39-.686.902-.854 1.778-.884l10.33-.001zM50.563 2.64V.958c-.018-.572.404-.946.945-.956h11.228l-.931 1.765c-.465.816-1.099.883-2.314.875h-8.928zM135.761 3.07l.001 1.2c.023.247.218.406.462.416l8.148.01c.538.01.957.383.939.954l.001 5.393c.017.571-.402.944-.94.954l-12.46.003.921-1.753c.462-.814 1.093-.887 2.301-.878h7.128a.447.447 0 00.35-.41l-.001-1.221c-.024-.247-.218-.405-.462-.415l-8.151-.003c-.538-.01-.957-.383-.94-.955V.958c-.017-.572.402-.945.94-.955L145.312 0l-.921 1.753c-.462.814-1.092.896-2.301.887l-5.942.012a.45.45 0 00-.387.419z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const AnimalsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      stroke="none"
      viewBox="0 0 21 20">
      <path fill="currentColor" d="M13.813 6.25a.937.937 0 100-1.875.937.937 0 000 1.875z"></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.375 10.625l-3.125 3.75"></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.25 7.501v1.875a7.5 7.5 0 01-7.5 7.5H1.625l7.5-9.375V5.939a4.063 4.063 0 017.992-1.024l2.008 1.336-1.875 1.25z"></path>
    </svg>
  );
};

export const BloodGoreIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.313 11.313L25 18s-9 12-22 9L24.738 4.738a2.492 2.492 0 113.524 3.525l-6.287 6.712"></path>
    </svg>
  );
};

export const GunFXIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32">
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M8.873 27.88l3.927-1.2-.932-11.684a1.483 1.483 0 011.046-1.537L29.328 8.44l-1.572-5.142-20.215 6.18.325 1.064v0c.372 1.217-.243 1.453-.618.237a17.446 17.446 0 01-.014-.043L6.91 9.671.98 11.484l.975 3.187c.142.464.601.743 1.084.8a3.494 3.494 0 013.08 3.3l.36 7.425a1.854 1.854 0 002.394 1.684z"></path>
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M12.154 18.54l-.229-3.738c-.037-.599.342-1.145.916-1.32l4.962-1.518-.164 3.36a2.225 2.225 0 01-1.572 2.019l-3.913 1.196z"></path>
    </svg>
  );
};

export const DebrisIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M18 11s0-3 3-3 3-3 3-3M6.436 10.698s2.932-.63 3.563 2.302c.631 2.933 3.564 2.302 3.564 2.302M12.8 24.8l-5.6-5.6M13 2v3m11 13l2 2m0-8l3-1m-11.347 5.103l2.148 9.231"></path>
    </svg>
  );
};

export const SoundFXIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2 16.903h5.476l2.314-5.87 3.275 12.25L17.355 2l3.048 27.379 3.049-12.476H30"></path>
    </svg>
  );
};

export const GlassIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M12.265 23.88l-6.528 2.79 3.317 3.461 3.211-6.251zM13 8L9.48 1 5 2.902 13 8zM16 31l9-.129L16.553 21 16 31zM10.062 14.267L15 12.387 4.52 11 2 16.742h5.24L4.42 21l5.542-.495 2.62-1.98-2.519-4.258zM17 6.25L20.386 1l1.185 4.487-4.063 3.217L17 6.249zM20 18l5.142 5L29 19.25 20 18zM29.898 10.52l-1.704-5.095L18 14.843l11.898-4.323z"></path>
    </svg>
  );
};

export const LightingIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#clip0_17339_67569)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
          d="M18.334 10h.833m-9.166-8.333V.834m0 18.333v-.833m6.666-1.667l-.833-.833m.833-12.5l-.833.833m-12.5 12.5l.833-.833m-.833-12.5l.833.833M.834 10.001h.833m8.334 5a5 5 0 100-10 5 5 0 000 10z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_17339_67569">
          <path fill="#fff" d="M0 0H20V20H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const FireIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M19.32 28.75c.978-2.019 2.143-5.458.515-6.94-1.501.232-2.715.234-3.702.005-2.487-.577-3.274-2.61-2.59-5.215-3.345 3.156-3.487 7.81-2.246 12.291.201.728-.588 1.325-1.2.904C9.89 29.652 5 26.226 5 20.952c0-8.642 9.49-9.014 9.49-18.07 0-.692.786-1.07 1.3-.626 3.792 3.284 10.693 11.178 10.306 18.439-.192 3.6-2.086 6.661-5.63 9.1-.67.461-1.508-.299-1.146-1.045z"></path>
    </svg>
  );
};

export const ElectricityIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.5 18.75l1.25-6.25-5-1.875L12.5 1.25 11.25 7.5l5 1.875L7.5 18.75z"></path>
    </svg>
  );
};

export const PlantsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      stroke="none"
      viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M19.347 3.116a.625.625 0 00-.588-.588c-4.043-.234-7.29.996-8.686 3.299-.921 1.522-.92 3.372-.012 5.136a5.574 5.574 0 00-1.107 2.11l-1.271-1.277c.61-1.275.587-2.605-.078-3.71-1.032-1.702-3.412-2.615-6.368-2.441a.625.625 0 00-.587.587c-.174 2.956.74 5.336 2.441 6.367a3.579 3.579 0 001.866.525 4.263 4.263 0 001.84-.443l1.954 1.954v2.24a.625.625 0 101.25 0V14.57a4.344 4.344 0 01.958-2.734c.804.42 1.696.645 2.603.656a4.758 4.758 0 002.486-.692c2.304-1.394 3.536-4.64 3.299-8.684zM3.736 11.53c-1.199-.726-1.877-2.444-1.86-4.657 2.212-.018 3.93.662 4.656 1.86.379.626.44 1.354.192 2.105L4.817 8.932a.625.625 0 00-.883.884l1.907 1.907c-.751.248-1.48.187-2.105-.192zm11.665-.799c-1.047.634-2.278.682-3.528.157l4.195-4.196a.625.625 0 00-.884-.883L10.99 10c-.528-1.25-.48-2.482.156-3.528 1.09-1.797 3.672-2.798 6.98-2.721.074 3.306-.926 5.892-2.724 6.981z"></path>
    </svg>
  );
};

export const SlimeIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M15.92 8.15l-.027.5h.028v-.5zm-1.864 2.901l-.429.258.429-.258zm-4.351 2.28l.441-.236-.052-.098-.09-.066-.3.4zm-1.658 1.45l-.464-.186.464.186zM2.66 12.71l-.4-.3-.011.015-.01.017.421.268zm2.901-3.108l-.32.384.32-.384zm-2.9-2.9l-.469-.176.468.175zm5.594-2.072l-.103.489a.5.5 0 00.602-.506l-.5.017zm5.8-1.658l-.353-.354.354.354zm4.145.207l-.4.3.4-.3zm-2.252 4.473c-.347-.019-.757 0-1.157.085-.395.084-.818.241-1.152.526-.35.298-.585.721-.596 1.268-.01.523.185 1.114.584 1.779l.858-.515c-.347-.579-.447-.98-.442-1.245a.66.66 0 01.244-.526c.162-.138.408-.244.712-.309.3-.064.62-.08.894-.064l.055-.999zm-2.32 3.658c.903 1.506.979 2.391.828 2.92-.151.528-.569.858-1.072 1.16l.515.857c.533-.32 1.255-.82 1.518-1.742.264-.921.028-2.109-.932-3.71l-.858.514zm-.244 4.08c-.435.26-.82.345-1.261.133-.499-.24-1.16-.896-1.977-2.427l-.882.471c.841 1.578 1.63 2.475 2.426 2.857.854.41 1.608.183 2.209-.177l-.515-.858zm-3.38-2.458c-.314-.236-.786-.28-1.243-.001-.431.263-.83.794-1.178 1.665l.929.372c.314-.787.607-1.084.77-1.184.136-.083.161-.024.123-.052l.6-.8zm-2.421 1.664c-.353.884-1.117 1.526-1.934 1.876a3.488 3.488 0 01-1.155.288c-.354.02-.605-.042-.748-.128l-.514.858c.375.225.85.294 1.317.268a4.482 4.482 0 001.494-.367c.995-.426 1.993-1.234 2.469-2.423l-.929-.372zm-3.837 2.036c-.458-.274-.926-.713-1.133-1.293-.198-.553-.19-1.325.469-2.36l-.844-.537c-.791 1.244-.887 2.336-.567 3.233.311.871.983 1.468 1.56 1.815l.515-.858zM3.06 13.01c.126-.168.764-.749 2-1.058l-.242-.97c-1.415.354-2.27 1.043-2.558 1.428l.8.6zm2-1.058c.422-.105.745-.307.96-.59.214-.28.29-.596.3-.875a2.069 2.069 0 00-.24-1.016.9.9 0 00-.199-.253l-.64.768c-.048-.04-.055-.066-.034-.028a1.071 1.071 0 01.113.495.514.514 0 01-.094.302c-.055.072-.166.167-.408.227l.243.97zm.821-2.734c-.344-.287-.743-.532-1.114-.75-.385-.227-.73-.418-1.028-.62-.3-.205-.487-.38-.58-.536-.076-.126-.1-.25-.03-.435l-.937-.351c-.179.478-.12.919.108 1.3.209.348.545.622.877.848.334.227.73.448 1.083.655.367.216.704.426.981.657l.64-.768zM3.13 6.877c.295-.789.65-1.368 1.309-1.698.679-.34 1.787-.467 3.714-.061l.206-.979c-2.01-.423-3.389-.343-4.367.146-.999.5-1.473 1.37-1.799 2.24l.937.351zm5.625-2.265c-.026-.807.443-1.257.913-1.344.446-.082 1.083.138 1.432 1.114l.942-.336c-.48-1.345-1.535-1.95-2.556-1.761-.997.184-1.772 1.101-1.73 2.36l1-.033zm2.345-.23c.112.313.236.573.38.771.144.198.34.375.602.44a.91.91 0 00.696-.122c.174-.105.322-.255.443-.4.24-.287.471-.675.667-.995.214-.35.381-.61.522-.752l-.707-.707c-.242.243-.474.62-.668.937-.213.349-.4.659-.582.876a.884.884 0 01-.192.185c-.03.019 0-.008.06.006.05.013.033.034-.033-.057a2.12 2.12 0 01-.246-.518l-.942.336zm3.31-1.058c.367-.367.934-.735 1.532-.81.552-.069 1.21.1 1.86.964l.8-.6c-.844-1.124-1.843-1.474-2.783-1.356-.894.111-1.653.633-2.116 1.095l.707.707zm3.391.154c.835 1.113.838 2.15.45 2.885-.398.753-1.253 1.288-2.33 1.288v1c1.41 0 2.627-.709 3.214-1.82.596-1.13.496-2.58-.534-3.953l-.8.6z"></path>
    </svg>
  );
};

export const LandscapesIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 256 256">
      <path
        fill="currentColor"
        d="M164 80a28 28 0 1 0-28-28a28 28 0 0 0 28 28m0-40a12 12 0 1 1-12 12a12 12 0 0 1 12-12m90.88 155.92l-54.56-92.08A15.87 15.87 0 0 0 186.55 96a15.85 15.85 0 0 0-13.76 7.84L146.63 148l-44.84-76.1a16 16 0 0 0-27.58 0L1.11 195.94A8 8 0 0 0 8 208h240a8 8 0 0 0 6.88-12.08M88 80l23.57 40H64.43ZM22 192l33-56h66l18.74 31.8L154 192Zm150.57 0l-16.66-28.28L186.55 112L234 192Z"></path>
    </svg>
  );
};

export const SpaceIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      stroke="none"
      viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M19.15 4.74c-.598-1.03-2.176-1.262-4.571-.676A7.495 7.495 0 002.56 10.96C.398 13.203.429 14.531.85 15.26c.399.69 1.23.99 2.324.99a9.701 9.701 0 002.25-.312A7.495 7.495 0 0017.44 9.043c.976-1.016 1.626-1.98 1.848-2.807.152-.571.106-1.075-.139-1.496zM10 3.75a6.259 6.259 0 016.094 4.859c-1.333 1.255-3.137 2.541-4.85 3.526-2.152 1.235-4.019 2.005-5.508 2.427A6.245 6.245 0 0110 3.75zM1.933 14.632c-.114-.196-.051-.566.173-1.016.222-.422.492-.816.804-1.176a7.5 7.5 0 001.406 2.447c-1.347.227-2.188.082-2.383-.255zM10 16.25a6.208 6.208 0 01-3.013-.777 28.902 28.902 0 004.878-2.255c1.686-.968 3.178-2.017 4.38-3.053A6.255 6.255 0 0110 16.25zm8.08-10.337c-.133.493-.484 1.057-.987 1.65a7.476 7.476 0 00-1.406-2.449c1.11-.183 2.138-.169 2.383.254.07.122.074.306.01.545z"></path>
    </svg>
  );
};

export const TexturesIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      stroke="none"
      viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M3.73 17.438c-.265-.056-.511-.198-.74-.427-.23-.23-.372-.476-.428-.74L16.271 2.562c.291.07.541.212.75.427.208.216.354.462.437.74L3.73 17.438zM2.5 12.25V9.917L9.917 2.5h2.333L2.5 12.25zm0-6.417V4.167c0-.459.163-.851.49-1.178.326-.326.718-.489 1.177-.489h1.666L2.5 5.833zM14.167 17.5l3.333-3.333v1.666c0 .459-.163.851-.49 1.178-.326.326-.718.489-1.177.489h-1.666zm-6.417 0l9.75-9.75v2.333L10.083 17.5H7.75z"></path>
    </svg>
  );
};

export const NewVarietyPackIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      stroke="none"
      viewBox="0 0 20 20">
      <g clipPath="url(#clip0_4995_105844)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M6 3.5V6H3.5A1.5 1.5 0 002 7.5v8A1.5 1.5 0 003.5 17h8a1.5 1.5 0 001.5-1.5V13h2.5a1.5 1.5 0 001.5-1.5v-8A1.5 1.5 0 0015.5 2h-8A1.5 1.5 0 006 3.5zM7.5 3a.5.5 0 00-.5.5V6h4.5A1.5 1.5 0 0113 7.5V12h2.5a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-8zm0 10A1.5 1.5 0 016 11.5V7H3.5a.5.5 0 00-.5.5v8a.5.5 0 00.5.5h8a.5.5 0 00.5-.5V13H7.5z"
          clipRule="evenodd"></path>
      </g>
      <defs>
        <clipPath id="clip0_4995_105844">
          <path
            fill="currentColor"
            d="M0 0H15V15H0z"
            transform="translate(2 2)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const EnergyFXIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      stroke="none">
      <path
        fill="currentColor"
        d="M14.497.407c-.337.002-.678.02-1.024.055 3.103.938 5.758 2.921 7.704 5.417-4.635-4.49-12.8-5.241-17.423.393 1.972-1.057 4.176-1.605 6.4-1.742C4.296 6.427-.718 13.123.368 20.46c.318-3.003 1.804-5.595 3.836-7.745-2.391 4.642-2.014 10.713 2.54 14.449-1.588-2.964-2.068-6.4-1.596-9.646-.081 6.568 5.218 13.144 12.599 12.416-3.104-.938-5.758-2.922-7.704-5.418 4.857 4.105 12.385 4.18 17.423-.393-7.417 2.797-13.419 1.329-17.016-1.737-3.7-2.547-4.882-7.567-2.598-11.522a8.689 8.689 0 011.497-1.917c.174-.198.353-.387.538-.567.144-.081.289-.16.433-.239a8.76 8.76 0 015.307-1.627 8.655 8.655 0 014.118 1.163 8.709 8.709 0 014.35 7.427 3.834 3.834 0 11-7.595.356 2.833 2.833 0 102.764-3.623 5.793 5.793 0 10-.754 11.505l-.032.012c.258-.012.515-.033.771-.064 3.287-.056 7.71-1.622 9.631-4.482-1.144.53-2.23.912-3.28 1.048.404-.472.77-.976 1.092-1.508 2.26-2.795 4.042-7.047 3.362-10.513-.45 1.227-.96 2.316-1.602 3.224-.2-2.907-1.455-5.76-3.976-7.827 1.588 2.963 2.067 6.4 1.596 9.646C26.149 6.617 21.339.35 14.497.407z"></path>
    </svg>
  );
};

export const WeatherIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16 30l3.288-5m-6.95 1l3.95-6M11 11.5a8.5 8.5 0 118.5 8.5h-10a5.5 5.5 0 111.787-10.7"></path>
    </svg>
  );
};

export const ParticlesIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22 2v6m3-3h-6m9 4v4m2-2h-4m-8.662 10.938l-2.4 6.512a1 1 0 01-1.875 0l-2.4-6.512a1.013 1.013 0 00-.6-.6l-6.513-2.4a1 1 0 010-1.875l6.513-2.4a1.012 1.012 0 00.6-.6l2.4-6.513a1 1 0 011.875 0l2.4 6.513a1.011 1.011 0 00.6.6l6.513 2.4a1 1 0 010 1.875l-6.513 2.4a1.011 1.011 0 00-.6.6z"></path>
    </svg>
  );
};

export const PeopleIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M30.5 17.5a7.475 7.475 0 00-6-3 4 4 0 10-3.925-4.75M1.5 17.5a7.476 7.476 0 016-3 4 4 0 113.925-4.75M8.8 27a8.012 8.012 0 0114.4 0M21 17.5a5 5 0 11-10 0 5 5 0 0110 0z"></path>
    </svg>
  );
};

export const SmokeIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.75 28.25s-4-3.5 0-9.5 0-9 0-9m13 18.5s-4-3.5 0-9.5 0-9 0-9m-6 18s-4-5 0-11-1-14-1-14"></path>
    </svg>
  );
};

export const SoundIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2 16.903h5.476l2.314-5.87 3.275 12.25L17.355 2l3.048 27.379 3.049-12.476H30"></path>
    </svg>
  );
};

export const WaterIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5 9s5-4 11 0 11 0 11 0M5 16s5-4 11 0 11 0 11 0M5 23s5-4 11 0 11 0 11 0"></path>
    </svg>
  );
};

export const MilitaryIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g id="Group" fill="currentColor">
        <path
          id="Vector"
          d="M8.913 1.563a.09.09 0 0 1 .173 0l.247.76a.09.09 0 0 0 .086.063h.8c.087 0 .123.113.052.164l-.646.47a.09.09 0 0 0-.033.101l.247.76a.09.09 0 0 1-.14.102l-.646-.47a.09.09 0 0 0-.107 0l-.647.47a.09.09 0 0 1-.14-.101l.248-.76a.09.09 0 0 0-.033-.102l-.647-.47a.09.09 0 0 1 .054-.164h.799a.09.09 0 0 0 .086-.062z"
        ></path>
        <path
          id="Vector_2"
          fillRule="evenodd"
          d="M5.011 6.698q-.412.125-.85.275a.5.5 0 0 1-.52-.821l.004-.005a3.671 3.671 0 0 0 .352-.455c.192-.296.336-.624.336-.907C4.333 2.157 6.41 0 9 0s4.666 2.156 4.666 4.786c0 .282.145.61.337.907q.149.229.331.433l.004.003.017.019.003.004a.5.5 0 0 1-.52.821q-.436-.15-.85-.275Q13 6.848 13 7a4 4 0 1 1-7.989-.302m.322-1.913C5.333 2.682 6.988 1 9 1s3.666 1.682 3.666 3.786c0 .293.071.575.17.826-1.188-.333-2.282-.525-3.37-.567a12 12 0 0 0-1.092.007c-1.035.054-2.08.243-3.211.56a2.3 2.3 0 0 0 .17-.827m.724 1.627a3 3 0 1 0 5.885 0 13 13 0 0 0-2.294-.357 11 11 0 0 0-1.209-.005c-.765.039-1.545.159-2.382.362M14.5 9 17 7.572V1.5h1V13l-3.5-1.5zm2.5-.277-1.5.857v1.26l1.5.643z"
          clipRule="evenodd"
        ></path>
        <path
          id="Vector_3"
          d="M3.071 11.669a.499.499 0 0 0-.257-.95.5.5 0 0 0-.19.056L.776 11.7a.5.5 0 0 0 .448.894zm-.018 3.107a.5.5 0 0 1 .67-.223l.777.388.777-.388a.502.502 0 0 1 .736.408.5.5 0 0 1-.29.486l-1 .5a.5.5 0 0 1-.446 0l-1-.5a.5.5 0 0 1-.224-.67"
        ></path>
        <path
          id="Vector_4"
          fillRule="evenodd"
          d="M18 15.25c0-2.03-5.462-3.308-9.265-3.246C5.13 12.063 0 13.221 0 15.251V18h18zm-9.248-2.246c1.507-.025 3.3.175 4.86.552l-1.034 3.445H1v-1.75c0-.044.024-.237.45-.55.413-.303 1.05-.6 1.868-.86 1.625-.516 3.71-.809 5.434-.837m5.823.818-.953 3.179H17v-1.75c0-.021-.016-.22-.49-.556-.437-.309-1.099-.61-1.935-.873"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export const ExplosionsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20"
    >
      <g id="Icons">
        <path
          id="Vector"
          stroke="currentColor"
          strokeWidth="1.5"
          d="M10.082 7.163 5.637 2.5l1.961 5.772-3.203-.294 1.961 2.446L2.5 13.652l5.294-.75-.196 4.109 2.484-3.62L13.84 17.5l-.85-5.054 4.51-.424-4.02-1.892 3.432-2.967-4.51.815V4z"
        ></path>
      </g>
    </svg>
  );
};

export const OpticsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      fill="none"
      viewBox="0 0 26 26">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1m0 24C6.373 25 1 19.627 1 13S6.373 1 13 1m0 24L8.412 12.162M13 1l4.587 12.838M2.613 7l13.4 2.45M2.612 19l8.825-10.387M23.387 19l-13.4-2.45M23.388 7l-8.826 10.387"></path>
    </svg>
  );
};

export const FreeGiftIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.25 10v5.624a.625.625 0 01-.625.625H4.375a.625.625 0 01-.625-.625V10M10 6.25v10m0-10s2.648 0 3.54-.882a1.878 1.878 0 00-2.657-2.657C10 3.6 10 6.25 10 6.25zm0 0s-2.649 0-3.54-.882A1.878 1.878 0 119.118 2.71C10 3.6 10 6.25 10 6.25zm-6.875 0h13.75c.345 0 .625.28.625.625v2.5c0 .346-.28.625-.625.625H3.125a.625.625 0 01-.625-.625v-2.5c0-.345.28-.625.625-.625z"></path>
    </svg>
  );
};
export const FreeGiftIconLarge: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        stroke="#24C1FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M26 16v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-9m10-6v16m0-16s4.238 0 5.663-1.413a3.005 3.005 0 1 0-4.25-4.25C16 5.762 16 10 16 10m0 0s-4.238 0-5.663-1.413a3.005 3.005 0 0 1 4.25-4.25C16 5.762 16 10 16 10M5 10h22a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"
      ></path>
    </svg>
  );
};

export const VehicleIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <g clipPath="url(#clip0_9193_50196)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.833 10V4.165m0 5.833H4.166m11.667 0c.92 0 1.666.746 1.666 1.667v1.667c0 .92-.746 1.666-1.666 1.666H4.166c-.92 0-1.667-.746-1.667-1.666v-1.667c0-.92.747-1.667 1.667-1.667m0 0V4.166m11.667 0a2.5 2.5 0 00-2.5-2.5H6.666a2.5 2.5 0 00-2.5 2.5m11.667 0h.833c.92 0 1.667.746 1.667 1.667v.833m-2.5-2.5H4.166m0 0h-.833c-.92 0-1.667.746-1.667 1.667v.833m8.333-2.5v5.833m-4.166 8.334h1.666c.46 0 .834-.373.834-.834v-1.666a.833.833 0 00-.834-.834H5.833a.833.833 0 00-.834.834v1.666c0 .46.373.834.834.834zm6.666 0h1.667c.46 0 .833-.373.833-.834v-1.666a.833.833 0 00-.833-.834h-1.667a.833.833 0 00-.833.834v1.666c0 .46.373.834.833.834z"></path>
      </g>
      <defs>
        <clipPath id="clip0_9193_50196">
          <path fill="#fff" d="M0 0H20V20H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const WeaponIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.313 11.313L25 18s-9 12-22 9L24.738 4.738a2.492 2.492 0 113.524 3.525l-6.287 6.712"></path>
    </svg>
  );
};

export const LinkIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="none" viewBox="0 0 16 18">
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 6.902V2.707m0 0h-4m4 0l-7.333 7.691M8 4.105H6a4 4 0 00-4 4v3.188a4 4 0 004 4h2.667a4 4 0 004-4V9"></path>
    </svg>
  );
};

export const AccountSmall: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      fill="none"
      stroke="none"
      viewBox="0 0 11 11">
      <path
        fill="#7F898D"
        d="M.944 8.688a.5.5 0 00.866.5l-.866-.5zm7.578.5a.5.5 0 00.866-.5l-.866.5zM7.166 4.25a2 2 0 01-2 2v1a3 3 0 003-3h-1zm-2 2a2 2 0 01-2-2h-1a3 3 0 003 3v-1zm-2-2a2 2 0 012-2v-1a3 3 0 00-3 3h1zm2-2a2 2 0 012 2h1a3 3 0 00-3-3v1zM1.81 9.187c.34-.589.83-1.078 1.418-1.418l-.5-.866A4.875 4.875 0 00.944 8.688l.866.5zM3.228 7.77c.59-.34 1.258-.52 1.938-.52v-1c-.856 0-1.697.226-2.438.654l.5.866zm1.938-.52c.68 0 1.349.18 1.938.52l.5-.866a4.875 4.875 0 00-2.438-.653v1zm1.938.52c.589.34 1.078.83 1.418 1.418l.866-.5a4.875 4.875 0 00-1.784-1.784l-.5.866z"></path>
    </svg>
  );
};

export const AVFXSmall: React.FC<IconProps> = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16">
      <path
        fill={props.fill || '#AEB6BA'}
        stroke="none"
        fillRule="evenodd"
        d="M.5 8l2.782 1.25 7.196-4.219-.011 7.454 2.802 1.26L13.29.5.5 8zM27.056 8.002L24.273 6.75l-7.195 4.221.011-7.453-2.802-1.261-.021 13.245 12.79-7.499z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const EyeIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32">
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16 7C6 7 2 16 2 16s4 9 14 9 14-9 14-9-4-9-14-9z"></path>
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16 21a5 5 0 100-10 5 5 0 000 10z"></path>
    </svg>
  );
};

// SOFTWARE ICONS

export const AfterEffects: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40">
      <g clipPath="url(#clip0_1928_53245)">
        <path
          fill="#00005B"
          d="M7.083 0h25.834C36.833 0 40 3.248 40 7.265v25.47C40 36.752 36.833 40 32.917 40H7.083C3.167 40 0 36.752 0 32.735V7.265C0 3.248 3.167 0 7.083 0z"></path>
        <path
          fill="#99F"
          d="M16.067 23.932h-6.2l-1.266 4.034a.293.293 0 01-.317.24H5.151c-.184 0-.234-.103-.184-.308l5.367-15.778c.05-.17.1-.325.167-.53.067-.359.1-.735.1-1.111-.017-.085.05-.17.133-.188h4.317c.117 0 .2.051.216.137l6.084 17.436c.05.188 0 .273-.167.273h-3.483c-.117.017-.233-.068-.267-.188l-1.367-4.102v.085zm-5.233-3.402h4.234c-.1-.359-.234-.786-.384-1.23-.15-.462-.3-.958-.45-1.47-.166-.53-.316-1.043-.483-1.573a37.564 37.564 0 01-.45-1.522c-.133-.478-.25-.923-.367-1.333h-.033c-.15.735-.333 1.47-.567 2.205-.25.82-.5 1.675-.766 2.53a27.112 27.112 0 01-.734 2.393zM31.167 22.394h-5.283c.067.53.233 1.06.517 1.522.3.461.716.82 1.216 1.025.667.29 1.4.445 2.133.428a9.79 9.79 0 001.734-.188 6.137 6.137 0 001.483-.394c.084-.068.133-.034.133.137v2.616a.877.877 0 01-.033.205.395.395 0 01-.117.12c-.533.239-1.083.41-1.666.512-.784.154-1.567.222-2.367.205-1.267 0-2.333-.205-3.2-.598a5.628 5.628 0 01-2.1-1.624 6.328 6.328 0 01-1.15-2.24 8.933 8.933 0 01-.35-2.495c0-.923.133-1.83.417-2.718a7.029 7.029 0 011.25-2.342 6.066 6.066 0 012.017-1.624c.783-.393 1.716-.53 2.783-.53a5.892 5.892 0 012.583.53c.683.308 1.283.77 1.75 1.368.433.581.783 1.23 1 1.948a6.88 6.88 0 01.317 2.086c0 .41-.017.77-.034 1.094-.033.325-.05.564-.066.718-.017.12-.117.222-.233.222-.1 0-.284.017-.55.034a7.69 7.69 0 01-.967.052c-.383 0-.784-.069-1.217-.069zM25.884 19.9H29.4c.433 0 .75 0 .95-.018a.803.803 0 00.383-.136v-.171a2.01 2.01 0 00-.1-.633c-.3-.957-1.183-1.607-2.167-1.572a2.337 2.337 0 00-2.216 1.299 3.61 3.61 0 00-.367 1.23z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1928_53245">
          <path fill="#fff" d="M0 0H40V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const Nuke: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40">
      <g fill="#FDC842" clipPath="url(#clip0_1928_53246)">
        <path d="M57.226 10.978v11.901l-8.115-12.153a1.217 1.217 0 00-1.07-.612H46.25c-.686 0-1.239.552-1.239 1.236l.096 17.672c0 .468.385.864.866.864h2.092a.869.869 0 00.866-.864l-.036-12.13 8.283 12.478c.204.336.565.54.95.54h1.803c.613 0 1.118-.504 1.118-1.116V10.978a.869.869 0 00-.865-.864h-2.092a.861.861 0 00-.866.864zm19.62-.864a.753.753 0 00-.757.756v11.566c0 1.535-.445 2.375-1.022 3.07-.577.697-1.455 1.213-3.066 1.213-1.587 0-2.476-.576-3.065-1.272-.577-.696-.986-1.488-.986-3.011V10.87a.753.753 0 00-.758-.756h-2.38a.753.753 0 00-.757.756v11.685c0 2.424.649 4.272 1.947 5.567 1.299 1.284 3.138 2.364 6.096 2.364 2.86 0 4.64-1.056 5.939-2.352 1.286-1.295 1.935-3.143 1.935-5.555V10.87a.753.753 0 00-.757-.755h-2.369zM98.138 28.23l-6.769-9.814 5.843-6.346c.65-.732.264-1.956-.457-1.968l-1.971-.024c-.361 0-.65.276-.746.372l-7.105 7.618v-7.282a.805.805 0 00-.806-.804h-2.26a.805.805 0 00-.805.804v18.44c0 .444.36.804.805.804h2.26c.445 0 .806-.36.806-.804v-6.263l1.863-1.847 5.903 8.542a.696.696 0 00.59.324h1.659c.925.012 1.695-.984 1.19-1.752zm15.136-1.38v2.352a.634.634 0 01-.649.624H101.42c-.589 0-1.058-.456-1.058-1.02V11.182c0-.564.469-1.02 1.058-1.02h11.205c.36 0 .649.276.649.624v2.171a.634.634 0 01-.649.624h-8.608v4.355h6.54c.36 0 .649.276.649.624v2.112a.634.634 0 01-.649.624h-6.54v4.93h8.608c.36 0 .649.277.649.625zM20.041 40C8.993 40 0 31.026 0 20S8.993 0 20.041 0C31.09 0 40.082 8.974 40.082 20s-8.992 20-20.04 20zm0-37.84C10.183 2.16 2.164 10.162 2.164 20s8.019 17.84 17.877 17.84c9.858 0 17.877-8.002 17.877-17.84S29.9 2.16 20.041 2.16z"></path>
        <path d="M18.287 16.616l5.217 5.614c.217.216.349.504.349.804l-.469 11.134c-.012.876.565 1.572 1.395 1.284 4.929-1.716 7.946-4.427 9.437-7.967.216-.504.156-1.08-.216-1.475l-4.545-4.835a1.925 1.925 0 01-.54-1.344l-.037-2.688a1.25 1.25 0 011.262-1.247l3.643.048c1.72 0 1.864-.636 1.611-1.332-1.695-4.703-4.76-8.026-9.425-9.778a.83.83 0 00-1.13.732l-.3 4.739a.952.952 0 01-.95.912l-2.55-.012c-.673 0-1.25-.324-1.526-.6l-5.158-5.147c-.312-.3-.77-.396-1.166-.216-4.136 1.883-6.973 4.93-8.632 9.238-.252.672.289 1.38 1.01 1.38l11.096.072c.602.024 1.19.264 1.623.684zm3.642-2.964c.71-.684 2.405-.348 3.547.828 1.13 1.176 1.815 2.843.745 3.731-.757.624-2.008.396-3.246-.672-1.382-1.175-1.851-3.107-1.046-3.887z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1928_53246">
          <path fill="#fff" d="M0 0H40V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const Resolve: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40">
      <g clipPath="url(#clip0_1928_53247)">
        <path fill="#000" d="M18.566 23.3l6.907-8.232-1.423-1.193-6.907 8.231 1.423 1.194z"></path>
        <path
          fill="#383838"
          d="M20.612 40h-1.186a.475.475 0 00-.166-.025 21.556 21.556 0 01-1.885-.166 19.469 19.469 0 01-3.426-.763 20.098 20.098 0 01-5.351-2.637 19.86 19.86 0 01-4.07-3.768 19.687 19.687 0 01-3.247-5.63 19.604 19.604 0 01-1.226-5.677c0-.105-.02-.21-.055-.316v-2.065a.91.91 0 00.055-.281 19.73 19.73 0 012.12-7.746 19.953 19.953 0 012.563-3.854 20.06 20.06 0 013.346-3.144 19.835 19.835 0 016.653-3.24 19.853 19.853 0 013.592-.633c.216-.02.442 0 .658-.055h2.03c.156.045.317.02.472.035.805.07 1.604.171 2.397.327a19.765 19.765 0 016.954 2.807 19.976 19.976 0 014.412 3.863 19.647 19.647 0 012.618 3.933 19.581 19.581 0 011.789 5.269c.18.974.316 1.959.321 2.954 0 .066.015.136.02.2v1.186c-.02.075-.02.156-.025.236 0 .19 0 .382-.015.573a20.885 20.885 0 01-.583 3.601 19.816 19.816 0 01-2.8 6.194 19.977 19.977 0 01-3.366 3.823 20.005 20.005 0 01-4.206 2.843 19.874 19.874 0 01-7.778 2.094c-.198.023-.41.018-.616.062z"></path>
        <path
          style={{ mixBlendMode: 'lighten' }}
          fill="url(#paint0_radial_1928_53247)"
          d="M14.799 11.703c-.014.367.051.769.16 1.17.206.765.547 1.466.95 2.128.919 1.504 2.076 2.793 3.332 3.989.103.098.226.181.357.244a.44.44 0 00.398.01c.13-.058.248-.142.347-.25.436-.45.866-.902 1.279-1.368a22.173 22.173 0 001.636-2.072c.454-.662.862-1.358 1.162-2.113.3-.75.445-1.524.346-2.337-.164-1.342-.712-2.48-1.691-3.372-1.159-1.052-2.508-1.474-4.026-1.24-2.47.384-4.26 2.657-4.25 5.21z"></path>
        <path
          fill="url(#paint1_radial_1928_53247)"
          d="M27.578 29.999c-.31.009-.66-.03-1.009-.104-1.032-.226-1.909-.695-2.582-1.527a9.486 9.486 0 01-1.052-1.636c-.349-.681-.64-1.391-.895-2.11-.31-.87-.575-1.758-.778-2.655-.113-.503.014-.819.57-.992.707-.22 1.42-.418 2.145-.578 1.202-.263 2.413-.432 3.648-.39.35.013.697.05 1.042.112 1 .174 1.847.635 2.54 1.363 1.183 1.24 1.654 2.721 1.362 4.409-.42 2.411-2.56 4.127-4.99 4.108z"></path>
        <path
          fill="url(#paint2_radial_1928_53247)"
          d="M12.015 29.999c.31.009.66-.03 1.008-.104 1.033-.226 1.91-.695 2.583-1.527a9.474 9.474 0 001.051-1.636c.35-.681.641-1.391.895-2.11.311-.87.575-1.758.778-2.655.113-.503-.014-.819-.57-.992a25.845 25.845 0 00-2.144-.578c-1.202-.263-2.413-.432-3.648-.39a7.745 7.745 0 00-1.042.112c-1 .174-1.848.635-2.54 1.363-1.184 1.24-1.654 2.721-1.362 4.409.419 2.411 2.559 4.127 4.99 4.108z"></path>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1928_53247"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(5.29235 .4465 -.82537 9.78291 19.894 18.62)"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#009BD8"></stop>
        </radialGradient>
        <radialGradient
          id="paint1_radial_1928_53247"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(21.776 -45.661 66.145) scale(11.7122 6.25871)"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#FF3044"></stop>
        </radialGradient>
        <radialGradient
          id="paint2_radial_1928_53247"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(146.321 5.912 13.38) scale(11.836 5.38007)"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#FCFF7C"></stop>
        </radialGradient>
        <clipPath id="clip0_1928_53247">
          <path fill="#fff" d="M0 0H40V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const Fusion: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40">
      <g clipPath="url(#clip0_1928_53248)">
        <path
          fill="#1E9ADA"
          fillRule="evenodd"
          d="M20 0C30.97 0 40 9.028 40 20c0 10.971-9.029 20-20 20C9.028 40 0 30.97 0 20 0 9.028 9.028 0 20 0z"
          clipRule="evenodd"></path>
        <path
          fill="#FEFEFE"
          d="M15.537 11.17c-4.961 7.608-8.008 18.174-9.196 21.763-.669-6.775 2.86-15.997 5.444-21.448-1.189.055-7.525.501-11.035 4.129 0 0 1.895-5.823 12.838-7.59l.037-.075c8.564-12.52 14.992-5.042 14.992-5.042-3.903-.651-7.301 1.302-10.2 4.483 1.412-.055 10.553-.167 13.184 7.068 0 0-5.295-3.794-16.07-3.296l.006.008zm6.19 8.723h-.008c-2.184 0-3.981 1.797-3.981 3.981s1.797 3.981 3.98 3.981c2.184 0 3.982-1.797 3.982-3.98v-.01c0-2.179-1.793-3.972-3.972-3.972z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1928_53248">
          <path fill="#fff" d="M0 0H40V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const Mocha: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="40"
      fill="none"
      viewBox="0 0 35 40">
      <g clipPath="url(#clip0_1928_53249)">
        <path
          fill="#000"
          d="M.009 19.988c0-3.186.004-6.372-.009-9.558 0-.334.086-.532.394-.707 5.532-3.19 11.055-6.39 16.57-9.597.304-.176.514-.159.806.013 5.505 3.199 11.015 6.389 16.534 9.57.317.18.42.378.416.738-.013 6.372-.013 12.748 0 19.12 0 .335-.09.532-.395.708a6394.2 6394.2 0 00-16.568 9.592c-.275.159-.476.184-.768.013A4881.96 4881.96 0 00.416 30.288C.099 30.103 0 29.906 0 29.55c.017-3.186.009-6.376.009-9.562zm33.836.017c0-3.044-.004-6.089.005-9.133 0-.288-.069-.46-.335-.614a7205.872 7205.872 0 01-15.831-9.167c-.245-.142-.42-.133-.66.008a7227.473 7227.473 0 01-15.828 9.164c-.244.141-.326.296-.326.574.009 6.102.009 12.204 0 18.306 0 .304.108.459.356.6 5.257 3.036 10.51 6.076 15.755 9.125.287.167.488.159.771-.004a5782.795 5782.795 0 0115.72-9.104c.288-.167.386-.347.382-.673-.013-3.023-.009-6.055-.009-9.082z"></path>
        <path
          fill="#fff"
          d="M33.846 20.005c0 3.031-.004 6.059.009 9.09 0 .33-.094.51-.382.673a5151.226 5151.226 0 00-15.72 9.1c-.283.163-.484.171-.771.004a7136.584 7136.584 0 00-15.759-9.125c-.249-.146-.356-.3-.356-.6.009-6.102.009-12.204 0-18.306 0-.279.082-.433.326-.574A9503.381 9503.381 0 0017.03 1.099c.24-.142.411-.15.66-.009a7261.955 7261.955 0 0015.831 9.168c.266.154.335.33.335.613-.009 3.045-.009 6.09-.009 9.134z"></path>
        <path
          fill="#D96629"
          d="M17.413 37.07c-.004-4.271-.013-8.542 0-12.813.004-1.269.021-2.547.154-3.808.039-.364.438-.797.79-1.003 2.838-1.668 5.703-3.289 8.558-4.931 1.745-1.004 3.49-2.011 5.236-3.019.013 2.757.03 5.51.038 8.267.01 2.8.005 5.6-.008 8.4 0 .18-.094.447-.232.524-4.785 2.791-9.583 5.566-14.377 8.34-.043.03-.103.03-.159.043z"></path>
        <path
          fill="#4E2111"
          d="M17.413 37.07c-4.859-2.801-9.717-5.601-14.567-8.414-.107-.064-.18-.279-.18-.42-.008-5.476-.008-10.948.004-16.423 0-.176.15-.43.305-.52A4196.33 4196.33 0 0117.13 3.092c.133-.077.373-.12.488-.056 4.816 2.77 9.618 5.553 14.425 8.336.047.026.073.082.107.124-1.745 1.008-3.49 2.016-5.235 3.02-2.856 1.637-5.72 3.258-8.56 4.93-.35.206-.068 1.06-.106 1.424-.133 1.26-.832 2.118-.836 3.387-.013 4.271 0 8.542 0 12.813z"></path>
        <path
          fill="#fff"
          d="M12.675 12.98c.472 0 .943-.004 1.415 0 .472.009.579.077.729.51.776 2.282 1.548 4.567 2.32 6.853.077.231.158.459.24.686.013.038.043.073.06.107.026-.034.06-.064.073-.103.073-.202.146-.403.214-.605.776-2.298 1.548-4.596 2.329-6.895.175-.514.244-.553.771-.557a291.93 291.93 0 012.745 0c.377 0 .399.038.433.416.107 1.308.223 2.616.326 3.923.098 1.222.18 2.449.279 3.67.098 1.223.21 2.445.313 3.667.06.712.115 1.424.18 2.131.021.228-.095.322-.296.322-.914 0-1.831.004-2.745-.017-.334-.009-.403-.09-.433-.46-.047-.51-.068-1.024-.098-1.538-.065-1.038-.138-2.08-.185-3.118-.043-1.012-.06-2.024-.085-3.04 0-.056.008-.116-.005-.172-.013-.047-.051-.081-.081-.124-.03.026-.077.043-.095.077a6.33 6.33 0 00-.163.395c-.604 1.71-1.204 3.417-1.809 5.128-.18.51-.266.562-.815.566h-1.8c-.455-.004-.498-.021-.657-.454a564.76 564.76 0 01-1.71-4.751c-.095-.27-.198-.536-.3-.802-.022-.056-.074-.099-.112-.146-.009.056-.022.111-.026.167-.026.73-.03 1.458-.073 2.183-.064 1.11-.159 2.221-.236 3.332-.043.639-.073 1.282-.111 1.925l-.026.429c-.017.274-.154.407-.437.407-.644 0-1.287.009-1.93.013-.27 0-.545 0-.815-.004-.214-.005-.3-.108-.278-.326.132-1.505.261-3.01.385-4.52.1-1.21.18-2.418.28-3.627.098-1.223.21-2.445.312-3.667.043-.51.082-1.025.112-1.535.025-.437.017-.437.471-.442.446-.004.888-.004 1.334-.004z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1928_53249">
          <path fill="#fff" d="M0 0H34.72V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const HitFilm: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="40"
      fill="none"
      viewBox="0 0 46 40">
      <g clipPath="url(#clip0_1928_53250)">
        <path fill="#285BBF" d="M22.857 40L45.714 0H0l22.857 40z"></path>
        <path
          fill="#1B3DAA"
          d="M39.152 3.81L22.857 32.324 6.562 3.81h32.59zM45.714 0H0l22.857 40L45.714 0z"></path>
        <path
          fill="#1B3DAA"
          d="M22.856 7.676l4.867 8.514H17.99l4.866-8.514zm0-7.676L11.428 20h22.857L22.856 0z"></path>
        <path
          fill="#5BCDFF"
          d="M42.429 1.905L22.857 36.162 3.286 1.905h39.143zM45.714 0H0l22.857 40L45.714 0z"></path>
        <path
          fill="#2AFFFF"
          d="M22.856 3.838L31 18.095H14.713l8.143-14.257zm0-3.838L11.428 20h22.857L22.856 0z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1928_53250">
          <path fill="#fff" d="M0 0H45.714V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const UnrealEngine: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40">
      <g fill="#F5F5F5" clipPath="url(#clip0_1928_54068)">
        <path d="M20 .95C30.513.95 39.05 9.507 39.05 20c0 10.494-8.556 19.05-19.05 19.05C9.506 39.05.95 30.512.95 20S9.507.95 20 .95zM20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.065 0 20 0z"></path>
        <path d="M18.612 8.023s-4.506 1.274-8.555 5.57c-4.05 4.297-4.563 7.358-4.563 9.64.894-1.521 6.407-9.905 7.7-5.913v9.544s-.076 1.293-2.054.78c.59 1.102 3.632 3.82 9.126 4.372 1.255-1.255 2.89-3.061 2.89-3.061l2.737 2.32s4.924-3.194 6.864-7.833c-1.806 1.178-3.993 3.916-5.133 1.996V13.822s2.927-4.392 3.384-4.6c-1.16.208-5.248 1.558-7.396 4.334-.608-.666-2.3-.685-2.3-.685s1.33 1.103 1.35 2.11c.018 1.008 0 9.411 0 10.38-.913.932-1.883 1.427-2.51 1.427-1.464 0-1.882-.514-2.281-1.027V13.556s-.723.608-1.293-.38c-.57-.99-.59-2.91 2.034-5.153z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1928_54068">
          <path fill="#fff" d="M0 0H40V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

// HEARTS

export const DefaultHeart: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28">
      <path
        stroke="#7F898D"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.623 23.177l8.86-8.86c2.176-2.187 2.494-5.764.437-8.05a5.688 5.688 0 00-8.258-.23L14 7.711l-1.433-1.444c-2.187-2.176-5.764-2.494-8.05-.437a5.688 5.688 0 00-.23 8.257l9.09 9.09a.886.886 0 001.246 0v0z"></path>
    </svg>
  );
};

export const HoverHeart: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28">
      <path
        fill="#00A1E0"
        d="M24.566 5.676A6.507 6.507 0 0019.863 3.5a6.617 6.617 0 00-4.813 1.925L14 6.464l-.82-.81c-2.549-2.559-6.705-2.778-9.253-.47a6.552 6.552 0 00-.252 9.516l9.09 9.089a1.738 1.738 0 002.471 0l8.86-8.86c2.559-2.548 2.767-6.704.47-9.253z"
        opacity="0.8"></path>
    </svg>
  );
};

export const ActiveHeart: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28">
      <path
        fill="#00A1E0"
        d="M24.566 5.676A6.507 6.507 0 0019.863 3.5a6.617 6.617 0 00-4.813 1.925L14 6.464l-.82-.81c-2.549-2.559-6.705-2.778-9.253-.47a6.552 6.552 0 00-.252 9.516l9.09 9.089a1.738 1.738 0 002.471 0l8.86-8.86c2.559-2.548 2.767-6.704.47-9.253z"></path>
    </svg>
  );
};
export const GreenCircleCheckmark: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path
        fill="#00DA5E"
        d="M9 0a9 9 0 109 9 9.018 9.018 0 00-9-9zm4.284 7.425l-5.072 4.846a.701.701 0 01-.484.19.665.665 0 01-.476-.19L4.716 9.848a.692.692 0 11.952-1.004l2.06 1.965 4.604-4.388a.692.692 0 01.952 1.004z"></path>
    </svg>
  );
};

export const TagIconThin: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none" viewBox="0 0 32 33">
      <path
        stroke="#AEB6BA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.337 3.737L5.25 5.75 3.237 15.837a1 1 0 00.275.9l13.05 13.05a.987.987 0 001.413 0l11.312-11.312a.987.987 0 000-1.413l-13.05-13.05a1 1 0 00-.9-.275v0z"></path>
      <path fill="#AEB6BA" d="M10.5 12.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>
    </svg>
  );
};
export const GroupIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="31" fill="none" viewBox="0 0 32 31">
      <g fill="#AEB6BA" clipPath="url(#clip0_6664_122878)">
        <path d="M24.024 23.532c0-1.39-.397-2.78-1.191-3.772-1.39-1.589-2.978-2.383-4.964-2.383h-3.574c-1.39 0-2.581.397-3.772 1.191-1.39.993-2.184 2.383-2.383 3.971-.199 1.787 0 3.773-.199 5.758.199 0 .596.199.795.199 2.382.596 4.566 1.191 6.949 1.191 1.39 0 2.978 0 4.368-.198 1.191-.199 2.383-.596 3.574-.993.199 0 .199-.199.199-.397.198-1.589.198-3.177.198-4.567z"></path>
        <path d="M11.119 16.98c.397-.2.596-.2.993-.398-1.192-1.19-1.787-2.382-1.787-3.97h-4.17c-.794 0-1.588.198-2.184.396C1.787 13.803 0 15.987 0 18.37v4.964c0 .199 0 .199.199.397 1.588.397 3.176.794 4.765.993.595 0 1.39.199 1.985.199V23.73c0-.595 0-1.191.199-1.787.596-2.382 1.985-3.97 3.97-4.963zM31.77 18.766c0-.794-.2-1.786-.596-2.58-1.192-2.383-2.979-3.575-5.56-3.575h-3.772c0 1.589-.596 2.979-1.787 3.971.198 0 .397.199.397.199.993.397 1.985.993 2.78 1.787 1.19 1.39 1.787 2.978 1.787 4.765v1.39c.992-.198 1.787-.198 2.78-.397 1.19-.199 2.58-.596 3.772-1.191.198 0 .198-.199.198-.398v-3.97zM16.084 17.178c2.58 0 4.765-2.184 4.566-4.766 0-2.58-2.184-4.566-4.566-4.566-2.582 0-4.766 1.985-4.766 4.566.199 2.582 2.184 4.766 4.766 4.766zM21.84 12.017c.596.198 1.192.397 1.986.397 2.581 0 4.765-2.184 4.566-4.765 0-2.581-2.184-4.567-4.566-4.567-2.581 0-4.765 1.986-4.765 4.567 1.588.794 2.58 2.382 2.78 4.368zM7.943 12.413c.794 0 1.787-.199 2.383-.596.198-1.588.992-2.978 2.184-3.772v-.199c0-2.581-2.184-4.567-4.567-4.567-2.581 0-4.765 1.986-4.765 4.567 0 2.383 2.184 4.567 4.765 4.567z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6664_122878">
          <path fill="#fff" d="M0 0H31.768V30H0z" transform="translate(0 .5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export const SupportIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none" viewBox="0 0 32 33">
      <g clipPath="url(#clip0_6664_122886)">
        <path
          fill="#AEB6BA"
          d="M28 22.978a7.186 7.186 0 01-1.59 4.505A7.204 7.204 0 0122.344 30l-.765-2.294a4.809 4.809 0 003.379-2.334H22a2.402 2.402 0 01-2.4-2.397v-4.793a2.395 2.395 0 012.4-2.397h3.526a9.584 9.584 0 00-3.176-5.99 9.609 9.609 0 00-12.7 0 9.584 9.584 0 00-3.176 5.99H10a2.402 2.402 0 012.4 2.397v4.793a2.395 2.395 0 01-2.4 2.397H6.4A2.402 2.402 0 014 22.975v-5.992C4 10.365 9.372 5 16 5s12 5.365 12 11.983v5.995zm-2.4-.003v-4.793H22v4.793h3.6zM6.4 18.182v4.793H10v-4.793H6.4z"></path>
      </g>
      <defs>
        <clipPath id="clip0_6664_122886">
          <path fill="#fff" d="M0 0H32V32H0z" transform="translate(0 .5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const TimerIconRound: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
      <rect width="40" height="40" fill="#252B2D" rx="20"></rect>
      <path
        stroke="#F5F5F5"
        strokeWidth="1.5"
        d="M19.22 22.976a1 1 0 011.56 0l1.92 2.4A1 1 0 0121.92 27h-3.84a1 1 0 01-.78-1.625l1.92-2.399z"></path>
      <path
        stroke="#F5F5F5"
        strokeWidth="1.5"
        d="M13.6 14.8c-1.483-1.978-.072-4.8 2.4-4.8h8c2.472 0 3.883 2.822 2.4 4.8l-2.55 3.4a3 3 0 000 3.6l2.55 3.4c1.483 1.978.072 4.8-2.4 4.8h-8c-2.472 0-3.883-2.822-2.4-4.8l2.55-3.4a3 3 0 000-3.6l-2.55-3.4z"></path>
    </svg>
  );
};

export const IndividualPlanIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">
      <path
        fill="#00A1E0"
        d="M43.067 35.015c0-2.99-.854-5.978-2.562-8.113-2.989-3.416-6.405-5.124-10.675-5.124h-7.686c-2.989 0-5.55.854-8.113 2.562-2.989 2.135-4.697 5.124-5.124 8.54-.427 3.843 0 8.113-.427 12.383.427 0 1.281.427 1.708.427 5.124 1.28 9.821 2.562 14.945 2.562 2.99 0 6.405 0 9.394-.428 2.562-.426 5.124-1.28 7.686-2.134.427 0 .427-.427.427-.854.427-3.416.427-6.832.427-9.821zM25.984 21.352c5.551 0 10.248-4.697 9.821-10.248 0-5.55-4.697-9.82-9.82-9.82-5.552 0-10.249 4.27-10.249 9.82.427 5.551 4.697 10.248 10.248 10.248z"></path>
    </svg>
  );
};

export const BusinessPlanIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
      <g clipPath="url(#clip0_12784_173084)">
        <path
          fill="#00A1E0"
          d="M49.003 44.333h4.666V49H2.336v-4.667h4.667v-35A2.333 2.333 0 019.336 7h23.333a2.333 2.333 0 012.334 2.333v35h4.666V21h7a2.333 2.333 0 012.334 2.333v21zM16.336 25.667v4.666h9.333v-4.666h-9.333zm0-9.334V21h9.333v-4.667h-9.333z"></path>
      </g>
      <defs>
        <clipPath id="clip0_12784_173084">
          <path fill="#fff" d="M0 0H56V56H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const IndustrialIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <g>
        <path
          fill="currentColor"
          d="M6.078 3.922c.135 0 .244-.11.244-.245 0-.894.668-.488 1.562-.488H9.13c.135 0 .244-.11.244-.244 0-.885.737-1.623 1.622-1.623h5.962a1.724 1.724 0 01-1.692 1.465l-4.27.402a.244.244 0 100 .488l4.27-.402c1.188 0 2.197-1.006 2.197-2.197a.244.244 0 00-.244-.244h-6.223c-1.04 0-1.977.827-2.096 1.867H7.884c-1.164 0-2.05-.187-2.05.976 0 .135.11.245.244.245z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.275"
          d="M3.334 17.876h1.417m0 0h7.083m-7.083 0V8.1c0-.794 0-1.19.154-1.494.136-.266.352-.483.619-.619.303-.154.7-.154 1.493-.154h2.55c.794 0 1.19 0 1.493.154.267.136.484.353.62.62.154.302.154.699.154 1.49v4.111m0 5.667h4.25m-4.25 0v-5.667m4.25 5.667h1.417m-1.417 0v-5.667c0-.66 0-.99-.108-1.25a1.417 1.417 0 00-.766-.767c-.26-.108-.591-.108-1.251-.108-.66 0-.99 0-1.25.108-.348.144-.623.42-.767.767-.108.26-.108.59-.108 1.25m-4.958-1.417h2.833M6.876 8.667h2.833"></path>
      </g>
    </svg>
  );
};

export const ClockIcon: React.FC<IconProps> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          id="Vector"
          d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
          stroke={props?.stroke || '#AEB6BA'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M8.16406 5.66699V9.83366H12.3307"
          stroke={props?.stroke || '#AEB6BA'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const CreditsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="22"
      fill="none"
      viewBox="0 0 31 22">
      <path
        stroke="#F5F5F5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21.5 5.5c0 2.485-4.477 4.5-10 4.5s-10-2.015-10-4.5m20 0c0-2.485-4.477-4.5-10-4.5s-10 2.015-10 4.5m20 0v5c0 2.488-4.475 4.5-10 4.5s-10-2.012-10-4.5v-5m6 4.125v5m14-7.537c4.563.425 8 2.237 8 4.412m0 0c0 2.488-4.475 4.5-10 4.5-2.45 0-4.7-.4-6.438-1.05M29.5 11.5v5c0 2.488-4.475 4.5-10 4.5s-10-2.012-10-4.5v-1.588m14 .713v5m-8-11v11"></path>
    </svg>
  );
};

export const Essentials: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="368"
      height="54"
      fill="none"
      viewBox="0 0 368 54">
      <g fillRule="evenodd" clipPath="url(#clip0_14130_193240)" clipRule="evenodd">
        <path fill="#00A1E0" d="M.063.971h367.444v52.377H.062V.97z"></path>
        <path
          fill="#F5F5F5"
          d="M60.17 20.162l.002 2.867c.056.59.514.968 1.093.992l19.26.024c1.271.024 2.263.915 2.221 2.28l.001 12.884c.041 1.365-.95 2.256-2.222 2.28l-29.455.007 2.178-4.189c1.092-1.945 2.583-2.118 5.44-2.098l16.85.002c.455-.113.789-.471.827-.981l-.003-2.917c-.055-.59-.514-.968-1.093-.992l-19.267-.007c-1.271-.024-2.263-.916-2.221-2.281v-12.92c-.042-1.365.95-2.257 2.22-2.281l26.748-.006-2.177 4.189c-1.093 1.944-2.583 2.139-5.44 2.118l-14.049.029c-.498.089-.873.46-.913 1zM302.322 35.209c5.049.002 15.982.004 18.896.007l-2.177 4.17c-1.092 1.936-2.583 2.129-5.439 2.109l-16.52-.006c-1.271-.024-2.263-.911-2.221-2.27V15.103c-.042-1.36.95-2.247 2.221-2.271l4.144-.007c.017 7.061.009 14.28.006 21.337.031.618.496 1.02 1.09 1.046zM235.057 12.847l-2.189 4.196c-1.098 1.947-2.597 2.142-5.469 2.122-2.28-.009-4.561-.015-6.842-.018-.574.04-1.024.43-1.064 1.027.008 6.353.003 12.694.003 19.03.041 1.368-.956 2.26-2.233 2.285l-4.168.007c-.016-6.901.022-13.773.028-20.694l.001-.53c0-.652-.464-1.108-1.12-1.127-4.194 0-8.389.003-12.582 0l2.189-4.196c1.098-1.947 2.597-2.142 5.469-2.122 9.324.037 18.652.011 27.977.02zM248.063 39.205c.042 1.367-.955 2.26-2.233 2.284l-4.168.007c-.019-8.8-.003-17.576-.003-26.379-.042-1.367.955-2.26 2.233-2.285l4.168-.007c.019 8.802.003 17.576.003 26.38zM271.461 24.466c-.213.01-.516-.035-1.025.799l-6.786 12.173c-1.284 2.45-3.144 4.117-5.56 4.056l-4.133.002 15.497-27.013c.286-.49.835-1.71 2.007-1.655 1.172-.055 1.72 1.165 2.007 1.655l15.497 27.013-4.133-.002c-2.416.061-4.277-1.607-5.56-4.056l-6.787-12.173c-.509-.834-.811-.789-1.024-.8zM165.344 41.495l4.167-.006c1.279-.025 2.276-.916 2.235-2.283v-13.92c.052-.647.564-.965 1.208-.479l16.058 15.84c.82.872 1.967.849 3.065.849h2.356c.008-7.8.046-21.344.029-28.67l-4.168.007c-1.278.025-2.274.916-2.233 2.283v13.966c-.073.62-.581.913-1.215.427l-15.641-15.377c-1.185-1.164-1.798-1.306-3.476-1.306h-2.355c-.009 7.8-.046 21.344-.03 28.67zM42.839 24.019l-2.19 4.195c-1.098 1.948-2.596 2.143-5.468 2.123-3.25-.003-4.311 0-7.56 0h-.579c-.57.017-1.026.374-1.106.936l.002 3.015c.079.486.44.816.91.898H48.33l-2.2 4.219c-1.099 1.947-2.597 2.11-5.47 2.09l-18.872-.002c-1.225-.023-2.19-.843-2.233-2.114 0-2.708-.015-5.416-.011-8.123-.087-.55-.536-.9-1.095-.922h-.589l-5.832-.003 2.19-4.197c.924-1.639 2.132-2.04 4.202-2.114l24.42-.001zM19.557 19.134l-.001-4.022c-.041-1.368.955-2.26 2.234-2.285h26.542l-2.201 4.219c-1.098 1.947-2.596 2.11-5.469 2.09l-21.105-.002zM97.24 20.162l.002 2.867c.055.59.514.968 1.093.992l19.26.024c1.271.024 2.262.915 2.221 2.28l.001 12.884c.042 1.365-.95 2.256-2.221 2.28l-29.455.007 2.177-4.189c1.092-1.945 2.583-2.118 5.44-2.098l16.849.002c.455-.113.789-.471.828-.981l-.003-2.917c-.055-.59-.514-.968-1.092-.992l-19.268-.007c-1.272-.024-2.263-.916-2.222-2.281v-12.92c-.04-1.365.95-2.257 2.222-2.281l26.746-.006-2.176 4.189c-1.093 1.944-2.583 2.139-5.44 2.118l-14.048.029c-.499.089-.874.46-.914 1zM154.838 24.017l-2.189 4.195c-1.097 1.948-2.597 2.143-5.468 2.123-3.249-.003-4.311 0-7.561 0h-.578c-.569.017-1.026.374-1.106.936l.001 3.015c.079.486.441.816.912.898h21.48l-2.201 4.219c-1.097 1.947-2.596 2.11-5.469 2.09l-18.872-.002c-1.225-.023-2.191-.843-2.234-2.114 0-2.708-.014-5.416-.01-8.123-.087-.55-.536-.9-1.095-.922h-.589l-5.832-.003 2.19-4.197c.924-1.639 2.132-2.04 4.201-2.114l24.42-.001zM131.56 19.134v-4.022c-.042-1.368.955-2.26 2.233-2.285h26.543l-2.201 4.219c-1.098 1.947-2.596 2.11-5.469 2.09l-21.106-.002zM332.962 20.162l.003 2.867c.055.59.514.968 1.092.992l19.261.024c1.271.024 2.262.915 2.221 2.28l.001 12.884c.041 1.365-.95 2.256-2.222 2.28l-29.455.007 2.178-4.189c1.092-1.945 2.583-2.118 5.439-2.098l16.85.002c.455-.113.789-.471.827-.981l-.002-2.917c-.056-.59-.515-.968-1.093-.992l-19.268-.007c-1.271-.024-2.262-.916-2.221-2.281v-12.92c-.041-1.365.95-2.257 2.221-2.281l26.747-.006-2.177 4.189c-1.092 1.944-2.582 2.139-5.439 2.118l-14.049.029c-.498.089-.873.46-.914 1z"></path>
      </g>
      <defs>
        <clipPath id="clip0_14130_193240">
          <rect width="368" height="53" y="0.5" fill="#fff" rx="5"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export const EIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
      cy-test-id="eicon"
    >
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M0 5a5 5 0 015-5h22a5 5 0 015 5v22a5 5 0 01-5 5H5a5 5 0 01-5-5V5z"
        clipRule="evenodd"></path>
      <path
        fill="#F5F5F5"
        fillRule="evenodd"
        d="M22.98 13.92l-1.341 2.574c-.674 1.195-1.592 1.314-3.352 1.302-1.991-.002-2.642 0-4.633 0h-.355c-.349.01-.629.23-.678.574l.002 1.85c.048.297.27.5.558.55h13.164l-1.35 2.588c-.672 1.194-1.59 1.294-3.35 1.282l-11.566-.001c-.751-.014-1.343-.518-1.369-1.297 0-1.66-.009-3.322-.007-4.982-.053-.337-.328-.552-.67-.566h-.361l-3.574-.002 1.342-2.574c.566-1.005 1.306-1.251 2.574-1.296l14.966-.001zM8.704 10.913V8.445c-.025-.838.585-1.386 1.369-1.401h16.266L24.99 9.632c-.673 1.194-1.59 1.293-3.351 1.281H8.704z"
        clipRule="evenodd"></path>
    </svg>
  );
};

export const EIconStraightRightCorners: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
      cy-test-id="eicon-straight-right"
    >
      <path
        fill="#00A1E0"
        fillRule="evenodd"
        d="M0 5a5 5 0 015-5h22a5 300 0 015 5v22a5 300 0 01-5 5H5a5 5 0 01-5-5V5z"
        clipRule="evenodd"></path>
      <path
        fill="#F5F5F5"
        fillRule="evenodd"
        d="M22.98 13.92l-1.341 2.574c-.674 1.195-1.592 1.314-3.352 1.302-1.991-.002-2.642 0-4.633 0h-.355c-.349.01-.629.23-.678.574l.002 1.85c.048.297.27.5.558.55h13.164l-1.35 2.588c-.672 1.194-1.59 1.294-3.35 1.282l-11.566-.001c-.751-.014-1.343-.518-1.369-1.297 0-1.66-.009-3.322-.007-4.982-.053-.337-.328-.552-.67-.566h-.361l-3.574-.002 1.342-2.574c.566-1.005 1.306-1.251 2.574-1.296l14.966-.001zM8.704 10.913V8.445c-.025-.838.585-1.386 1.369-1.401h16.266L24.99 9.632c-.673 1.194-1.59 1.293-3.351 1.281H8.704z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export const DashIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        fill="#AEB6BA"
        d="M17.188 9.063h-6.563-7.188c-.165 0-.324.098-.441.274a1.214 1.214 0 00-.183.663c0 .249.065.487.183.663.117.176.276.274.442.274h13.75c.165 0 .324-.098.441-.274.118-.176.183-.414.183-.663 0-.249-.065-.487-.183-.663-.117-.176-.276-.274-.442-.274z"></path>
    </svg>
  );
};

export const EnterpriseIconOutline: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      width="114"
      height="100"
      viewBox="0 0 114 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="69.8984" y="34" width="32" height="64" rx="3" stroke="#404D52" strokeWidth="4" />
      <rect x="11.8984" y="2" width="58" height="96" rx="3" stroke="#404D52" strokeWidth="4" />
      <rect x="28.5195" y="20.6895" width="25.1097" height="4.59766" rx="2.29883" fill="#404D52" />
      <rect x="28.5195" y="37.9297" width="25.1097" height="4.59766" rx="2.29883" fill="#404D52" />
      <rect y="95.4023" width="114" height="4.59766" rx="2.29883" fill="#404D52" />
    </svg>
  );
};

export const LicenseIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40">
      <g clipPath="url(#clip0_15536_59955)">
        <path
          fill="#F5F5F5"
          d="M29.017 8.333h-7.35V.983l7.35 7.35zm-10.684 3.334V0H5C2.233 0 0 2.233 0 5v31.667h16.667v-4.034l4.583-4.583-2.083-.567-2.417.65c-.633.134-1.25.2-1.75.2-1.75 0-3.483-.683-5-1.75-1.517 1.067-3.25 1.75-5 1.75V25c.85 0 1.7-.283 2.5-.75C5.967 22.417 5 20.217 5 18.333c0-2.75 2.25-5 5-5s5 2.25 5 5c0 1.9-.967 4.084-2.5 5.917.8.467 1.65.75 2.5.75.2 0 1.067-.05 1.95-.45a7.61 7.61 0 01-.283-2.05c0-1.383 1.133-2.5 2.5-2.5 1.366 0 2.5 1.117 2.5 2.5a7.61 7.61 0 01-.284 2.05c.884.417 1.75.45 1.95.45h.95L30 19.3v-7.633H18.333zm20.434 9.566a4.235 4.235 0 00-5.984 0L20 34.017V40h5.983l12.784-12.783a4.21 4.21 0 001.233-3c0-1.134-.433-2.2-1.233-2.984zm-30.434-2.9c0 1.05.65 2.467 1.667 3.734 1.017-1.267 1.667-2.684 1.667-3.734 0-.916-.75-1.666-1.667-1.666s-1.667.75-1.667 1.666z"></path>
      </g>
      <defs>
        <clipPath id="clip0_15536_59955">
          <path fill="#fff" d="M0 0H40V40H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const SmallLicenseIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.75 21H5.25a.75.75 0 01-.75-.75V3.75A.75.75 0 015.25 3h9l5.25 5.25v12a.75.75 0 01-.75.75z"></path>
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.125 16.875c1.818-1.818 2.727-3.273 2.727-4.364 0-1.636-.545-1.636-1.09-1.636-.546 0-1.109.592-1.092 1.636.019 1.118.905 2.66 1.364 3.273.818 1.091 1.364 1.364 1.91.545l1.09-1.636c.182 1.455.727 2.182 1.636 2.182.29 0 1.44-1.09 1.637-1.09.282 0 .827.363 1.636 1.09"></path>
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13.5 3.75V9h5.25"></path>
    </svg>
  );
};

export const SelectedCheck: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      cy-test-id="selected-check"
      viewBox="0 0 32 32">
      <path
        fill="#24C1FF"
        d="M16 4a12 12 0 1012 12A12.023 12.023 0 0016 4zm5.712 9.9l-6.762 6.461a.934.934 0 01-.646.254.887.887 0 01-.635-.253l-3.38-3.231a.922.922 0 111.269-1.339l2.746 2.62 6.138-5.85a.923.923 0 011.27 1.338z"></path>
    </svg>
  );
};

export const Warning: React.FC<IconProps> = (props) => {
  return (
    <svg
      data-testid="warning"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20">
      <path
        fill="#FF9D00"
        stroke="#FF9D00"
        strokeWidth="0.125"
        d="M18.437 14.718h0a1.804 1.804 0 01-1.563 2.72h0-13.75 0a1.805 1.805 0 01-1.563-2.72h0L8.428 2.843h0a1.812 1.812 0 013.142 0h0l6.867 11.875zm-8.924-7.08a.688.688 0 00-.201.487v3.125a.688.688 0 001.375 0V8.125a.688.688 0 00-1.174-.486zm-.07 7.256a1 1 0 101.112-1.663 1 1 0 00-1.111 1.663z"></path>
    </svg>
  );
};

export const EssentialsLogo: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="155"
      height="22"
      fill="none"
      viewBox="0 0 155 22"
      cy-test-id="essentials-logo"
    >
      <g
        fillRule="evenodd"
        clipPath="url(#clip0_16659_57940)"
        clipRule="evenodd"
      >
        <path fill="#00A1E0" d="M.027.196h154.766v21.741H.027V.198z"></path>
        <path
          fill="#F5F5F5"
          d="M25.344 8.16l.001 1.19c.024.245.217.402.46.412l8.113.01c.535.01.953.38.935.946l.001 5.348c.017.567-.4.937-.936.947l-12.406.003.917-1.74c.46-.806 1.088-.878 2.291-.87h7.097a.444.444 0 00.349-.407l-.002-1.21c-.023-.245-.216-.402-.46-.412l-8.115-.003c-.535-.01-.953-.38-.936-.947V6.064c-.017-.567.4-.937.936-.947l11.266-.002-.917 1.738c-.46.808-1.088.888-2.292.88l-5.917.012a.448.448 0 00-.385.415zM127.339 14.406c2.126 0 6.731.001 7.959.003l-.918 1.73c-.46.804-1.087.884-2.291.876l-6.958-.002c-.535-.01-.953-.379-.935-.943V6.06c-.018-.564.4-.932.935-.942l1.746-.003c.007 2.931.004 5.928.002 8.857.014.256.209.423.46.434zM99.006 5.124l-.923 1.741c-.462.809-1.093.89-2.303.88-.96-.003-1.921-.005-2.882-.006-.242.016-.431.178-.448.426.003 2.637.001 5.27.001 7.9.018.567-.402.938-.94.948l-1.756.003c-.007-2.865.01-5.717.012-8.59v-.22c0-.271-.195-.46-.471-.468h-5.3l.922-1.742c.463-.808 1.094-.89 2.304-.88 3.927.015 7.856.004 11.784.008zM104.486 16.064c.017.568-.403.939-.941.949l-1.756.003c-.008-3.654-.001-7.296-.001-10.95-.018-.568.402-.938.941-.948l1.755-.003c.008 3.653.002 7.295.002 10.95zM114.337 9.947c-.089.004-.217-.015-.431.331l-2.859 5.053c-.54 1.017-1.324 1.71-2.342 1.684h-1.74l6.527-11.212c.121-.204.352-.71.845-.687.494-.023.725.483.846.687l6.527 11.213-1.741-.001c-1.017.025-1.801-.667-2.342-1.684l-2.858-5.053c-.214-.346-.342-.327-.432-.331zM69.642 17.015l1.755-.002c.54-.01.959-.38.942-.948v-5.778c.022-.269.237-.4.508-.199l6.764 6.575c.346.362.829.353 1.291.353h.992c.004-3.238.02-8.86.013-11.901l-1.756.003c-.538.01-.958.38-.94.947v5.798c-.031.257-.245.379-.512.177l-6.588-6.383c-.5-.483-.757-.542-1.464-.542h-.992c-.004 3.237-.02 8.86-.013 11.9zM18.044 9.76l-.922 1.742c-.463.809-1.094.89-2.303.881H11.39c-.24.008-.433.156-.466.39v1.25a.45.45 0 00.384.373h9.048l-.927 1.752c-.463.808-1.094.875-2.304.867H9.177c-.516-.01-.923-.35-.94-.878 0-1.124-.007-2.248-.005-3.372-.037-.228-.226-.374-.461-.383h-.248l-2.457-.001.923-1.742c.389-.68.898-.847 1.77-.877l10.285-.001zM8.24 7.733l-.001-1.67c-.018-.567.402-.938.94-.948h11.18l-.927 1.751c-.462.809-1.093.876-2.303.868h-8.89zM40.958 8.16v1.19c.024.245.217.402.461.412l8.112.01c.536.01.953.38.936.946v5.348c.017.567-.4.937-.936.947l-12.406.003.917-1.74c.46-.806 1.088-.878 2.291-.87h7.097A.444.444 0 0047.78 14l-.001-1.21c-.024-.245-.217-.402-.46-.412l-8.116-.003c-.535-.01-.953-.38-.936-.947V6.064c-.017-.567.4-.937.936-.947l11.266-.002-.917 1.738c-.46.808-1.088.888-2.291.88l-5.918.012a.448.448 0 00-.384.415zM65.22 9.76l-.922 1.742c-.463.809-1.094.89-2.304.881h-3.428c-.24.008-.432.156-.466.39l.001 1.25a.45.45 0 00.384.373h9.047l-.927 1.752c-.462.808-1.093.875-2.303.867h-7.95c-.515-.01-.922-.35-.94-.878 0-1.124-.006-2.248-.004-3.372-.037-.228-.226-.374-.461-.383h-.248l-2.457-.001.922-1.742c.39-.68.898-.847 1.77-.877L65.22 9.76zM55.415 7.733v-1.67c-.018-.567.402-.938.94-.948h11.18l-.927 1.751c-.463.809-1.094.876-2.304.868h-8.89zM140.243 8.16l.001 1.19c.023.245.216.402.46.412l8.112.01c.536.01.953.38.936.946v5.348c.018.567-.4.937-.935.947l-12.407.003.917-1.74c.46-.806 1.088-.878 2.291-.87h7.097a.444.444 0 00.349-.407l-.001-1.21c-.024-.245-.217-.402-.46-.412l-8.116-.003c-.535-.01-.953-.38-.935-.947V6.064c-.018-.567.4-.937.935-.947l11.266-.002-.917 1.738c-.46.808-1.088.888-2.291.88l-5.917.012a.448.448 0 00-.385.415z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_16659_57940">
          <rect width="155" height="22" fill="#fff" rx="5"></rect>
        </clipPath>
      </defs>
    </svg>
  );
}

export const ListView: React.FC<IconProps> = ({ onClick, color }) => {
  return (
    <svg
      data-cy="list-view-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onClick={onClick}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9 6h11.25M9 12h11.25M9 18h7.5M3.75 6h1.5M3.75 12h1.5M3.75 18h1.5"
      ></path>
    </svg>
  );
}

export const GridView: React.FC<IconProps> = ({ onClick, color }) => {
  return (
    <svg
      data-cy="grid-view-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onClick={onClick}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.5 4.5h-6v6h6v-6zM19.5 4.5h-6v6h6v-6zM10.5 13.5h-6v6h6v-6zM19.5 13.5h-6v6h6v-6z"
      ></path>
    </svg>
  );
}

export const ConfirmationIcon: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="confirmation-icon"
    >
      <g id="Icon">
        <g id="37">
          <path id="Rectangle 39871" d="M0.5 10C0.5 4.47715 4.97715 0 10.5 0H54.5C60.0228 0 64.5 4.47715 64.5 10V54C64.5 59.5228 60.0228 64 54.5 64H10.5C4.97715 64 0.5 59.5228 0.5 54V10Z" fill="#00B74F" />
          <g id="Group">
            <path id="Vector" d="M43.665 14.6194L27.5962 30.6881L21.335 24.4269C20.115 23.2069 18.1363 23.2069 16.915 24.4269C15.695 25.6469 15.695 27.6256 16.915 28.8469L25.3862 37.3181C26.6062 38.5381 28.585 38.5381 29.8062 37.3181L48.0863 19.0381C49.3063 17.8181 49.3063 15.8394 48.0863 14.6181C46.8663 13.3981 44.8875 13.3981 43.6662 14.6181L43.665 14.6194Z" fill="#F5F5F5" />
            <path id="Vector_2" d="M20.0039 50.2969H45.0039C46.7298 50.2969 48.1289 48.8978 48.1289 47.1719C48.1289 45.446 46.7298 44.0469 45.0039 44.0469H20.0039C18.278 44.0469 16.8789 45.446 16.8789 47.1719C16.8789 48.8978 18.278 50.2969 20.0039 50.2969Z" fill="#F5F5F5" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export const ReceiptIcon: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="receipt-icon"
    >
      <g id="Receipt">
        <path id="Vector" d="M7.625 9.75H17.375M7.625 12.75H17.375M3.5 19.5V5.25C3.5 5.05109 3.57902 4.86032 3.71967 4.71967C3.86032 4.57902 4.05109 4.5 4.25 4.5H20.75C20.9489 4.5 21.1397 4.57902 21.2803 4.71967C21.421 4.86032 21.5 5.05109 21.5 5.25V19.5L18.5 18L15.5 19.5L12.5 18L9.5 19.5L6.5 18L3.5 19.5Z" stroke="#00A1E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

export const EnvelopeIcon: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="envelope-icon"
    >
      <g id="tabler-icon-mail">
        <path id="Vector" d="M3.5 7C3.5 6.46957 3.71071 5.96086 4.08579 5.58579C4.46086 5.21071 4.96957 5 5.5 5H19.5C20.0304 5 20.5391 5.21071 20.9142 5.58579C21.2893 5.96086 21.5 6.46957 21.5 7M3.5 7V17C3.5 17.5304 3.71071 18.0391 4.08579 18.4142C4.46086 18.7893 4.96957 19 5.5 19H19.5C20.0304 19 20.5391 18.7893 20.9142 18.4142C21.2893 18.0391 21.5 17.5304 21.5 17V7M3.5 7L12.5 13L21.5 7" stroke="#00A1E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

export const LicenseProfileIcon: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="license-profile-icon"
    >
      <g id="Icons" clipPath="url(#clip0_16847_125616)">
        <path id="Vector" d="M15.0083 4.16667H11.3333V0.491667L15.0083 4.16667ZM9.66667 5.83333V0H3C1.61667 0 0.5 1.11667 0.5 2.5V18.3333H8.83333V16.3167L11.125 14.025L10.0833 13.7417L8.875 14.0667C8.55833 14.1333 8.25 14.1667 8 14.1667C7.125 14.1667 6.25833 13.825 5.5 13.2917C4.74167 13.825 3.875 14.1667 3 14.1667V12.5C3.425 12.5 3.85 12.3583 4.25 12.125C3.48333 11.2083 3 10.1083 3 9.16667C3 7.79167 4.125 6.66667 5.5 6.66667C6.875 6.66667 8 7.79167 8 9.16667C8 10.1167 7.51667 11.2083 6.75 12.125C7.15 12.3583 7.575 12.5 8 12.5C8.1 12.5 8.53333 12.475 8.975 12.275C8.89167 11.975 8.83333 11.6333 8.83333 11.25C8.83333 10.5583 9.4 10 10.0833 10C10.7667 10 11.3333 10.5583 11.3333 11.25C11.3333 11.6333 11.275 11.975 11.1917 12.275C11.6333 12.4833 12.0667 12.5 12.1667 12.5H12.6417L15.5 9.65V5.83333H9.66667ZM19.8833 10.6167C19.0583 9.79167 17.7167 9.79167 16.8917 10.6167L10.5 17.0083V20H13.4917L19.8833 13.6083C20.2833 13.2083 20.5 12.675 20.5 12.1083C20.5 11.5417 20.2833 11.0083 19.8833 10.6167ZM4.66667 9.16667C4.66667 9.69167 4.99167 10.4 5.5 11.0333C6.00833 10.4 6.33333 9.69167 6.33333 9.16667C6.33333 8.70833 5.95833 8.33333 5.5 8.33333C5.04167 8.33333 4.66667 8.70833 4.66667 9.16667Z" fill="#00A1E0" />
      </g>
      <defs>
        <clipPath id="clip0_16847_125616">
          <rect width="20" height="20" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const LicenseIconTag: React.FC<IconProps> = (props) => {
  return (
    <svg
      data-testid='licensee-icon'
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      stroke="none"
      viewBox="0 0 12 12"
    >
      <g clipPath="url(#clip0_16810_50747)">
        <path
          fill="#AEB6BA"
          d="M8.705 2.5H6.5V.295L8.705 2.5zM5.5 3.5V0h-4C.67 0 0 .67 0 1.5V11h5V9.79l1.375-1.375-.625-.17-.725.195c-.19.04-.375.06-.525.06-.525 0-1.045-.205-1.5-.525-.455.32-.975.525-1.5.525v-1c.255 0 .51-.085.75-.225-.46-.55-.75-1.21-.75-1.775C1.5 4.675 2.175 4 3 4s1.5.675 1.5 1.5c0 .57-.29 1.225-.75 1.775.24.14.495.225.75.225.06 0 .32-.015.585-.135A2.284 2.284 0 015 6.75c0-.415.34-.75.75-.75s.75.335.75.75c0 .23-.035.435-.085.615.265.125.525.135.585.135h.285L9 5.79V3.5H5.5zm6.13 2.87a1.27 1.27 0 00-1.795 0L6 10.205V12h1.795l3.835-3.835c.24-.24.37-.56.37-.9 0-.34-.13-.66-.37-.895zM2.5 5.5c0 .315.195.74.5 1.12.305-.38.5-.805.5-1.12 0-.275-.225-.5-.5-.5s-.5.225-.5.5z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_16810_50747">
          <path fill="#fff" d="M0 0H12V12H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export const TeamMembersIcon: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="team-members-icon"
    >
      <g id="Icons">
        <path id="Vector" d="M12.375 6.25H19.875M12.375 10H19.875M14.25 13.75H19.875M1.90625 15C2.18163 13.9245 2.80713 12.9712 3.68414 12.2905C4.56115 11.6097 5.63979 11.2402 6.75 11.2402C7.86021 11.2402 8.93885 11.6097 9.81586 12.2905C10.6929 12.9712 11.3184 13.9245 11.5938 15M9.875 8.125C9.875 9.85089 8.47589 11.25 6.75 11.25C5.02411 11.25 3.625 9.85089 3.625 8.125C3.625 6.39911 5.02411 5 6.75 5C8.47589 5 9.875 6.39911 9.875 8.125Z" stroke="#00A1E0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

export const AssetsIcon2D: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="assets-icon-2d"
    >
      <g id="2d assets">
        <path id="Vector 1503" d="M4.66714 8.59096C0.354844 13.4023 3.26922 17.3835 6.72985 19.0607C6.94706 19.166 7.17623 18.7042 7.01393 18.5255C5.39064 16.7384 5.04646 13.5149 10.5212 9.60909C10.6643 9.50696 10.8988 9.63136 10.9181 9.80615C11.0179 10.7092 11.5646 12.3786 12.7185 13.4423C13.6971 14.3444 15.6068 16.4853 13.217 18.8049C13.0497 18.9672 13.2293 19.2949 13.4408 19.1968C20.0703 16.1237 18.1657 9.85255 16.0858 6.83938C16.0055 6.72298 15.8311 6.73056 15.749 6.84576C15.3783 7.36616 14.6567 8.22164 14.1559 8.7075C14.0347 8.82509 13.8503 8.72869 13.8505 8.55982C13.8538 5.27504 10.9107 3.22633 8.83281 1.72082C8.68595 1.61441 8.47382 1.74678 8.48676 1.92769C8.64292 4.10974 6.91871 6.07882 4.66714 8.59096Z" fill="#00A1E0" fillOpacity="0.2" stroke="#00A1E0" strokeWidth="1.5" />
      </g>
    </svg>
  );
}

export const AssetsIcon3D: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="assets-icon-3d"
    >
      <g id="3D Assets">
        <path id="Polygon 2" d="M9.875 1.22687C10.2618 1.00358 10.7382 1.00358 11.125 1.22687L17.7853 5.07217C18.172 5.29546 18.4103 5.70812 18.4103 6.1547V13.8453C18.4103 14.2919 18.172 14.7045 17.7853 14.9278L11.125 18.7731C10.7382 18.9964 10.2618 18.9964 9.875 18.7731L3.21475 14.9278C2.82799 14.7045 2.58975 14.2919 2.58975 13.8453V6.1547C2.58975 5.70812 2.82799 5.29546 3.21475 5.07217L9.875 1.22687Z" fill="#00A1E0" fillOpacity="0.2" stroke="#00A1E0" strokeWidth="1.5" />
        <path id="Vector 1495" d="M3 5.8335L10.5 9.5835L18 5.8335" stroke="#00A1E0" strokeWidth="1.5" />
        <path id="Vector 1493 (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M8.15633 11.6416L6.95495 12.3879L6.37151 11.2136L7.57289 10.4673L8.15633 11.6416ZM14.0451 12.3879L12.8437 11.6416L13.4271 10.4673L14.6285 11.2136L14.0451 12.3879ZM16.4478 13.8805L15.2465 13.1342L15.8299 11.9599L17.0313 12.7062L16.4478 13.8805ZM5.75357 13.1342L4.55219 13.8805L3.96875 12.7062L5.17013 11.9599L5.75357 13.1342Z" fill="#00A1E0" />
        <path id="Vector 1496" d="M10.5 9.5835V19.1668" stroke="#00A1E0" strokeWidth="1.5" />
        <path id="Vector 1494 (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M9.875 4.54845V3.229H11.125V4.54845H9.875ZM9.875 7.18734V5.86789H11.125V7.18734H9.875Z" fill="#00A1E0" />
      </g>
    </svg>
  );
}

export const AssetsIconPFL: React.FC<IconProps> = ({
  className,
}) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      cy-test-id="assets-icon-pfl"
    >
      <g id="Footage">
        <rect id="Rectangle 39758" x="2.08594" y="9.0835" width="12.25" height="9.33333" rx="1.25" fill="#00A1E0" fillOpacity="0.2" stroke="#00A1E0" strokeWidth="1.5" />
        <path id="Vector 2756" d="M11.3307 15.8335H4.66406" stroke="#00A1E0" strokeWidth="1.5" strokeLinecap="round" />
        <path id="Rectangle 39759" d="M15.2109 15.3987V12.1026L19.1702 9.8401C19.3369 9.74487 19.5443 9.86521 19.5443 10.0572V17.4441C19.5443 17.6361 19.3369 17.7564 19.1702 17.6612L15.2109 15.3987Z" fill="#00A1E0" fillOpacity="0.2" stroke="#00A1E0" strokeWidth="1.5" />
        <path id="Ellipse 35" d="M13.9167 4.16683C13.9167 5.59356 12.7601 6.75016 11.3333 6.75016C9.9066 6.75016 8.75 5.59356 8.75 4.16683C8.75 2.74009 9.9066 1.5835 11.3333 1.5835C12.7601 1.5835 13.9167 2.74009 13.9167 4.16683Z" fill="#00A1E0" fillOpacity="0.2" stroke="#00A1E0" strokeWidth="1.5" />
        <path id="Ellipse 36" d="M6.41927 4.58317C6.41927 5.77979 5.44922 6.74984 4.2526 6.74984C3.05599 6.74984 2.08594 5.77979 2.08594 4.58317C2.08594 3.38655 3.05599 2.4165 4.2526 2.4165C5.44922 2.4165 6.41927 3.38655 6.41927 4.58317Z" fill="#00A1E0" fillOpacity="0.2" stroke="#00A1E0" strokeWidth="1.5" />
      </g>
    </svg>
  );
}

export const UnlockIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        stroke="#24C1FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M23.615 13.23H8.846c-1.02 0-1.846.827-1.846 1.847v11.077C7 27.174 7.827 28 8.846 28h14.77c1.019 0 1.846-.827 1.846-1.846V15.077c0-1.02-.827-1.847-1.847-1.847z"
      ></path>
      <path
        stroke="#24C1FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20.791 5.902A6.351 6.351 0 0016.231 4a6.461 6.461 0 00-6.461 6.462v2.769M16.23 21.538a.923.923 0 100-1.847.923.923 0 000 1.847z"
      ></path>
    </svg>
  );
}

export const LargeWarningIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      fill="none"
      viewBox="0 0 64 64"
    >
      <path
        fill="#FF9D00"
        d="M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24z"
      ></path>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        d="M32 20v14"
      ></path>
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth="0.125"
        d="M34.938 43a2.938 2.938 0 11-5.876 0 2.938 2.938 0 015.875 0z"
      ></path>
    </svg>
  );
}

export const DashColorIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#A22A30"
        d="M17.188 9.063h-6.563-7.188c-.165 0-.324.098-.441.274a1.214 1.214 0 00-.183.663c0 .249.065.487.183.663.117.176.276.274.442.274h13.75c.165 0 .324-.098.441-.274.118-.176.183-.414.183-.663 0-.249-.065-.487-.183-.663-.117-.176-.276-.274-.442-.274z"
      ></path>
    </svg>
  );
}

export const ListIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9 6h11.25M9 12h11.25M9 18h7.5M3.75 6h1.5M3.75 12h1.5M3.75 18h1.5"></path>
    </svg>
  );
}
export const GridIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.5 4.5h-6v6h6v-6zM19.5 4.5h-6v6h6v-6zM10.5 13.5h-6v6h6v-6zM19.5 13.5h-6v6h6v-6z"></path>
    </svg>
  );
}

export const AVFXContributor: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className={props.className}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M3.75 9.375h3.125m0 0V7.5m0 1.875H10m0 0V7.5m0 1.875h3.125m0 0V7.5m0 1.875h3.125m-8.125 2.5h1.25m1.25 0h1.25m-1.25 1.875h1.25m-3.75 0h1.25m-5 3.125v-7.5h-1.25v-2.5L5 3.125h10l1.875 3.75v2.5h-1.25v7.5z"
      ></path>
    </svg>
  );
}
export const TouchIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g id="ph:hand-tap">
        <path
          id="Vector"
          fill="#fff"
          d="M3.5 4.75a3.75 3.75 0 0 1 7.5 0 .5.5 0 0 1-1 0 2.75 2.75 0 1 0-5.5 0 .5.5 0 1 1-1 0m8.75 2.75c-.292 0-.579.073-.835.212A1.75 1.75 0 0 0 9 6.669V4.75a1.75 1.75 0 1 0-3.5 0v5l-.239-.383a1.75 1.75 0 0 0-3.025 1.76l1.832 3.125a.5.5 0 1 0 .863-.502L3.1 10.625a.75.75 0 1 1 1.299-.75l.008.014 1.168 1.875A.5.5 0 0 0 6.5 11.5V4.75a.75.75 0 0 1 1.5 0V9a.5.5 0 1 0 1 0v-.75a.75.75 0 0 1 1.5 0V9.5a.5.5 0 0 0 1 0v-.25a.75.75 0 1 1 1.5 0v2.25c0 1.35-.444 2.269-.448 2.276a.5.5 0 0 0 .895.448c.024-.046.554-1.125.554-2.724V9.25A1.75 1.75 0 0 0 12.25 7.5"
        ></path>
      </g>
    </svg>
  );
}

export const ExternalLinkIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none" {...props}>
      <path d="M11.3763 5.7972L11.3763 2.38867M11.3763 2.38867L8.1263 2.38867M11.3763 2.38867L5.41797 8.63765" stroke="#00A1E0" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.5 3.52344H3.625C2.52043 3.52344 1.625 4.41887 1.625 5.52344V10.6129C1.625 11.7174 2.52043 12.6129 3.625 12.6129H8.29167C9.39624 12.6129 10.2917 11.7174 10.2917 10.6129V7.50006" stroke="#00A1E0" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export const CurrencyCircleDollarIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FFAC26"
        d="M12 2.25A9.75 9.75 0 1 0 21.75 12 9.77 9.77 0 0 0 12 2.25m1.125 14.25h-.375v.75a.75.75 0 1 1-1.5 0v-.75h-1.5a.75.75 0 1 1 0-1.5h3.375a1.125 1.125 0 1 0 0-2.25h-2.25a2.625 2.625 0 0 1 0-5.25h.375v-.75a.75.75 0 1 1 1.5 0v.75h1.5a.75.75 0 1 1 0 1.5h-3.375a1.125 1.125 0 0 0 0 2.25h2.25a2.625 2.625 0 0 1 0 5.25"
      ></path>
    </svg>
  );
};

export const SurveyCompleted: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#00DA5E"
        d="m11 13.59-1.295-1.295L9 13l2 2 4-4-.705-.705z"
      ></path>
      <path
        fill="#00DA5E"
        d="M12.5 2.5H11V2a1.003 1.003 0 0 0-1-1H6a1.003 1.003 0 0 0-1 1v.5H3.5a1.003 1.003 0 0 0-1 1V14a1.003 1.003 0 0 0 1 1H8v-1H3.5V3.5H5V5h6V3.5h1.5V9h1V3.5a1.003 1.003 0 0 0-1-1M10 4H6V2h4z"
      ></path>
    </svg>
  );
};

export const LicenseFileIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.75 21H5.25a.75.75 0 0 1-.75-.75V3.75A.75.75 0 0 1 5.25 3h9l5.25 5.25v12a.75.75 0 0 1-.75.75"
      ></path>
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7.125 16.875q2.727-2.727 2.727-4.364c0-1.636-.545-1.636-1.09-1.636-.546 0-1.109.592-1.092 1.636.019 1.118.905 2.66 1.364 3.273.818 1.091 1.364 1.364 1.91.545l1.09-1.636q.273 2.182 1.636 2.182c.29 0 1.44-1.09 1.637-1.09q.423 0 1.636 1.09"
      ></path>
      <path
        stroke="#00A1E0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13.5 3.75V9h5.25"
      ></path>
    </svg>
  );
};
